
(function () {
  var Main,
    el,
    bind = function (fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    },
    extend = function (child, parent) {
      for (var key in parent) {
        if (hasProp.call(parent, key)) child[key] = parent[key];
      }
      function ctor() {
        this.constructor = child;
      }
      ctor.prototype = parent.prototype;
      child.prototype = new ctor();
      child.__super__ = parent.prototype;
      return child;
    },
    hasProp = {}.hasOwnProperty;

  theme.classes.CoreBlog = (function () {
    function CoreBlog(root) {
      var _this;
      this.root = root;
      this.initMasonry = bind(this.initMasonry, this);
      this.eventListeners = bind(this.eventListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.list = _this.root.find(".blog--list");
      if (_this.root.data("columns") > 1) {
        _this.load();
      }
    }

    CoreBlog.prototype.load = function () {
      var _this;
      _this = this;
      return theme.utils.insertScript(theme.assets.masonry, function () {
        if (theme.utils.mqs.current_window !== "small") {
          _this.initMasonry();
        }
        return _this.eventListeners();
      });
    };

    CoreBlog.prototype.eventListeners = function () {
      var _this;
      _this = this;
      return window.addEventListener("theme:utils:mqs:updated", function () {
        var masonry_loaded;
        masonry_loaded = _this.list.data("masonry-loaded");
        if (!(theme.utils.mqs.current_window === "small" || masonry_loaded)) {
          return _this.initMasonry();
        } else if (
          theme.utils.mqs.current_window === "small" &&
          masonry_loaded
        ) {
          _this.list.attr("data-masonry-loaded", false);
          return _this.masonry.destroy();
        }
      });
    };

    CoreBlog.prototype.initMasonry = function () {
      var _this;
      _this = this;
      _this.list.attr("data-masonry-loaded", true);
      return (_this.masonry = new Masonry(_this.list.el[0], {
        itemSelector: ".blog--list--item",
        percentPosition: true,
        horizontalOrder: true,
        columnWidth: ".blog--list--item",
        gutter: 32,
      }));
    };

    return CoreBlog;
  })();

  theme.classes.CoreCarousel = (function () {
    function CoreCarousel(root) {
      var _this;
      this.root = root;
      this.toggleFocusableEl = bind(this.toggleFocusableEl, this);
      this.toggleDraggable = bind(this.toggleDraggable, this);
      this.getAllFocusableEl = bind(this.getAllFocusableEl, this);
      _this = this;
      _this.container = _this.root.find(".carousel--x-container");
      _this.dot_nav = _this.root.find(".carousel--dot-nav");
      _this.dot_nav_wrapper = _this.root.find(".carousel--dot-nav--wrapper");
      _this.dots = _this.root.find(".carousel--dot");
      _this.height_container = _this.root.find(".carousel--y-container");
      _this.links = _this.container.find("a");
      _this.next = _this.root.find(".carousel--next");
      _this.prev = _this.root.find(".carousel--prev");
      _this.at_end = _this.root.attr("data-at-end");
      _this.at_start = _this.root.attr("data-at-start");
      _this.auto_rotate = _this.root.data("auto-rotate");
      _this.blocks = _this.root.find(".carousel--block");
      _this.blocks_per_slide_desktop = _this.root.data("blocks-per-slide");
      _this.blocks_per_slide_mobile = _this.root.data(
        "blocks-per-slide--mobile",
      );
      _this.dot_nav_enabled = _this.root.attr("data-dot-nav");
      _this.rotate_frequency = _this.root.attr("data-rotate-frequency");
      _this.section_id = _this.root
        .closest("[data-section-id]")
        .data("section-id");
      _this.total_blocks = _this.blocks.length;
      _this.transition_type = _this.root.attr("data-transition-type");
      _this.view = _this.root.data("view");
      _this.active_slide = 1;
      _this.autoplay_focus_enabled = false;
      _this.slide_pause = false;
      _this.container_destination = "0px";
      _this.trailing_dot_index = 0;
      _this.leading_dot_index = 0;
      _this.dot_nav_offset = 0;
      _this.draggable = true;
      _this.active_blocks = null;
      _this.auto_slide_timer = null;
      _this.blocks_per_slide = null;
      _this.old_active_blocks = null;
      _this.screen_size_loaded = null;
      _this.slide_count = null;
      _this.swipe_state = null;
      _this.window_width = null;
      _this.dot_change_type = null;
      theme.carousels[_this.section_id] = this;
      _this.load();
    }

    CoreCarousel.prototype.load = function () {
      var _this;
      _this = this;
      _this.resizeListener();
      _this.initNewScreenSize();
      _this.getAllFocusableEl();
      _this.updateActive();
      _this.setSliderHeight();
      _this.mouseDownListener();
      _this.swipeListener();
      _this.arrowNavListeners();
      _this.blockListener();
      if (_this.transition_type === "slide") {
        _this.loadBlocks();
      }
      if (_this.auto_rotate) {
        _this.autoSlide();
        _this.stopAutoSlideWhenInteracting();
      }
      return _this.root.trigger("loaded");
    };

    CoreCarousel.prototype.initNewScreenSize = function () {
      var _this;
      _this = this;
      if (theme.utils.mqs.current_window === "small") {
        if (_this.screen_size_loaded === "small") {
          return;
        }
        _this.dot_nav.attr("data-loaded", "false");
        _this.screen_size_loaded = "small";
        _this.blocks_per_slide = _this.blocks_per_slide_mobile;
        _this.active_slide = Math.ceil(
          (_this.blocks_per_slide_desktop * (_this.active_slide - 1) + 1) /
            _this.blocks_per_slide_mobile,
        );
      } else {
        if (_this.screen_size_loaded === "medium-large") {
          return;
        }
        _this.screen_size_loaded = "medium-large";
        _this.blocks_per_slide = _this.blocks_per_slide_desktop;
        _this.active_slide = Math.ceil(
          (_this.blocks_per_slide_mobile * (_this.active_slide - 1) + 1) /
            _this.blocks_per_slide_desktop,
        );
      }
      _this.slide_count = Math.ceil(
        _this.total_blocks / _this.blocks_per_slide,
      );
      _this.createDotNav();
      _this.dotNavListeners();
      _this.goToActiveSlide();
      return _this.updateActiveDot();
    };

    CoreCarousel.prototype.getAllFocusableEl = function () {
      var _this;
      _this = this;
      return (_this.focusable_el = theme.utils.getFocusableEl(_this.root));
    };

    CoreCarousel.prototype.loadBlocks = function () {
      var _this;
      _this = this;
      return _this.blocks.each(function (block) {
        block.setAttribute("data-loaded", "true");
        return block.setAttribute("data-loaded--mobile", "true");
      });
    };

    CoreCarousel.prototype.blockListener = function () {
      var _this;
      _this = this;
      return _this.blocks.on("theme:block:select", function () {
        _this.active_slide = Math.ceil(
          (el(this).index() + 1) / _this.blocks_per_slide,
        );
        _this.updateActive();
        _this.goToActiveSlide(true);
        _this.updateActiveDot();
        return _this.setSliderHeight();
      });
    };

    CoreCarousel.prototype.toggleDraggable = function (toggle) {
      var _this;
      if (toggle == null) {
        toggle = "opposite";
      }
      _this = this;
      if (toggle === "opposite") {
        _this.draggable = !_this.draggable;
      }
      if (toggle === true) {
        return (_this.draggable = true);
      } else if (toggle === false) {
        return (_this.draggable = false);
      }
    };

    CoreCarousel.prototype.checkForActiveModel = function (target) {
      var _this, model, model_disabled;
      _this = this;
      model = el(target.closest("model-viewer"));
      if (model.length) {
        model_disabled = model.hasClass("shopify-model-viewer-ui__disabled");
        if (!model_disabled) {
          return true;
        }
      }
      return false;
    };

    CoreCarousel.prototype.mouseDownListener = function () {
      var _this;
      _this = this;
      return _this.container.on(
        "mousedown touchstart",
        function (event) {
          if (_this.checkForActiveModel(event.target) || !_this.draggable) {
            return false;
          }
          _this.swipe_state = "swipe-started";
          _this.reenableClickAfterSwiping();
          _this.mouseUpListener();
          _this.slide_pause = true;
          if (_this.transition_type === "slide") {
            _this.drag_start = event.pageX;
            _this.container_x = _this.container
              .css("transform")
              .replace(/[^0-9\-.,]/g, "")
              .split(",")[4];
            _this.container.attr("data-transition", "");
            _this.container.css(
              "transform",
              "translateX(" + _this.container_x + "px)",
            );
            return _this.dragBegin();
          }
        },
        true,
      );
    };

    CoreCarousel.prototype.mouseUpListener = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "mouseup." + _this.section_id + " touchend." + _this.section_id,
        function () {
          _this.swipe_state = "swipe-ended";
          _this.removeMouseUpListener();
          _this.dragEnd();
          if (_this.slide_pause === true) {
            _this.container.attr("data-transition", "forwards");
            return _this.container.css(
              "transform",
              "translateX(" + _this.container_destination + ")",
            );
          }
        },
        true,
      );
    };

    CoreCarousel.prototype.removeMouseUpListener = function () {
      var _this;
      _this = this;
      return theme.window.off(
        "mouseup." + _this.section_id + " touchend." + _this.section_id,
      );
    };

    CoreCarousel.prototype.dragBegin = function () {
      var _this;
      _this = this;
      _this.root.attr("data-dragging", "true");
      return theme.window.on(
        "mousemove." + _this.section_id + " touchmove." + _this.section_id,
        function (event) {
          var offset, slide_x_start;
          offset = _this.container_x - _this.drag_start + event.pageX;
          slide_x_start = _this.window_width * (_this.slide_count - 1);
          if (offset > 0) {
            return _this.container.css(
              "transform",
              "translateX(" + offset / 4 + "px)",
            );
          } else if (offset < slide_x_start * -1) {
            offset = offset * -1;
            offset = slide_x_start + (offset - slide_x_start) / 4;
            return _this.container.css(
              "transform",
              "translateX(-" + offset + "px)",
            );
          } else {
            return _this.container.css(
              "transform",
              "translateX(" + offset + "px)",
            );
          }
        },
        true,
      );
    };

    CoreCarousel.prototype.dragEnd = function () {
      var _this;
      _this = this;
      _this.root.attr("data-dragging", "false");
      return theme.window.off(
        "mousemove." + _this.section_id + " touchmove." + _this.section_id,
      );
    };

    CoreCarousel.prototype.updateContainerDestination = function (index) {
      var _this;
      _this = this;
      return (_this.container_destination =
        ((_this.active_slide - 1) / _this.slide_count) * -100 + "%");
    };

    CoreCarousel.prototype.slideToNext = function (loop_to_start) {
      var _this, transition_direction;
      if (loop_to_start == null) {
        loop_to_start = false;
      }
      _this = this;
      _this.dot_change_type = "iterate";
      if (_this.active_slide !== _this.slide_count) {
        _this.updateActive("next");
        transition_direction = "forwards";
      } else if (loop_to_start && _this.active_slide === _this.slide_count) {
        _this.active_slide = 1;
        _this.updateActive();
        transition_direction = "forwards";
      } else if (_this.active_slide === _this.slide_count) {
        transition_direction = "backwards";
      }
      if (_this.transition_type === "slide") {
        _this.updateContainerDestination();
        _this.container.css(
          "transform",
          "translateX(" + _this.container_destination + ")",
        );
      } else if (_this.transition_type === "fade") {
        _this.fadeSlides();
      }
      return _this.container.attr("data-transition", transition_direction);
    };

    CoreCarousel.prototype.slideToPrev = function () {
      var _this, transition_direction;
      _this = this;
      _this.dot_change_type = "iterate";
      if (_this.active_slide !== 1) {
        _this.updateActive("prev");
        transition_direction = "forwards";
      } else if (_this.active_slide === 1) {
        transition_direction = "backwards";
      }
      if (_this.transition_type === "slide") {
        _this.updateContainerDestination();
        _this.container.css(
          "transform",
          "translateX(" + _this.container_destination + ")",
        );
      } else if (_this.transition_type === "fade") {
        _this.fadeSlides();
      }
      return _this.container.attr("data-transition", transition_direction);
    };

    CoreCarousel.prototype.goToActiveSlide = function (animate) {
      var _this;
      if (animate == null) {
        animate = false;
      }
      _this = this;
      _this.dot_change_type = "init";
      if (_this.transition_type === "slide") {
        _this.updateContainerDestination();
        _this.container.css(
          "transform",
          "translateX(" + _this.container_destination + ")",
        );
      } else if (_this.transition_type === "fade") {
        _this.fadeSlides();
      }
      if (animate) {
        return _this.container.attr("data-transition", "forwards");
      }
    };

    CoreCarousel.prototype.checkStartEnd = function () {
      var _this;
      _this = this;
      if (_this.active_slide === 1) {
        _this.at_start = true;
        _this.prev.attr("tabindex", "-1");
      } else {
        _this.at_start = false;
        _this.prev.attr("tabindex", "0");
      }
      _this.root.attr("data-at-start", _this.at_start);
      if (_this.active_slide === _this.slide_count) {
        _this.at_end = true;
        _this.next.attr("tabindex", "-1");
      } else {
        _this.at_end = false;
        _this.next.attr("tabindex", "0");
      }
      return _this.root.attr("data-at-end", _this.at_end);
    };

    CoreCarousel.prototype.updateActive = function (direction) {
      var _this, higher_range, lower_range;
      if (direction == null) {
        direction = false;
      }
      _this = this;
      if (direction === "next") {
        _this.active_slide += 1;
        if (!(_this.autoplay_focus_enabled === false && _this.auto_rotate)) {
          _this.prev.focus(0);
        }
      } else if (direction === "prev") {
        _this.active_slide -= 1;
        if (!(_this.autoplay_focus_enabled === false && _this.auto_rotate)) {
          _this.next.focus(0);
        }
      }
      lower_range = (_this.active_slide - 1) * _this.blocks_per_slide;
      higher_range = lower_range + _this.blocks_per_slide;
      if (_this.active_blocks !== null) {
        _this.old_active_blocks = _this.active_blocks;
      }
      _this.active_blocks = el(
        Array.from(_this.blocks.el).slice(lower_range, higher_range),
      );
      _this.toggleFocusableEl(direction);
      return _this.checkStartEnd();
    };

    CoreCarousel.prototype.toggleFocusableEl = function (direction) {
      var _this;
      _this = this;
      if (_this.disabled_el) {
        _this.disabled_el.attr("tabindex", "0");
      }
      _this.disabled_el = theme.utils.getFocusableEl(
        _this.blocks.not(_this.active_blocks),
      );
      if (_this.disabled_el) {
        return _this.disabled_el.attr("tabindex", "-1");
      }
    };

    CoreCarousel.prototype.setSliderHeight = function () {
      var _this, tallest;
      _this = this;
      tallest = 0;
      _this.active_blocks.each(function (block) {
        var height;
        height = block.offsetHeight;
        if (height > tallest) {
          return (tallest = height);
        }
      });
      return _this.height_container.css("height", tallest + "px");
    };

    CoreCarousel.prototype.swipeListener = function () {
      var _this;
      _this = this;
      document.addEventListener("theme:swipe:left", function () {
        if (_this.swipe_state === "swipe-started") {
          _this.slide_pause = false;
          _this.slideToNext();
          _this.setSliderHeight();
          _this.updateActiveDot();
          return _this.preventClickWhenSwiping();
        }
      });
      return document.addEventListener("theme:swipe:right", function () {
        if (_this.swipe_state === "swipe-started") {
          _this.slide_pause = false;
          _this.slideToPrev();
          _this.setSliderHeight();
          _this.updateActiveDot();
          return _this.preventClickWhenSwiping();
        }
      });
    };

    CoreCarousel.prototype.createDotNav = function () {
      var _this, carousel_dot, i, j, ref;
      _this = this;
      if (!_this.dot_nav_enabled || _this.slide_count === 1) {
        return;
      }
      _this.dot_nav.empty();
      for (
        i = j = 1, ref = _this.slide_count;
        1 <= ref ? j <= ref : j >= ref;
        i = 1 <= ref ? ++j : --j
      ) {
        carousel_dot = theme.utils.parseHtml(
          '<div class="carousel--dot"></div>',
        );
        _this.dot_nav.append(carousel_dot);
      }
      _this.dots = _this.root.find(".carousel--dot");
      if (theme.utils.mqs.current_window === "small") {
        return _this.dots.attr("tabindex", "0");
      }
    };

    CoreCarousel.prototype.updateActiveDot = function () {
      var _this;
      _this = this;
      _this.dots.attr("data-active", "false");
      _this.dots.eq(_this.active_slide - 1).attr("data-active", "true");
      if (_this.dots.length > 5) {
        return _this.updateTrailingLeadingDots();
      } else {
        _this.alignDots();
        return _this.dot_nav.attr("data-loaded", "true");
      }
    };

    CoreCarousel.prototype.updateTrailingLeadingDots = function () {
      var _this, active, initial_offset, offset_initial;
      _this = this;
      if (_this.active_slide === _this.leading_dot_index) {
        _this.leading_dot_index++;
        _this.trailing_dot_index++;
        active = _this.dots.eq(_this.active_slide - 1);
        active.attr("data-position", "");
        initial_offset = active.offset().left;
        setTimeout(function () {
          _this.dots
            .eq(_this.active_slide - 4)
            .attr("data-position", "trailing-1");
          _this.dots
            .eq(_this.active_slide - 5)
            .attr("data-position", "trailing-2");
          if (_this.active_slide >= 5) {
            _this.dots
              .filter(":nth-child(-n+" + (_this.active_slide - 5) + ")")
              .attr("data-position", "hidden");
          }
          _this.dots.eq(_this.active_slide).attr("data-position", "leading-1");
          _this.dots
            .eq(_this.active_slide + 1)
            .attr("data-position", "leading-2");
          _this.dots
            .filter(":nth-child(n+" + (_this.active_slide + 3) + ")")
            .attr("data-position", "hidden");
          _this.alignDots(initial_offset);
          if (_this.dot_change_type === "init") {
            _this.alignDots();
            return _this.dot_nav.attr("data-loaded", "true");
          }
        }, 0);
        return setTimeout(function () {
          _this.dot_nav.attr("data-transition", "true");
          return _this.alignDots();
        }, 200);
      } else if (_this.active_slide === _this.trailing_dot_index) {
        _this.leading_dot_index--;
        _this.trailing_dot_index--;
        active = _this.dots.eq(_this.active_slide - 1);
        active.attr("data-position", "");
        offset_initial = active.offset().left;
        setTimeout(function () {
          _this.dots
            .eq(_this.active_slide - 2)
            .attr("data-position", "trailing-1");
          _this.dots
            .eq(_this.active_slide - 3)
            .attr("data-position", "trailing-2");
          _this.dots
            .eq(_this.active_slide + 2)
            .attr("data-position", "leading-1");
          _this.dots
            .eq(_this.active_slide + 3)
            .attr("data-position", "leading-2");
          _this.dots
            .filter(":nth-child(n+" + (_this.active_slide + 5) + ")")
            .attr("data-position", "hidden");
          if (_this.active_slide >= 4) {
            _this.dots
              .filter(":nth-child(-n+" + (_this.active_slide - 2) + ")")
              .attr("data-position", "hidden");
          }
          _this.alignDots(initial_offset);
          if (_this.dot_change_type === "init") {
            _this.alignDots();
            return _this.dot_nav.attr("data-loaded", "true");
          }
        }, 0);
        return setTimeout(function () {
          _this.dot_nav.attr("data-transition", "true");
          return _this.alignDots();
        }, 200);
      } else if (_this.dot_change_type === "init") {
        _this.dots.attr("data-position", "");
        if (_this.slide_count - _this.active_slide <= 2) {
          _this.leading_dot_index = _this.active_slide;
          _this.trailing_dot_index = _this.active_slide - 3;
        } else if (_this.slide_count - _this.active_slide > 2) {
          _this.trailing_dot_index = _this.active_slide;
          _this.leading_dot_index = _this.active_slide + 3;
        }
        return _this.updateTrailingLeadingDots();
      }
    };

    CoreCarousel.prototype.alignDots = function (offset_initial) {
      var _this, new_offset, offset_difference;
      if (offset_initial == null) {
        offset_initial = false;
      }
      _this = this;
      if (offset_difference) {
        offset_difference = offset_initial - active.offset().left;
        new_offset = _this.dot_nav_offset + offset_difference + "px";
        _this.dot_nav.attr("data-transition", "false");
        return _this.dot_nav.css("transform", "translateX(" + new_offset + ")");
      } else {
        _this.dot_nav_offset = (_this.root.width() - _this.dot_nav.width()) / 2;
        return _this.dot_nav.css(
          "transform",
          "translateX(" + _this.dot_nav_offset + "px)",
        );
      }
    };

    CoreCarousel.prototype.dotNavListeners = function () {
      var _this;
      _this = this;
      _this.dots.off(
        "click." + _this.section_id + " keydown." + _this.section_id,
      );
      return _this.dots.on(
        "click." + _this.section_id + " keydown." + _this.section_id,
        function () {
          if (event.type === "keydown" && event.key !== "Enter") {
            return;
          }
          _this.active_slide = el(this).index() + 1;
          _this.updateActive();
          _this.goToActiveSlide(true);
          _this.setSliderHeight();
          return _this.updateActiveDot();
        },
      );
    };

    CoreCarousel.prototype.arrowNavListeners = function () {
      var _this;
      _this = this;
      _this.prev.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        _this.slideToPrev();
        _this.setSliderHeight();
        return _this.updateActiveDot();
      });
      return _this.next.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        _this.slideToNext();
        _this.setSliderHeight();
        return _this.updateActiveDot();
      });
    };

    CoreCarousel.prototype.resizeListener = function () {
      var _this;
      _this = this;
      _this.window_width = document.documentElement.clientWidth;
      return theme.window.on(
        "resize." + _this.section_id,
        theme.utils.debounce(100, function () {
          _this.window_width = document.documentElement.clientWidth;
          _this.initNewScreenSize();
          _this.updateActive();
          _this.setSliderHeight();
          _this.alignDots();
          if (theme.utils.mqs.current_window === "small") {
            return _this.dots.attr("tabindex", "0");
          } else {
            return _this.dots.removeAttr("tabindex");
          }
        }),
      );
    };

    CoreCarousel.prototype.reenableClickAfterSwiping = function () {
      var _this;
      _this = this;
      return _this.links.off("click." + _this.section_id);
    };

    CoreCarousel.prototype.preventClickWhenSwiping = function () {
      var _this;
      _this = this;
      return _this.links.on("click." + _this.section_id, function (event) {
        return event.preventDefault();
      });
    };

    CoreCarousel.prototype.autoSlide = function () {
      var _this;
      _this = this;
      return (_this.auto_slide_timer = setInterval(function () {
        _this.slideToNext(true);
        _this.updateActiveDot();
        return _this.setSliderHeight();
      }, _this.rotate_frequency * 1000));
    };

    CoreCarousel.prototype.stopAutoSlideWhenInteracting = function () {
      var _this;
      _this = this;
      _this.root.on(
        "click touchstart",
        function () {
          _this.autoplay_focus_enabled = true;
          clearInterval(_this.auto_slide_timer);
          return _this.root.off("click touchstart");
        },
        true,
      );
      return _this.focusable_el.on(
        "focus",
        function () {
          _this.autoplay_focus_enabled = true;
          clearInterval(_this.auto_slide_timer);
          return _this.focusable_el.off("focus");
        },
        true,
      );
    };

    CoreCarousel.prototype.fadeSlides = function () {
      var _this;
      _this = this;
      if (_this.active_blocks === null || _this.old_active_blocks === null) {
        return;
      }
      _this.blocks.attr("data-active", "");
      _this.blocks.attr("data-loaded", "false");
      _this.blocks.attr("data-loaded--mobile", "false");
      _this.old_active_blocks.each(function (active_block) {
        active_block.setAttribute("data-active", "old");
        return (active_block.style.left = "0%");
      });
      return _this.active_blocks.each(function (active_block, index) {
        var left;
        left = (100 / _this.total_blocks) * index + "%";
        active_block.setAttribute("data-active", "new");
        return (active_block.style.left = left);
      });
    };

    CoreCarousel.prototype.updateThenGoToActiveSlide = function (slide_num) {
      var _this;
      _this = this;
      _this.active_slide = slide_num;
      _this.goToActiveSlide();
      _this.setSliderHeight();
      return _this.updateActiveDot();
    };

    return CoreCarousel;
  })();

  theme.classes.CoreCart = (function () {
    function CoreCart(root) {
      var _this;
      this.root = root;
      this.renderDynamicCheckoutButtons = bind(
        this.renderDynamicCheckoutButtons,
        this,
      );
      this.updateTotals = bind(this.updateTotals, this);
      this.updateAllHasItems = bind(this.updateAllHasItems, this);
      this.addItem = bind(this.addItem, this);
      this.swapInImages = bind(this.swapInImages, this);
      this.getHtml = bind(this.getHtml, this);
      this.updateHtml = bind(this.updateHtml, this);
      this.htmlListener = bind(this.htmlListener, this);
      this.updateAllHtml = bind(this.updateAllHtml, this);
      this.updateNote = bind(this.updateNote, this);
      this.noteTypingListener = bind(this.noteTypingListener, this);
      this.updateQuantity = bind(this.updateQuantity, this);
      this.clearRequests = bind(this.clearRequests, this);
      this.quantitySlot = bind(this.quantitySlot, this);
      this.sendNextQuantity = bind(this.sendNextQuantity, this);
      this.markChanging = bind(this.markChanging, this);
      this.showFailedChanges = bind(this.showFailedChanges, this);
      this.toggleLoadingDisplay = bind(this.toggleLoadingDisplay, this);
      this.toggleLoadingOnSubmit = bind(this.toggleLoadingOnSubmit, this);
      this.removeItem = bind(this.removeItem, this);
      this.removeButtonListener = bind(this.removeButtonListener, this);
      this.minusButtonListener = bind(this.minusButtonListener, this);
      this.plusButtonListener = bind(this.plusButtonListener, this);
      this.inputBoxListener = bind(this.inputBoxListener, this);
      this.eventListeners = bind(this.eventListeners, this);
      this.getOtherCarts = bind(this.getOtherCarts, this);
      _this = this;
      _this.is_drawer = _this.root.data("is-drawer");
      _this.other_carts = _this.getOtherCarts();
      _this.quantity_request = null;
      _this.quantity_timer = {};
      _this.quantity_queue = [];
      _this.quantity_last_tap = 0;
      // GC-208: line key (or number) → the quantity asked for by a change that didn't land.
      _this.failed_quantities = {};
      // GC-241: line key (or number) -> what the line is (CoreCart.lineIdentity), for a failed change, so its
      // message finds the line after a cart-wide discount has given it a new key.
      _this.failed_lines = {};
      // GC-241: the page's finished cart writes (CoreCart.writes_done) when the lines on show were drawn.
      _this.drawn_writes = CoreCart.writes_done;
      _this.total_item_count = document.querySelectorAll(
        ".cart--external--total-items",
      );
      _this.total_price = document.querySelectorAll(
        ".cart--external--total-price",
      );
      _this.view = _this.root.attr("data-view");
      _this.htmlListener();
      _this.eventListeners();
      _this.checkoutGuard();
      _this.renderDynamicCheckoutButtons();
      CoreCart.carts.push(_this);
    }

    // GC-208: the cart's Checkout buttons: the theme's own, and the copy Route's script
    // swaps in a few seconds after load.
    CoreCart.CHECKOUT =
      'button[name="checkout"], .checkout-button, button[data-route-copy]';

    // GC-241: the page's cart writes waiting their turn (CoreCart.write), shared by every cart on the page,
    // and those carts (each marks Checkout busy while a write waits, markChanging).
    CoreCart.writes = [];
    CoreCart.writing = false;
    CoreCart.carts = [];
    CoreCart.carts_marked = false;
    // The longest one write may hold the others: a request that never finishes must not stop every add on the
    // site. Well past a slow add on a slow phone network.
    CoreCart.WRITE_WAIT = 25000;
    // GC-319: how many more times a cart redraw is asked for when its answer isn't a 2xx (getHtml).
    CoreCart.HTML_RETRIES = 2;
    // How long an add holds the next write while it reads the cart after itself (addItem): a slow read only
    // leaves the counts behind, so it never holds the others for long.
    CoreCart.READ_WAIT = 10000;
    // GC-241: cart writes finished on this page. The lines a cart shows are only sure to carry their current
    // keys while none has finished since they were drawn (CoreCart.prototype.currentKey).
    CoreCart.writes_done = 0;
    // The count once the write running now has landed (its answer is in, set by that write): a redraw asked for
    // after that shows it, though the write hasn't finished yet (the /cart page redraws from a change's answer).
    CoreCart.writes_landed = 0;

    /**
     * GC-241: what Shopify merges cart lines on (variant, properties, selling plan), read from a drawn line
     * (snippets/cart-drawer-line.liquid prints them), so the line can be found again once its key has changed:
     * while a cart-wide discount applies, Shopify gives every line a new key on each change.
     * @param {Object} line - el() collection holding one .cart--item
     * @returns {?{variant: number, properties: Object, plan: string}} null when the line doesn't print them
     */
    CoreCart.lineIdentity = function (line) {
      var properties;
      if (line.attr("data-properties") == null) {
        return null;
      }
      try {
        properties = JSON.parse(line.attr("data-properties")) || {};
      } catch (error) {
        return null;
      }
      return {
        variant: Number(line.attr("data-variant-id")),
        properties: properties,
        plan: line.attr("data-selling-plan") || "",
      };
    };

    /**
     * GC-241: a /cart.js line's identity, as CoreCart.lineIdentity reads it from a drawn line.
     * @param {Object} item - one of /cart.js's items
     * @returns {{variant: number, properties: Object, plan: string}}
     */
    CoreCart.itemIdentity = function (item) {
      return {
        variant: item.variant_id,
        properties: item.properties || {},
        plan: String(item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : ""),
      };
    };

    /**
     * GC-241: whether two identities name the same cart line.
     * @param {{variant: number, properties: Object, plan: string}} a
     * @param {{variant: number, properties: Object, plan: string}} b
     * @returns {boolean}
     */
    CoreCart.sameLine = function (a, b) {
      var names = Object.keys(a.properties);
      return (
        a.variant === b.variant &&
        a.plan === b.plan &&
        names.length === Object.keys(b.properties).length &&
        names.every(function (name) {
          return String(a.properties[name]) === String(b.properties[name]);
        })
      );
    };

    /**
     * GC-241: every cart write on the page (an add, a quantity change, a gift, an add-on, the note) goes
     * through here, one at a time, in the order asked: Shopify can lose one of two cart writes that overlap,
     * though it answers 200 to both. Each waits only for the request before it to finish, not for the cart
     * to redraw. Route's widget writes the cart on its own and can't wait here.
     * @param {function(function(): void): void} send - Starts the request and calls its argument once it has
     *   finished (XHR loadend: after load, error, timeout or abort); a second call does nothing.
     * @returns {void}
     */
    CoreCart.write = function (send) {
      CoreCart.writes.push(send);
      CoreCart.nextWrite();
      // Only a write that has to wait marks the carts: one that starts at once leaves Checkout as it is
      // (Route redraws its line each time Checkout turns busy, GC-223).
      if (CoreCart.writes.length) {
        CoreCart.writesChanged();
      }
    };

    /**
     * GC-241: every cart on the page marks Checkout busy while a write waits its turn (leaving for checkout
     * then would drop it), and not busy once none waits.
     * @returns {void}
     */
    CoreCart.writesChanged = function () {
      CoreCart.carts_marked = CoreCart.writes.length > 0;
      CoreCart.carts.forEach(function (cart) {
        cart.markChanging();
      });
    };

    /**
     * GC-241: starts the oldest waiting cart write once none is running.
     * @returns {void}
     */
    CoreCart.nextWrite = function () {
      var done, finished, send, watchdog;
      if (CoreCart.writing || !CoreCart.writes.length) {
        return;
      }
      CoreCart.writing = true;
      send = CoreCart.writes.shift();
      if (CoreCart.carts_marked) {
        CoreCart.writesChanged();
      }
      finished = false;
      done = function () {
        if (finished) {
          return;
        }
        finished = true;
        clearTimeout(watchdog);
        CoreCart.writes_done += 1;
        CoreCart.writing = false;
        CoreCart.nextWrite();
      };
      watchdog = setTimeout(done, CoreCart.WRITE_WAIT);
      try {
        send(done);
      } catch (error) {
        // A write that couldn't start holds nothing. Thrown later, not here: this may run inside the
        // previous write's done(), and its caller (a callback still to come) must not be cut short.
        done();
        setTimeout(function () {
          throw error;
        });
      }
    };

    /**
     * GC-208: while a quantity change waits or is in flight (data-changing, markChanging),
     * stops a click on Checkout and a submit of the cart's own form (.cart--form; the
     * product forms in the drawer's suggestions keep working). Capture phase on window, so
     * it runs before the cart's and Route's own click handlers, and also covers a Route
     * copy that arrives mid-change. Keyboard Enter on a button is a click too.
     * @returns {void}
     */
    CoreCart.prototype.checkoutGuard = function () {
      var _this, root, stop;
      _this = this;
      root = _this.root.el[0];
      if (!root) {
        return;
      }
      stop = function (event) {
        var target;
        target = event.target.closest
          ? event.target.closest(
              event.type === "submit" ? ".cart--form" : CoreCart.CHECKOUT,
            )
          : null;
        if (
          target &&
          root.contains(target) &&
          root.getAttribute("data-changing") === "true"
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      window.addEventListener("click", stop, true);
      window.addEventListener("submit", stop, true);
    };

    CoreCart.prototype.getOtherCarts = function () {
      var _this, other_carts;
      _this = this;
      return (other_carts = el('[data-js-class="Cart"]').not(_this.root));
    };

    CoreCart.prototype.eventListeners = function () {
      var _this;
      _this = this;
      _this.inputBoxListener();
      _this.plusButtonListener();
      _this.minusButtonListener();
      _this.removeButtonListener();
      _this.toggleLoadingOnSubmit();
      return _this.noteTypingListener();
    };

    CoreCart.prototype.inputBoxListener = function () {
      var _this, input_box;
      _this = this;
      input_box = _this.root.find(".cart--quantity--input");
      input_box.on("keydown", function (event) {
        if (
          (event.which < 48 || event.which > 57) &&
          (event.which < 37 || event.which > 40) &&
          event.which !== 8 &&
          event.which !== 9
        ) {
          return event.preventDefault();
        }
      });
      return input_box.on("focusout", function (event) {
        var identity, line_num, quantity, slot;
        input_box = el(this);
        line_num = input_box.closest(".cart--item").data("line-num");
        slot = _this.quantitySlot(line_num);
        identity = CoreCart.lineIdentity(input_box.closest(".cart--item"));
        quantity = isNaN(parseInt(input_box.val()))
          ? 1
          : parseInt(input_box.val());
        // Focus just passing through (Tab, or a tap in and out) sends nothing:
        // an update re-renders the cart and would throw keyboard focus away.
        if (quantity === parseInt(input_box.closest(".cart--item").attr("data-quantity"))) {
          return;
        }
        _this.toggleLoadingDisplay(line_num);
        _this.clearRequests(line_num);
        if (quantity === 0) {
          return _this.removeItem(line_num);
        } else {
          return _this.updateQuantity(
            line_num,
            quantity,
            0,
            function (success, error) {
              if (success) {
                return _this.updateAllHtml(function () {});
              } else {
                return _this.updateAllHtml(function () {
                  // GC-194: by key: a Remove above it may have moved the line up.
                  return _this
                    .lineFor(slot, identity)
                    .find(".cart--error")
                    .removeAttr("style");
                });
              }
            },
          );
        }
      });
    };

    CoreCart.prototype.plusButtonListener = function () {
      var _this, plus_button;
      _this = this;
      plus_button = _this.root.find(".cart--plus");
      return plus_button.on("click", function (event) {
        var burst, identity, input, line_num, plus_el, quantity, slot;
        event.preventDefault();
        plus_el = el(this);
        input = plus_el.prev("input");
        line_num = plus_el.closest(".cart--item").data("line-num");
        slot = _this.quantitySlot(line_num);
        identity = CoreCart.lineIdentity(plus_el.closest(".cart--item"));
        quantity = isNaN(parseInt(input.val())) ? 1 : parseInt(input.val()) + 1;
        input.val(quantity);
        _this.toggleLoadingDisplay(line_num);
        _this.clearRequests(line_num);
        // Leading-edge debounce: a lone tap fires immediately; only taps
        // inside the 700ms window trail. Safe under rapid tapping because
        // clearRequests() above drops this line's waiting change, changes go
        // one at a time in tap order (GC-194), and the quantity sent is absolute.
        burst = Date.now() - _this.quantity_last_tap < 700;
        _this.quantity_last_tap = Date.now();
        _this.updateQuantity(
          line_num,
          quantity,
          burst ? 700 : 0,
          function (success, error) {
            if (success) {
              return _this.updateAllHtml(function () {});
            } else {
              return _this.updateAllHtml(function () {
                // GC-194: by key: a Remove above it may have moved the line up.
                return _this
                  .lineFor(slot, identity)
                  .find(".cart--error")
                  .removeAttr("style");
              });
            }
          },
        );
        event.preventDefault();
        return event.stopPropagation();
      });
    };

    CoreCart.prototype.minusButtonListener = function () {
      var _this, minus_button;
      _this = this;
      minus_button = _this.root.find(".cart--minus");
      return minus_button.on("click", function (event) {
        var burst, input, line_num, minus_el, quantity;
        event.preventDefault();
        minus_el = el(this);
        input = minus_el.siblings("input");
        line_num = minus_el.closest(".cart--item").data("line-num");
        quantity = isNaN(parseInt(input.val())) ? 1 : parseInt(input.val()) - 1;
        if (quantity < 1) {
          quantity = 1;
        }
        input.val(quantity);
        _this.toggleLoadingDisplay(line_num);
        _this.clearRequests(line_num);
        // Leading-edge debounce — see plusButtonListener for the safety note.
        burst = Date.now() - _this.quantity_last_tap < 700;
        _this.quantity_last_tap = Date.now();
        // GC-194: re-render on a capped answer too. On an oversold line, minus is capped
        // to the stock and still changes the quantity; without it the box and Checkout
        // stayed stale.
        _this.updateQuantity(line_num, quantity, burst ? 700 : 0, function () {
          return _this.updateAllHtml(function () {});
        });
        event.preventDefault();
        return event.stopPropagation();
      });
    };

    CoreCart.prototype.removeButtonListener = function () {
      var _this, remove_button;
      _this = this;
      remove_button = _this.root.find(".cart--item--remove");
      return remove_button.on("click", function (event) {
        var line_num;
        event.preventDefault();
        line_num = el(this).closest(".cart--item").data("line-num");
        _this.toggleLoadingDisplay(line_num);
        _this.clearRequests(line_num);
        _this.removeItem(line_num);
        event.preventDefault();
        return event.stopPropagation();
      });
    };

    CoreCart.prototype.removeItem = function (line_num) {
      var _this;
      _this = this;
      return _this.updateQuantity(line_num, 0, 0, function (success) {
        if (success) {
          return _this.updateAllHtml(function () {});
        }
      });
    };

    CoreCart.prototype.toggleLoadingOnSubmit = function () {
      var _this;
      _this = this;
      _this.checkout_button = _this.root.find(".cart--checkout-button button");
      return _this.checkout_button.on("click", function () {
        return el(this).attr("data-loading", true);
      });
    };

    CoreCart.prototype.toggleLoadingDisplay = function (line_num) {
      var _this, input;
      _this = this;
      input = _this.root.find(
        ".cart--item[data-line-num='" + line_num + "'] input",
      );
      input.attr("data-loading", "true");
      _this.checkout_button.attr("disabled", true);
      return _this.root
        .find(".cart--additional-buttons")
        .css("visibility", "hidden");
    };

    /**
     * GC-194: drops this line's waiting quantity change, because a newer tap replaces
     * it (the quantity sent is absolute). Other lines' changes keep their place in
     * quantity_queue. A change already in flight is not aborted: Shopify may still
     * apply it after its replacement. It finishes first, unrendered, and the newer
     * change goes after it.
     * @param {number} line_num - the line's data-line-num at tap time
     * @returns {void}
     */
    CoreCart.prototype.clearRequests = function (line_num) {
      var _this, slot;
      _this = this;
      slot = _this.quantitySlot(line_num);
      clearTimeout(_this.quantity_timer[slot]);
      delete _this.quantity_timer[slot];
      _this.quantity_queue = _this.quantity_queue.filter(function (job) {
        return job.slot !== slot;
      });
      if (_this.quantity_request && _this.quantity_request.slot === slot) {
        _this.quantity_request.replaced = true;
      }
      // GC-208: a new tap on the line replaces its failed change, and takes back the message.
      delete _this.failed_quantities[slot];
      delete _this.failed_lines[slot];
      _this.root
        .find(".cart--item[data-line-num='" + line_num + "'] .cart--error")
        .css("display", "none");
      _this.markChanging();
    };

    /**
     * GC-208: marks the cart busy (data-changing="true") while a quantity change waits or
     * is in flight, and not busy once none is left. theme--async.css then shows Checkout's
     * spinner, on Route's copy too whenever it arrives, and checkoutGuard() stops Checkout.
     * Called each time the queue or the request in flight changes. GC-241: also while any
     * cart write on the page waits its turn (an add tapped while another was on its way).
     * @returns {void}
     */
    CoreCart.prototype.markChanging = function () {
      var changing;
      changing = !!(this.quantity_request || this.quantity_queue.length || CoreCart.writes.length);
      this.root.attr("data-changing", changing ? "true" : "false");
      this.root.find(CoreCart.CHECKOUT).each(function (button) {
        if (changing) {
          button.setAttribute("aria-disabled", "true");
        } else if (!button.disabled) {
          // A button disabled for its own reason (the gift-only guard) keeps its aria-disabled.
          button.removeAttribute("aria-disabled");
        }
      });
    };

    /**
     * GC-208: says "Couldn't update. Try again." on each line whose change didn't land
     * (failed_quantities), in the line's .cart--error, read out as an alert. A failure stays
     * until a new tap on the line (clearRequests) or a change for it that lands, so every
     * re-render says it again (#35's late look after a timeout re-renders too).
     * @param {boolean} from_store - true: the lines were just drawn from the store. A line
     *   now at the quantity asked for (a timed-out change that landed after all), or gone
     *   when it was being removed, is settled: no message, failure forgotten. false: the
     *   lines as they are (they show the asked-for number), so no settling.
     * @returns {void}
     */
    CoreCart.prototype.showFailedChanges = function (from_store) {
      var _this;
      _this = this;
      Object.keys(_this.failed_quantities).forEach(function (slot) {
        var identity, key, line, wanted;
        wanted = _this.failed_quantities[slot];
        identity = _this.failed_lines[slot];
        line = _this.lineFor(slot, identity);
        // GC-241: drawn with a new key (a cart-wide discount renews them on each change): keep the failure
        // under it.
        key = isNaN(slot) && line.length ? line.attr("data-key") : null;
        if (key && key !== slot) {
          delete _this.failed_quantities[slot];
          delete _this.failed_lines[slot];
          _this.failed_quantities[key] = wanted;
          _this.failed_lines[key] = identity;
        } else {
          key = null;
        }
        if (from_store && !line.length) {
          // Removed as asked, or gone for another reason: nothing left to say it on.
          delete _this.failed_quantities[slot];
          delete _this.failed_lines[slot];
          return;
        }
        if (from_store && parseInt(line.attr("data-quantity")) === wanted) {
          delete _this.failed_quantities[key || slot];
          delete _this.failed_lines[key || slot];
          return;
        }
        line.find(".cart--error").each(function (error) {
          error.textContent = theme.translations.cart_update_failed;
          error.setAttribute("role", "alert");
          error.removeAttribute("style");
        });
      });
    };

    /**
     * The drawn line a change was for: by its key (GC-194) or number, and, GC-241, when a cart-wide discount
     * has given it a new key since, by what it is (CoreCart.lineIdentity).
     * @param {string|number} slot - the line's key, or its number (quantitySlot)
     * @param {?{variant: number, properties: Object, plan: string}} identity
     * @returns {Object} el() collection: the line, or none
     */
    CoreCart.prototype.lineFor = function (slot, identity) {
      var line;
      line = this.root.find(
        isNaN(slot)
          ? ".cart--item[data-key='" + slot + "']"
          : ".cart--item[data-line-num='" + slot + "']",
      );
      if (line.length || !identity) {
        return line;
      }
      // .el is a NodeList: no filter() of its own.
      line = Array.prototype.filter.call(this.root.find(".cart--item[data-key]").el, function (each) {
        var other = CoreCart.lineIdentity(el(each));
        return !!other && CoreCart.sameLine(other, identity);
      });
      return el(line.length === 1 ? line : []);
    };

    /**
     * GC-194: names a cart line by its Shopify line item key (`data-key`), which,
     * unlike its line number, stays the same when an earlier line is removed or a gift
     * line comes or goes. Falls back to the line number.
     * @param {number} line_num
     * @returns {string|number}
     */
    CoreCart.prototype.quantitySlot = function (line_num) {
      return (
        this.root
          .find(".cart--item[data-line-num='" + line_num + "']")
          .attr("data-key") || line_num
      );
    };

    /**
     * GC-241: a line's key as it is now. While a cart-wide discount applies, Shopify gives every line a new
     * key on each change, so the key drawn on the line goes stale once a cart write has finished after the
     * drawing (a change ahead of it in a burst, an add, a gift): a change.js by that key gets 400 ("no valid
     * id or line parameter") and the tap is lost. In that case it reads /cart.js and finds the line by what
     * it is.
     * Runs in the change's turn among the page's cart writes, so nothing can change the cart in between.
     * @param {?{variant: number, properties: Object, plan: string}} identity - CoreCart.lineIdentity, or null
     *   to keep the drawn key (a line sent by number, or markup that doesn't print the identity)
     * @param {boolean} force - read even when no write has finished since the drawing (Shopify refused the
     *   drawn key: a write the queue doesn't see renewed it)
     * @param {function((string|boolean|null))} callback - the key; null: keep the drawn one (fresh, or the
     *   cart couldn't be read, or several lines match); false: the line is gone
     * @returns {void}
     */
    CoreCart.prototype.currentKey = function (identity, force, callback) {
      var request;
      if (!identity || (!force && this.drawn_writes === CoreCart.writes_done)) {
        return callback(null);
      }
      request = new XMLHttpRequest();
      request.onload = function () {
        var matches;
        try {
          matches = JSON.parse(request.response).items.filter(function (item) {
            return CoreCart.sameLine(CoreCart.itemIdentity(item), identity);
          });
        } catch (error) {
          // Shopify answers its rate-limit page as HTML.
          return callback(null);
        }
        if (!matches.length) {
          return callback(false);
        }
        return callback(matches.length === 1 ? matches[0].key : null);
      };
      request.onerror = request.ontimeout = function () {
        return callback(null);
      };
      request.open("GET", theme.urls.cart + ".js");
      request.timeout = CoreCart.READ_WAIT;
      return request.send();
    };

    /**
     * GC-194: sends the oldest queued quantity change once its debounce is over and no
     * change.js is in flight, so changes reach Shopify one at a time, in the order they
     * were tapped (the free-gift logic expects one cart change at a time).
     * @returns {void}
     */
    CoreCart.prototype.sendNextQuantity = function () {
      if (
        !this.quantity_request &&
        this.quantity_queue.length &&
        this.quantity_queue[0].ready
      ) {
        this.quantity_queue.shift().send();
      }
    };

    /**
     * Queues a quantity change for one cart line (GC-194: in tap order, by line item
     * key, one change.js at a time) and sends it once `time_out` ms have passed.
     * @param {number} line_num - the line's data-line-num at tap time
     * @param {number} requested_quantity - the line's new quantity (0 removes it)
     * @param {number} time_out - debounce in ms (0: the next tick)
     * @param {function(boolean)} callback - re-renders the cart; false = capped at stock
     * @returns {number} the debounce timer
     */
    CoreCart.prototype.updateQuantity = function (
      line_num,
      requested_quantity,
      time_out,
      callback,
    ) {
      var _this,
        ajaxQuantity,
        all_items_added,
        cart_item,
        identity,
        inventory_management,
        inventory_quantity,
        job,
        slot;
      _this = this;
      cart_item = _this.root.find(
        ".cart--item[data-line-num='" + line_num + "']",
      );
      slot = _this.quantitySlot(line_num);
      // GC-241: what the line is, to find it again if its key has changed by the change's turn.
      identity = CoreCart.lineIdentity(cart_item);
      inventory_management = cart_item.data("inventory-management");
      inventory_quantity = cart_item.data("inventory-quantity");
      all_items_added = false;
      // GC-88: cap increases only, never below 0. A sold-out line can sit in the cart
      // with stock at 0 or below (oversold); capping its Remove (0) to a negative stock
      // sent quantity -N to change.js and reported the removal as failed.
      if (
        requested_quantity > 0 &&
        requested_quantity > inventory_quantity &&
        inventory_management === "shopify"
      ) {
        all_items_added = true;
        requested_quantity = Math.max(inventory_quantity, 0);
      }
      ajaxQuantity = function () {
        var body, loadend, request;
        // GC-194: by line item key when the line has one; a line number goes stale once
        // an earlier line is removed, and the change would land on the wrong product.
        body =
          slot === line_num
            ? { line: line_num, quantity: requested_quantity }
            : { id: slot, quantity: requested_quantity };
        // The drawer comes back rendered with the change (Shopify's Section
        // Rendering API), so its redraw needs no second request.
        if (_this.is_drawer) {
          body.sections = CoreCart.DRAWER_SECTION;
          body.sections_url = window.location.pathname;
        }
        request = new XMLHttpRequest();
        request.slot = slot;
        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            CoreCart.writes_landed = CoreCart.writes_done + 1;
            // GC-194: this change has landed. Its own re-render can run right away (the
            // drawer's, from next_html) and must not find it still in flight.
            if (_this.quantity_request === request) {
              _this.quantity_request = null;
            }
            // GC-208: this line's earlier failed change is replaced by this one.
            delete _this.failed_quantities[slot];
            delete _this.failed_lines[slot];
            // GC-194: while another change waits, skip this re-render: it would reset
            // that line's box to the old number, and a tap on it would then be lost.
            // The last change re-renders.
            if (!_this.quantity_queue.length) {
              request.rendered = true;
              // Read by getHtml() while the callback redraws, and only then.
              _this.next_html = _this.is_drawer ? CoreCart.drawerHtml(request.response) : null;
              callback(!all_items_added);
              _this.next_html = null;
            }
            return _this.updateTotals();
          }
        };
        request.onerror = function () {
          return console.log(
            request.statusText + ": quantity update request failed!",
          );
        };
        // Runs after load, error, timeout or abort: only then may the next change go.
        loadend = function () {
          var burst_ended;
          if (_this.quantity_request === request) {
            _this.quantity_request = null;
          }
          // GC-208: a change that didn't land (an error, a timeout, a refusal, a rate limit)
          // is told on its line at once, mid-burst too, and on the line as it is in case the
          // re-render below fails as well. Not when a newer tap on the line replaced it.
          if (
            !(request.status >= 200 && request.status < 300) &&
            !request.replaced &&
            !request.settled
          ) {
            _this.failed_quantities[slot] = requested_quantity;
            if (identity) {
              _this.failed_lines[slot] = identity;
            }
            _this.showFailedChanges(false);
          }
          // GC-194: the burst ended on a failed change (an error, a timeout, a refusal),
          // and the earlier ones skipped their re-render: show the true cart. Not when a
          // newer tap on the line replaced this change.
          burst_ended =
            !request.rendered &&
            !request.replaced &&
            !_this.quantity_queue.length;
          // GC-208: the queue moves on and Checkout's busy flag follows first, so nothing
          // the re-render does can leave Checkout busy.
          _this.sendNextQuantity();
          _this.markChanging();
          if (burst_ended) {
            _this.updateTotals();
            _this.updateAllHtml(function () {});
          }
        };
        // A timed-out change may still land on Shopify: look once more, unless a burst
        // is running (its last change re-renders anyway).
        request.ontimeout = function () {
          setTimeout(function () {
            if (!_this.quantity_request && !_this.quantity_queue.length) {
              _this.updateTotals();
              _this.updateAllHtml(function () {});
            }
          }, 5000);
        };
        // GC-241: in flight from now on, also while it waits its turn among the page's cart
        // writes: Checkout stays busy (markChanging) and no re-render lands first (updateHtml).
        _this.quantity_request = request;
        CoreCart.write(function (done) {
          var finish, looked_again, post;
          // Every way out lets the next write go, even when the change's own ending throws.
          finish = function () {
            try {
              loadend();
            } finally {
              done();
            }
          };
          // Sends the change, by `key` when one was found (else the key drawn on the line).
          post = function (key) {
            if (key) {
              body.id = key;
            }
            try {
              request.open("POST", theme.urls.cart_change + ".js");
              request.setRequestHeader("Content-Type", "application/json");
              // GC-194: one slow change.js would hold every queued change behind it.
              request.timeout = 10000;
              request.send(JSON.stringify(body));
            } catch (error) {
              // Never sent, so no loadend: let the line and Checkout go.
              finish();
              setTimeout(function () {
                throw error;
              });
            }
          };
          // A newer tap on the line replaced it while it waited: it never goes (the quantity sent is absolute).
          if (request.replaced) {
            return finish();
          }
          request.onloadend = function () {
            // GC-241: refused for its key (400, "no valid id or line parameter"): a write the queue doesn't see
            // (Route's widget, another tab) renewed it. Looks the line up once and sends again; a removal of a
            // line that is gone has nothing left to do.
            if (request.status === 400 && !looked_again && identity && slot !== line_num && !request.replaced) {
              looked_again = true;
              return _this.currentKey(identity, true, function (key) {
                if (key === false) {
                  request.settled = requested_quantity === 0;
                }
                if (!key || request.replaced) {
                  return finish();
                }
                post(key);
              });
            }
            finish();
          };
          // GC-241: by the line's key as it is now, not as it was at the tap. A line not found goes with its drawn
          // key, and the look again above decides.
          _this.currentKey(slot === line_num ? null : identity, false, function (key) {
            // Replaced while the cart was read.
            if (request.replaced) {
              return finish();
            }
            post(key);
          });
        });
        return request;
      };
      // GC-194: queued now, so changes keep the order they were tapped in; each goes once
      // its debounce is over (0: the next tick), never ahead of an earlier waiting tap.
      job = { slot: slot, send: ajaxQuantity, ready: false };
      // The typed-quantity check compares with data-quantity; while re-renders wait for
      // the burst to end, keep it at the quantity this line is about to get.
      cart_item.attr("data-quantity", requested_quantity);
      _this.quantity_queue.push(job);
      _this.markChanging();
      return (_this.quantity_timer[slot] = setTimeout(function () {
        delete _this.quantity_timer[slot];
        job.ready = true;
        return _this.sendNextQuantity();
      }, time_out));
    };

    CoreCart.prototype.noteTypingListener = function () {
      var _this, note_textbox;
      _this = this;
      note_textbox = _this.root.find(".cart--notes--textarea");
      return note_textbox.on("input", function () {
        if (_this.note_request) {
          _this.note_request.abort();
        }
        if (_this.note_timer) {
          clearTimeout(_this.note_timer);
        }
        return _this.updateNote(this.value);
      });
    };

    CoreCart.prototype.updateNote = function (note) {
      var _this, ajaxNote;
      _this = this;
      ajaxNote = function () {
        var request;
        request = new XMLHttpRequest();
        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            return _this.other_carts.trigger("update-html");
          }
        };
        request.onerror = function () {
          return console.log(
            request.statusText + ": cart note update request failed!",
          );
        };
        _this.note_request = request;
        // GC-241: one cart write at a time.
        CoreCart.write(function (done) {
          // Typing went on while it waited: only the newest note goes (abort() can't stop an unsent request).
          if (_this.note_request !== request) {
            return done();
          }
          request.onloadend = done;
          request.open("POST", theme.urls.cart + "/update.js");
          request.setRequestHeader("Content-Type", "application/json");
          request.send(
            JSON.stringify({
              note: note,
            }),
          );
        });
        return request;
      };
      return (_this.note_timer = setTimeout(ajaxNote, 350));
    };

    // Swaps .cart--form only. Pair it with updateTotals() (as addItem and
    // updateQuantity do): that alone sets the header badges, so an updateAllHtml()
    // on its own leaves them stale (GC-102). Since GC-208 the swap also copies the
    // drawn cart's .cart--root[data-has-items], so the empty state follows it.
    CoreCart.prototype.updateAllHtml = function (update_all_html_done) {
      var _this;
      _this = this;
      _this.updateHtml(update_all_html_done);
      return _this.other_carts.trigger("update-html");
    };

    CoreCart.prototype.htmlListener = function () {
      var _this;
      _this = this;
      return _this.root.on("update-html", function () {
        return _this.updateHtml(function () {});
      });
    };

    CoreCart.prototype.updateHtml = function (update_all_html_done) {
      var _this, drawn, seq;
      _this = this;
      seq = _this.html_seq = (_this.html_seq || 0) + 1;
      // GC-241: the cart writes this drawing shows (currentKey). Taken now: a write finishing while it is on
      // its way may or may not be in it. One that has landed already is (the redraw after a change or an add).
      drawn = Math.max(CoreCart.writes_done, CoreCart.writes_landed);
      return _this.getHtml(_this.view, function (new_html) {
        var cart_updated_event, focus_class, focus_line, focus_target, focused, new_form, old_form;
        old_form = _this.root.find(".cart--form");
        new_form = new_html.find(".cart--form");
        // GC-194: a re-render that left before a tap must not land in the middle of a
        // burst either: it would put the line's box back while a change is still queued
        // or in flight, and the next tap would send the old number. The burst's last
        // change re-renders (and fires theme:cart:updated; until then the free-gift logic
        // would read lines older than the cart).
        if (_this.quantity_request || _this.quantity_queue.length) {
          return update_all_html_done();
        }
        // GC-194: a re-render answering after a newer one was shown would put back a cart
        // from before the latest change. Keep the newer cart, but still call the done-callback
        // (it opens the drawer, re-enables a checkbox, continues the gift logic).
        if (seq < (_this.html_shown || 0)) {
          update_all_html_done();
          // The free-gift logic may have waited on this re-render (its done-callback
          // clears its guard): let it run again on the cart that is shown.
          return window.dispatchEvent(new Event("theme:cart:updated"));
        }
        _this.html_shown = seq;
        new_form = _this.swapInImages(old_form, new_form);
        // The swap destroys the focused control. Remember it by its line number
        // and first class, so keyboard users land on its twin, not on <body>.
        // (el() collections hold their nodes in .el, not at numeric indexes.)
        focused = document.activeElement;
        if (focused && old_form.el[0] && old_form.el[0].contains(focused)) {
          focus_line = focused.closest(".cart--item") ? focused.closest(".cart--item").getAttribute("data-line-num") : null;
          focus_class = (focused.getAttribute("class") || "").split(" ")[0];
        }
        old_form.replaceWith(new_form);
        _this.drawn_writes = drawn;
        // GC-208: the drawn cart says whether it has items (cart.liquid), so the empty-cart
        // message (outside .cart--form) no longer waits on updateTotals()'s /cart.js, which
        // a rate limit can leave unanswered.
        if (new_html.attr("data-has-items") != null) {
          _this.root.attr("data-has-items", new_html.attr("data-has-items"));
        }
        _this.eventListeners();
        // GC-241: the swapped-in Checkout gets the busy state too while a write still waits.
        _this.markChanging();
        _this.showFailedChanges(true);
        update_all_html_done();
        if (_this.is_drawer) {
          theme.partials.OffCanvas.unload();
          theme.partials.OffCanvas.load();
        }
        if (focus_class) {
          focus_target = (focus_line ? new_form.find(".cart--item[data-line-num='" + focus_line + "']") : new_form).find("." + focus_class).el[0];
          // The line is gone (removed): fall back to the drawer's close button, or the page's heading (047).
          focus_target = focus_target || new_form.find("[data-cart-focus-fallback]").el[0];
          if (focus_target) {
            focus_target.focus({ preventScroll: true });
          }
        }
        cart_updated_event = new Event("theme:cart:updated");
        return window.dispatchEvent(cart_updated_event);
      });
    };

    // The section that renders the drawer (layout/theme.liquid), and its HTML
    // from a cart request's "sections" answer, or null when it isn't there.
    CoreCart.DRAWER_SECTION = "cart-drawer";

    CoreCart.drawerHtml = function (response) {
      try {
        return (JSON.parse(response).sections || {})[CoreCart.DRAWER_SECTION] || null;
      } catch (error) {
        return null;
      }
    };

    CoreCart.prototype.getHtml = function (view, callback) {
      var _this, cart_html, load, tries, url;
      _this = this;
      // A quantity change already brought the drawer back (updateQuantity).
      if (_this.next_html) {
        cart_html = theme.utils.parseHtml(_this.next_html, ".cart--root");
        _this.next_html = null;
        if (cart_html) {
          return callback(cart_html);
        }
      }
      url = theme.urls.cart + "?view=ajax-desktop";
      if (view === "mobile" && _this.is_drawer) {
        url = theme.urls.cart + "?view=ajax-drawer";
      } else if (view === "mobile") {
        url = theme.urls.cart + "?view=ajax-mobile";
      } else if (view === "page") {
        // Feature 047: the /cart page redraws its own section (Section Rendering API), so the redraw
        // has the settings of the first paint (suggestions, trust lines, empty-cart menu).
        url = theme.urls.cart + "?section_id=" + encodeURIComponent(_this.root.attr("data-section-id"));
      }
      // GC-319: an answer that isn't a 2xx (Shopify's 429 rate limit on a shared phone network) or a dropped
      // connection used to end here with the callback never called: the drawer kept the cart it had, and
      // anything waiting on the redraw (the gift routine's guard, a busy "Add it back") waited for ever.
      // Ask again, twice, a little later. A retry's answer that a cart write may have overtaken (one
      // running, waiting, or finished since the retry went out) is a cart from before that write: it is
      // dropped, and that write's own redraw shows the cart.
      tries = 0;
      load = function () {
        var request = new XMLHttpRequest();
        var sent = Math.max(CoreCart.writes_done, CoreCart.writes_landed);
        var again = function () {
          if (tries < CoreCart.HTML_RETRIES) {
            tries += 1;
            setTimeout(load, 1200 * tries);
          }
        };
        request.onload = function () {
          var cart_html;
          if (request.status >= 200 && request.status < 300) {
            if (tries > 0 && (CoreCart.writing || CoreCart.writes.length || _this.quantity_request || _this.quantity_queue.length ||
              Math.max(CoreCart.writes_done, CoreCart.writes_landed) !== sent)) {
              return again();
            }
            cart_html = theme.utils.parseHtml(request.response, ".cart--root");
            return callback(cart_html);
          }
          again();
        };
        request.onerror = function () {
          console.log(request.statusText + ": cart HTML update request failed!");
          again();
        };
        request.open("GET", url);
        request.send();
      };
      return load();
    };

    CoreCart.prototype.swapInImages = function (old_html, new_html) {
      var _this, new_items;
      _this = this;
      new_items = new_html.find(".cart--item");
      new_items.each(function (new_item) {
        var new_image,
          new_instance,
          new_item_el,
          old_image,
          old_item,
          variant_id;
        new_item_el = el(new_item);
        variant_id = new_item_el.attr("data-variant-id");
        new_image = new_item_el.find(".cart--item--image");
        new_instance = new_html
          .find("[data-variant-id='" + variant_id + "'] .cart--item--image")
          .index(new_image);
        old_item = old_html
          .find("[data-variant-id='" + variant_id + "']")
          .eq(new_instance);
        if (old_item.el.length) {
          old_image = old_item.find(".cart--item--image");
          return new_image.replaceWith(old_image);
        }
      });
      return new_html;
    };

    /**
     * GC-90: adds the form's variant as {items: [...]}, the one body Shopify
     * checks stock for: it answers 422 for a sold-out variant, while
     * {id, quantity} and form posts add it anyway. Calls back exactly once.
     * @param {HTMLFormElement|{id: (number|string), quantity: (number|string)=,
     *   properties: Object=}} form_or_item - A product form (id, quantity,
     *   properties), or the item itself (the drawer's recommendation buttons
     *   have no form).
     * @param {function(boolean, ?string, string=)} callback - (added, problem,
     *   message): problem is null, "partial" (added what was in stock),
     *   "in_cart", "sold_out" or "error"; message is Shopify's sentence.
     * @returns {void}
     */
    CoreCart.prototype.addItem = function (form_or_item, callback) {
      var _this, added, before, form_data, item, request, source;
      _this = this;
      // GC-187: what was tapped (the form, or the item's `source` element), passed on in
      // "theme:cart:added" so snippets/suggestion-tracking.liquid can tell a suggestion's add.
      source =
        form_or_item instanceof HTMLFormElement
          ? form_or_item
          : form_or_item.source || null;
      added = function () {
        window.dispatchEvent(
          new CustomEvent("theme:cart:added", { detail: { source: source } }),
        );
      };
      if (form_or_item instanceof HTMLFormElement) {
        form_data = new FormData(form_or_item);
        item = {
          id: form_data.get("id"),
          quantity: form_data.get("quantity"),
          properties: {},
        };
        form_data.forEach(function (value, key) {
          var property = key.match(/^properties\[(.+)\]$/);
          if (property) {
            item.properties[property[1]] = value;
          }
        });
        if (form_data.get("selling_plan")) {
          item.selling_plan = Number(form_data.get("selling_plan"));
        }
      } else {
        item = {
          id: form_or_item.id,
          quantity: form_or_item.quantity,
          properties: form_or_item.properties || {},
        };
      }
      // A Number: the 422 check compares it with /cart.js's variant_id.
      item.id = Number(item.id);
      item.quantity = Math.max(1, parseInt(item.quantity, 10) || 1);
      // No variant: Shopify's 422 for it would read as "sold out".
      if (!(item.id > 0)) {
        return callback(false, "error");
      }
      // GC-241: one cart write at a time, so an add tapped while another is on its way never loses either.
      CoreCart.write(function (done) {
        var check, checking;
        // Read at its turn, not at the tap: an add of the same variant ahead of it has grown the
        // count, and holds the queue until its own cart read (updateTotals) has stored the new one.
        before = theme.classes.Cart.storedQuantity(item.id);
        // A 422 can still add part of an over-stock request: asks the cart, and holds the next
        // write until it knows.
        check = function (message) {
          checking = true;
          setTimeout(done, CoreCart.READ_WAIT);
          return _this.updateTotals(function (cart) {
            var now;
            done();
            if (!cart) {
              return callback(false, "error");
            }
            now = cart.items
              .filter(function (line) {
                return line.variant_id === item.id;
              })
              .reduce(function (sum, line) {
                return sum + line.quantity;
              }, 0);
            if (now > before) {
              added();
              return callback(true, "partial", message);
            }
            return callback(false, now > 0 ? "in_cart" : "sold_out", message);
          });
        };
        request = new XMLHttpRequest();
        request.onload = function () {
          var message;
          if (request.status >= 200 && request.status < 300) {
            CoreCart.writes_landed = CoreCart.writes_done + 1;
            // The next write goes once the cart is read again (see `before`), not after the redraw.
            checking = true;
            setTimeout(done, CoreCart.READ_WAIT);
            _this.updateTotals(done);
            added();
            return callback(true, null);
          }
          if (request.status !== 422) {
            return callback(false, "error");
          }
          try {
            message = JSON.parse(request.response).description;
          } catch (error) {
            message = null;
          }
          return check(message);
        };
        request.onerror = function () {
          console.log(request.statusText + ": cart add item request failed!");
          return callback(false, "error");
        };
        // No time limit of its own: a slow add still lands (on a throttled connection one took 10 s), so
        // giving up would say "Couldn't add" for an item in the cart. CoreCart.WRITE_WAIT keeps one
        // that never answers from holding the other writes.
        // After load, error or abort, even when a callback above threw. Not while the cart is being
        // read (checking): that read releases the queue.
        request.onloadend = function () {
          if (!checking) {
            done();
          }
        };
        request.open("POST", theme.urls.cart_add + ".js");
        request.setRequestHeader("Content-Type", "application/json");
        request.setRequestHeader("Accept", "application/json");
        request.send(JSON.stringify({ items: [item] }));
      });
    };

    CoreCart.prototype.updateAllHasItems = function (item_count, force_true) {
      var _this, has_items;
      if (force_true == null) {
        force_true = false;
      }
      _this = this;
      has_items = false;
      if (item_count > 0 || force_true) {
        has_items = true;
      }
      _this.root.attr("data-has-items", has_items);
      return _this.other_carts.attr("data-has-items", has_items);
    };

    /**
     * GC-242: tells the page the cart has settled, so other code can read the cart from the event, not from the
     * drawer's markup: `theme:cart:settled` on window, with detail.items (/cart.js's lines, gifts and fees too) and
     * detail.count (what the header shows). It says nothing while a write runs or waits or a quantity tap is queued,
     * or for a read that left before the latest write began: that write's own read speaks for it. So one change can
     * fire it more than once (a gift follows), a refused read never fires it, and it can come before or after the
     * drawer's redraw (`theme:cart:updated`).
     * @param {Object} data - /cart.js's answer
     * @param {number} count - the count in the header
     * @param {number} begun - the cart writes begun when this read left
     * @returns {void}
     */
    CoreCart.saySettled = function (data, count, begun) {
      var waiting = CoreCart.carts.some(function (cart) {
        return cart.quantity_request || cart.quantity_queue.length;
      });
      if (CoreCart.writing || CoreCart.writes.length || waiting || begun !== CoreCart.writes_done) {
        return;
      }
      window.dispatchEvent(new CustomEvent("theme:cart:settled", { detail: { items: data.items, count: count } }));
    };

    /**
     * Refreshes the totals, the header badges and .cart--root[data-has-items].
     * @param {function(?Object)=} done - Called with /cart.js's data, or null
     *   when it couldn't be read.
     * @returns {void}
     */
    CoreCart.prototype.updateTotals = function (done) {
      var _this, begun, request;
      _this = this;
      done = done || function () {};
      // GC-242: a write begun after this leaves may not show in its answer (CoreCart.saySettled).
      begun = CoreCart.writes_done + (CoreCart.writing ? 1 : 0);
      request = new XMLHttpRequest();
      request.onload = function () {
        var count, data, total_price;
        if (request.status >= 200 && request.status < 300) {
          try {
            data = JSON.parse(request.response);
          } catch (error) {
            // Shopify answers its rate-limit page as HTML.
            return done(null);
          }
          theme.classes.Cart.setItems(data.items);
          total_price = theme.utils.formatMoney(data.total_price);
          // Fee line items (Route shipping protection) are hidden from the
          // rendered item list by snippets/cart.liquid, so they must not be
          // counted here either — otherwise the header badge over-counts, and
          // a cart holding ONLY a fee line is flagged has-items and renders
          // blank (Liquid emits the empty state, this flag would hide it).
          count = theme.utils.visibleCartItemCount(data);
          _this.total_price.forEach(function (price) {
            return (price.innerHtml = total_price);
          });
          _this.total_item_count.forEach(function (item_count) {
            return (item_count.textContent = count);
          });
          _this.updateAllHasItems(count);
          _this.updateTotalsComplete(count);
          // First: an add holds the queue until its read is back, and done lets the next write go.
          done(data);
          return CoreCart.saySettled(data, count, begun);
        }
        return done(null);
      };
      request.onerror = function () {
        console.log(request.statusText + ": error updating cart totals!");
        return done(null);
      };
      request.open("GET", theme.urls.cart + ".js");
      return request.send();
    };

    // Shopify draws express checkout buttons once per page: on /cart they belong to the page's summary,
    // not the drawer. (Since feature 047 the page is one cart, so there is no second, desktop copy to drop.)
    CoreCart.prototype.renderDynamicCheckoutButtons = function () {
      var buttons;
      if (window.location.pathname === theme.urls.cart) {
        buttons = document.querySelector(
          ".off-canvas--right-sidebar .cart--additional-buttons",
        );
        if (buttons) {
          buttons.parentNode.removeChild(buttons);
        }
      }
    };

    CoreCart.getItems = function () {
      var request;
      request = new XMLHttpRequest();
      request.onload = function () {
        var data;
        if (request.status >= 200 && request.status < 300) {
          data = JSON.parse(request.response);
          theme.classes.Cart.setItems(data.items);
          // GC-278: the first read of a page load may differ from what was stored (an order paid, another tab); the cards' counts follow it.
          if (theme.cardCounts) {
            theme.cardCounts();
          }
          return;
        }
      };
      request.onerror = function () {
        return console.log(
          request.statusText + ": error updating cart totals!",
        );
      };
      request.open("GET", theme.urls.cart + ".js");
      return request.send();
    };

    /**
     * The quantity of a variant in the cart as last read from /cart.js.
     * @param {number|string} variant_id - The variant.
     * @returns {number} 0 before the first read (first visit) or when storage
     *   is unavailable.
     */
    CoreCart.storedQuantity = function (variant_id) {
      var cart_items;
      try {
        cart_items = JSON.parse(
          localStorage.getItem(theme.local_storage.cart_items),
        );
      } catch (error) {
        cart_items = null;
      }
      return (cart_items && cart_items[variant_id]) || 0;
    };

    CoreCart.setItems = function (data_items) {
      var cart_items;
      cart_items = {};
      // Summed: one variant can sit on several lines (line-item properties).
      data_items.forEach(function (item) {
        return (cart_items[item.id] =
          (cart_items[item.id] || 0) + item.quantity);
      });
      // Blocked or full storage must not stop updateTotals() calling back.
      try {
        localStorage.setItem(
          theme.local_storage.cart_items,
          JSON.stringify(cart_items),
        );
      } catch (error) {}
    };

    return CoreCart;
  })();

  /**
   * Opens the cart drawer on the cart view, if it is closed.
   * @param {?HTMLElement} return_focus - Gets focus back when the drawer closes.
   * @returns {void}
   */
  theme.showCartDrawer = function (return_focus) {
    var off_canvas = theme.partials.OffCanvas;
    off_canvas.right_sidebar.attr("data-active", "cart");
    if (off_canvas.state === "closed") {
      off_canvas.right_sidebar_view = "cart";
      off_canvas.openRight();
      off_canvas.last_trigger = return_focus;
    }
    // GC-273: photos drawn while the drawer was shut are checked again now that it is on screen.
    if (window.lazySizes && lazySizes.loader && lazySizes.loader.checkElems) {
      lazySizes.loader.checkElems();
    }
  };

  // GC-278: a product card (grids, facelift cards) or a Maker card's quick-add button.
  var CARD_SELECTOR = ".bs-card, .gcf-card, .product--quick-add";

  /**
   * GC-278: is this add button on a product card (home, collections, bundle, a page's suggestions)?
   * Not the drawer's own suggestions: the drawer is open there already.
   * @param {?HTMLElement} trigger - The add button.
   * @returns {boolean}
   */
  theme.isCardAdd = function (trigger) {
    return !!(
      trigger &&
      trigger.closest &&
      trigger.closest(CARD_SELECTOR) &&
      !trigger.closest(".cart--root, .off-canvas--right-sidebar")
    );
  };

  /**
   * GC-278: marks a card's Add button busy while its add is on its way (a tap on it is ignored). The
   * add's callback clears it; a timer does too, so a request that never answers cannot leave it dead.
   * @param {HTMLElement} btn - The card's add button.
   * @returns {void}
   */
  theme.cardBusy = function (btn) {
    btn.dataset.gcBusy = "1";
    setTimeout(function () {
      delete btn.dataset.gcBusy;
    }, 30000);
  };

  // GC-278: a card's Add button label, kept so Added and the spinner can give it back unchanged.
  var CARD_LABELS = new WeakMap();
  var CHECK_ICON =
    '<svg class="card-add-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12.5l5 5L20 6.5"/></svg>';

  /**
   * GC-278: puts a card's Add button in a state: "adding" (a spinner, for buttons without their own),
   * "added" (a check and Added for 1.2 s, the word hidden on a facelift card, then the label comes back) or "reset" (the label now).
   * @param {HTMLElement} btn - The card's add button.
   * @param {string} state - adding, added or reset.
   * @returns {void}
   */
  theme.cardLabelSet = function (btn, state) {
    var el = btn.querySelector(".product-form--text, .add_cart_btn") || btn;
    var saved = CARD_LABELS.get(btn);
    if (state === "reset" && !saved) {
      return;
    }
    if (!saved) {
      // dataset.label: during a refused add's notice (cartAddNotice) the real label is kept there, and the element shows the notice.
      saved = { html: el.dataset.label || el.innerHTML };
      CARD_LABELS.set(btn, saved);
    }
    clearTimeout(saved.timer);
    if (state === "reset") {
      el.innerHTML = saved.html;
      btn.classList.remove("is-adding", "is-added");
      CARD_LABELS.delete(btn);
    } else if (state === "adding") {
      // A button with its own spinner (the grid cards: data-loading) shows that one.
      if (!btn.querySelector(".product-form--spinner")) {
        el.innerHTML = '<span class="card-add-spin" aria-hidden="true"></span>';
        btn.classList.add("is-adding");
      }
    } else if (state === "added") {
      el.innerHTML = CHECK_ICON;
      var word = document.createElement("span");
      word.className = "card-add-word"; // the facelift card shows the check alone (GC-278); the word stays for screen readers and other cards
      word.textContent = theme.translations.card_added;
      el.appendChild(word);
      btn.classList.remove("is-adding");
      btn.classList.add("is-added");
      saved.timer = setTimeout(function () {
        theme.cardLabelSet(btn, "reset");
      }, 1200);
    }
  };

  /**
   * GC-278: header cart icon nudge, for a page whose pinned cart bar is not showing (tablet and desktop,
   * or the bar hidden). The count's pop is in Cart.updateTotalsComplete.
   * @returns {void}
   */
  theme.cartNudge = function () {
    document.querySelectorAll("[data-cart-link]").forEach(function (link) {
      link.classList.remove("cart-nudge");
      void link.offsetWidth; // restart the animation on a quick second add
      link.classList.add("cart-nudge");
    });
  };

  /**
   * GC-278: what a card's add does instead of opening the drawer: the button says Added, the pinned
   * cart bar (snippets/cart-progress-sticky.liquid) slides to the product's photo and name with the photo
   * (or, with no bar on screen, the header icon nudges), the count pops (Cart.updateTotalsComplete), and
   * the drawer's HTML refreshes behind the page, which also runs the free-gift tiers.
   * @param {HTMLElement} trigger - The card's add button.
   * @returns {void}
   */
  theme.cardAdded = function (trigger) {
    theme.cardLabelSet(trigger, "added");
    var card = trigger.closest(CARD_SELECTOR);
    var title = card && card.querySelector(".bs-title, .gcf-card__title");
    var root = trigger.closest("[data-title]");
    var name = (title && title.textContent.trim()) || (root && root.dataset.title) || "";
    var said = name
      ? theme.translations.card_added_message
          .replace("[name]", function () {
            return name; // a function: a "$&" in a product name stays as written
          })
          .replace(/\s+/g, " ")
          .trim()
      : theme.translations.card_added;
    // The first photo or video poster in the card that is a real file (a lazy one may still be a placeholder).
    var thumb = "";
    if (card) {
      Array.prototype.some.call(card.querySelectorAll(".bs-media img, .bs-media video, .gcf-card__media img, .gcf-card__media video"), function (media) {
        var url = media.tagName === "VIDEO" ? media.poster : media.complete && media.naturalWidth ? media.currentSrc || media.src : "";
        if (/^(https?:)?\/\//.test(url)) {
          thumb = url;
          return true;
        }
        return false;
      });
    }
    theme.announce(said);
    var sticky = window.gcCartSticky;
    // The bar shows the photo and the name alone (James, 3 Nov): the bar is the cart link, the count pops, the word is announced above.
    if (!(sticky && sticky.confirm(name, thumb))) {
      theme.cartNudge();
    }
    theme.partials.Cart.updateAllHtml(function () {});
  };

  /**
   * GC-278: the count on a facelift card's Add (a gold badge, CSS: button[data-count]::after): how many of its variant
   * the cart holds, from the quantities stored at the last cart read. Run at load, on every settled cart and when a page
   * comes back from the history cache. A card drawn later (a filter that redraws a grid) gets its count at the next cart change.
   * @returns {void}
   */
  theme.cardCounts = function () {
    document.querySelectorAll(".gcf-card__row form[data-gcf-add]").forEach(function (form) {
      var id = form.elements.id && form.elements.id.value;
      var button = form.querySelector("button[type=submit]");
      var count = id && theme.classes.Cart ? theme.classes.Cart.storedQuantity(id) : 0;
      if (button) {
        // The badge is CSS content, which a button's aria-label hides: the count goes in the name too ("Add X to cart, In cart 2").
        if (!("labelBase" in button.dataset)) {
          button.dataset.labelBase = button.getAttribute("aria-label") || "";
        }
        if (count > 0) {
          button.dataset.count = count > 99 ? "99+" : String(count);
        } else {
          delete button.dataset.count;
        }
        if (button.dataset.labelBase) {
          button.setAttribute(
            "aria-label",
            count > 0 ? button.dataset.labelBase + ", " + theme.translations.card_add_in_cart + " " + count : button.dataset.labelBase
          );
        }
      }
    });
  };
  window.addEventListener("theme:cart:settled", theme.cardCounts);
  // Not run at once: this script has not defined theme.classes.Cart yet. DOMContentLoaded comes after it; pageshow covers a script that ran late.
  document.addEventListener("DOMContentLoaded", theme.cardCounts);
  window.addEventListener("pageshow", theme.cardCounts);

  /**
   * GC-90: the one way an add opens the cart drawer, after CoreCart.addItem
   * (which already refreshed the totals and badges).
   * @param {?HTMLElement} trigger - Gets focus back when the drawer closes;
   *   closeRight() throws if none was set.
   * @returns {void}
   */
  theme.openCartDrawer = function (trigger) {
    // Feature 047 (D4): /cart shows the cart itself, so an add there (a suggestion, recently viewed)
    // redraws the page and every other cart, and no drawer opens over the same cart.
    if (document.body.classList.contains("template--cart")) {
      theme.partials.Cart.updateAllHtml(function () {
        // The page's subtotal (summary, phone bar) changes in view; say it too. Suggestions say their own.
        if (!(trigger && trigger.closest && trigger.closest(".cart-recommendations"))) {
          theme.announce(theme.translations.cart_added);
        }
      });
      return;
    }
    // GC-278: a card's Add keeps the shopper on the page; only a page's own Add to Cart opens the drawer.
    if (theme.isCardAdd(trigger)) {
      theme.cardAdded(trigger);
      return;
    }
    // Taken now: focus can move while a page holds the drawer back (below).
    var return_focus = trigger || document.activeElement;
    // GC-203: a page can hold the drawer back for a moment, in ms (Night Drop's photo flying into
    // the cart icon, assets/pdp-night-drop.js). Asked now, as the add has gone through, so that wait
    // runs while the drawer refreshes; the drawer opens once both are done.
    var wait = 0;
    if (typeof theme.cartDrawerDelay === "function") {
      try {
        wait = Math.min(Number(theme.cartDrawerDelay(trigger)) || 0, 1500);
      } catch (error) {}
    }
    var ready_at = Date.now() + wait;
    theme.partials.Cart.updateAllHtml(function () {
      var open = function () {
        theme.showCartDrawer(return_focus);
      };
      var left = ready_at - Date.now();
      if (left > 0) {
        setTimeout(open, left);
      } else {
        open();
      }
    });
  };

  /**
   * GC-90, GC-195: says a short message in the page's one polite status
   * region, #cart-add-status (made on first use).
   * @param {string} text - What to say.
   * @returns {void}
   */
  theme.announce = function (text) {
    var region = document.getElementById("cart-add-status");
    if (!region) {
      region = document.createElement("p");
      region.id = "cart-add-status";
      region.className = "visually-hidden";
      region.setAttribute("role", "status");
      document.body.appendChild(region);
    }
    // Emptied, then filled a beat later, so a repeat is said again.
    region.textContent = "";
    setTimeout(function () {
      region.textContent = text;
    }, 100);
  };

  /**
   * GC-90: what an add-to-cart button says when Shopify refused all or part
   * of an add. "Just sold out" stays and disables the button; the rest go back
   * after a few seconds. A button's text change isn't announced, so it's also
   * said in a status region.
   * @param {?HTMLElement} button - The add button (a quick-add <div> too).
   * @param {?HTMLElement} text_el - The element holding its label.
   * @param {?string} problem - From CoreCart.addItem; null does nothing.
   * @param {string=} message - Shopify's sentence, if any.
   * @returns {void}
   */
  theme.cartAddNotice = function (button, text_el, problem, message) {
    var label, said, text;
    text = {
      error: theme.translations.add_failed,
      in_cart: theme.translations.add_in_cart,
      partial: message,
      sold_out: theme.translations.add_sold_out,
    }[problem];
    if (!text || !button || !text_el) {
      return;
    }
    said = message || text;
    // GC-278: a product card's button (not the drawer's own suggestions) is about 70 px wide in a 136 px row: it says one short word (Retry, In cart, Limit,
    // Sold out) and the whole sentence is announced instead, so the button never outgrows the card.
    if (theme.isCardAdd(button)) {
      text =
        {
          error: theme.translations.card_add_error,
          in_cart: theme.translations.card_add_in_cart,
          partial: theme.translations.card_add_limit,
          sold_out: theme.translations.card_add_sold_out,
        }[problem] || text;
    }
    theme.cardLabelSet(button, "reset"); // GC-278: a card's spinner or Added gives way to the message
    theme.announce(said);
    if (problem === "sold_out") {
      if (button.tagName === "BUTTON") {
        button.disabled = true;
      } else {
        button.setAttribute("aria-disabled", "true");
      }
      text_el.textContent = text;
      return;
    }
    // A second notice before the first ends keeps the button's own label.
    label = text_el.dataset.label || text_el.innerHTML; // html: a card's label has an icon (GC-278)
    text_el.dataset.label = label;
    text_el.textContent = text;
    setTimeout(
      function () {
        // Unless something else (a variant change) relabelled it meanwhile.
        if (text_el.textContent === text) {
          text_el.innerHTML = label;
        }
        delete text_el.dataset.label;
      },
      problem === "partial" ? 4000 : 2000,
    );
  };

  theme.classes.CoreCollection = (function () {
    function CoreCollection(root) {
      var _this;
      this.root = root;
      this.clearPriceFilter = bind(this.clearPriceFilter, this);
      this.clearSortFilter = bind(this.clearSortFilter, this);
      this.activeTagListeners = bind(this.activeTagListeners, this);
      this.activePriceListener = bind(this.activePriceListener, this);
      this.activeSortListener = bind(this.activeSortListener, this);
      this.toggleActiveTags = bind(this.toggleActiveTags, this);
      this.renderActiveTags = bind(this.renderActiveTags, this);
      this.renderActivePrice = bind(this.renderActivePrice, this);
      this.renderActiveSort = bind(this.renderActiveSort, this);
      this.formatProducts = bind(this.formatProducts, this);
      this.renderGridHtml = bind(this.renderGridHtml, this);
      this.getGridHtml = bind(this.getGridHtml, this);
      this.getAjaxUrl = bind(this.getAjaxUrl, this);
      this.showLoadingView = bind(this.showLoadingView, this);
      this.tagListener = bind(this.tagListener, this);
      this.priceListeners = bind(this.priceListeners, this);
      this.sortListener = bind(this.sortListener, this);
      this.browseListener = bind(this.browseListener, this);
      this.clearAllListener = bind(this.clearAllListener, this);
      this.menuToggleListeners = bind(this.menuToggleListeners, this);
      this.moveFilterOffCanvas = bind(this.moveFilterOffCanvas, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.layoutListener = bind(this.layoutListener, this);
      this.setLayout = bind(this.setLayout, this);
      this.initLayout = bind(this.initLayout, this);
      this.hoverImagesLoaded = bind(this.hoverImagesLoaded, this);
      this.resizeListeners = bind(this.resizeListeners, this);
      this.sectionListeners = bind(this.sectionListeners, this);
      this.initFilter = bind(this.initFilter, this);
      this.initNavigation = bind(this.initNavigation, this);
      this.initGrid = bind(this.initGrid, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.load();
    }

    CoreCollection.prototype.load = function () {
      var _this;
      _this = this;
      _this.initGrid();
      _this.initNavigation();
      _this.initFilter();
      _this.sectionListeners();
      return _this.resizeListeners();
    };

    CoreCollection.prototype.initGrid = function () {
      var _this;
      _this = this;
      _this.body = _this.root.find(".collection--body--root");
      _this.current_width = window.innerWidth;
      _this.grid_container = _this.body.find(".collection--body--grid");
      _this.max_columns = _this.body.data("max-columns");
      _this.num_columns = _this.grid_container.data("columns");
      _this.pagination_link = _this.body.find(
        '[href="#collection-pagination"]',
      );
      _this.spinner = _this.body.find(".collection--body--spinner");
      _this.pagination = _this.body.find(".collection--body--pagination");
      _this.url = _this.body.attr("data-url");
      if (theme.settings.hover_image_enabled) {
        return _this.hoverImagesLoaded();
      }
    };

    CoreCollection.prototype.initNavigation = function () {
      var _this;
      _this = this;
      _this.navigation = _this.root.find(".collection--navigation--root");
      _this.active_options_container = _this.navigation.find(
        ".collection--navigation--options-container",
      );
      _this.active_sort_container = _this.navigation.find(
        ".collection--navigation--active-sort",
      );
      _this.active_price_container = _this.navigation.find(
        ".collection--navigation--active-price",
      );
      _this.active_tags_wrapper = _this.navigation.find(
        ".collection--navigation--active-options",
      );
      _this.clear_tags_button = _this.navigation.find(
        ".collection--navigation--options-clear",
      );
      _this.layout_buttons = _this.navigation.find(
        ".collection--navigation--layout > *",
      );
      _this.small_layout_button = _this.layout_buttons.eq(1);
      _this.tag_template = _this.navigation.find(
        ".collection--navigation--active-tag",
      );
      _this.tag_template_html = _this.tag_template.outerHtml();
      if (_this.layout_buttons.length && _this.max_columns > 2) {
        _this.initLayout();
        _this.setLayout();
        return _this.layoutListener();
      } else {
        _this.layout_buttons.hide();
        return _this.matchImageHeights();
      }
    };

    CoreCollection.prototype.initFilter = function () {
      var _this, current_sort_input;
      _this = this;
      _this.filter = _this.root.find(".collection--filter--root");
      if (!_this.filter.length) {
        return;
      }
      _this.moveFilterOffCanvas();
      _this.browse_links = _this.filter.find(
        ".collection--filter--browse-link",
      );
      _this.filter_form = _this.filter.el[0].querySelector(
        ".collection--filter--form",
      );
      _this.menu_toggles = _this.filter.find(".collection--filter--toggle");
      _this.tag_links = _this.filter.find(".collection--filter--refine-label");
      _this.price_inputs = _this.filter.find(
        ".collection--filter--price-input",
      );
      _this.reset_button = _this.filter.find(".collection--filter--reset");
      _this.sort_links = _this.filter.find(".collection--filter--sort-label");
      if (_this.menu_toggles.length) {
        _this.menuToggleListeners();
        _this.clearAllListener();
      }
      if (_this.browse_links.length) {
        _this.browseListener();
      }
      if (_this.sort_links.length) {
        _this.sort_inputs = _this.filter.find(
          ".collection--filter--sort-input",
        );
        current_sort_input = _this.sort_inputs.filter(":checked");
        _this.current_sort_value = current_sort_input.val();
        _this.current_sort_label = current_sort_input.data("label");
        _this.sortListener();
        _this.renderActiveSort();
        _this.activeSortListener();
      }
      if (_this.tag_links.length) {
        _this.tagListener();
        _this.renderActiveTags();
      }
      if (_this.price_inputs.length) {
        _this.reset_prices = _this.filter.find(
          ".collection--filter--price-remove",
        );
        _this.max_price = parseFloat(_this.price_inputs.attr("max"));
        _this.current_max = parseFloat(
          _this.price_inputs.filter("[data-max-price]").val(),
        );
        _this.current_min = parseFloat(
          _this.price_inputs.filter("[data-min-price]").val(),
        );
        _this.active_min =
          _this.active_price_container.find("[data-min-price]");
        _this.active_max =
          _this.active_price_container.find("[data-max-price]");
        _this.priceListeners();
        _this.clearPriceFilter();
        _this.renderActivePrice();
        _this.activePriceListener();
      }
      return _this.toggleActiveTags();
    };

    CoreCollection.prototype.sectionListeners = function () {
      var _this;
      _this = this;
      return _this.root.on("shopify:section:load", function () {
        theme.partials.OffCanvas.unload();
        theme.partials.OffCanvas.load();
        _this.initGrid();
        _this.initNavigation();
        _this.initFilter();
        return theme.partials.CoreSearch.searchLinks();
      });
    };

    CoreCollection.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.Collection",
        theme.utils.debounce(100, function () {
          if (_this.current_width !== window.innerWidth) {
            _this.matchImageHeights();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    CoreCollection.prototype.hoverImagesLoaded = function () {
      var _this;
      _this = this;
      return _this.body.find(".product--hover-image").each(function (image) {
        var hover_image;
        hover_image = el(image);
        return theme.utils.imagesLoaded(hover_image, function () {
          var product;
          product = hover_image.closest('[data-hover-image="true"]');
          return product.attr("data-hover-image", "loaded");
        });
      });
    };

    CoreCollection.prototype.initLayout = function () {
      var _this;
      _this = this;
      _this.layout_buttons.removeAttr("style");
      return _this.small_layout_button.attr(
        "data-column-size",
        _this.max_columns,
      );
    };

    CoreCollection.prototype.setLayout = function () {
      var _this, columns;
      _this = this;
      columns = parseInt(
        localStorage.getItem(theme.local_storage.collection_view),
      );
      if (!(columns && (columns === 2 || columns === _this.num_columns))) {
        columns = _this.num_columns;
        localStorage.setItem(theme.local_storage.collection_view, columns);
      }
      _this.grid_container.attr("data-columns", columns);
      _this.layout_buttons.attr("data-active", false);
      _this.layout_buttons
        .filter("[data-column-size='" + columns + "']")
        .attr("data-active", true);
      return _this.matchImageHeights();
    };

    CoreCollection.prototype.layoutListener = function () {
      var _this;
      _this = this;
      _this.layout_buttons.off("click keydown");
      return _this.layout_buttons.on("click keydown", function (event) {
        var column_size;
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        column_size = parseInt(this.dataset.columnSize);
        localStorage.setItem(theme.local_storage.collection_view, column_size);
        return _this.setLayout();
      });
    };

    CoreCollection.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(
        _this.grid_container,
        _this.body.find(".product--root"),
        ".product--image-wrapper:not(.stack_wrapper) ",
        _this.body.find(".featured-content--root"),
      );
    };

    CoreCollection.prototype.moveFilterOffCanvas = function () {
      var _this, off_canvas_filter_container;
      _this = this;
      off_canvas_filter_container = document.querySelector(
        '[data-view="collection-filter"]',
      );
      off_canvas_filter_container.innerHtml = "";
      return off_canvas_filter_container.appendChild(_this.filter.el[0]);
    };

    CoreCollection.prototype.menuToggleListeners = function () {
      var _this;
      _this = this;
      return _this.menu_toggles.on("click keydown", function (event) {
        var aria_expanded, selected_menu;
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        aria_expanded = this.getAttribute("aria-expanded") !== "true";
        this.setAttribute("aria-expanded", aria_expanded);
        selected_menu = this.nextElementSibling;
        if (aria_expanded) {
          return setTimeout(function () {
            return selected_menu.setAttribute("data-transition", "fade-in");
          }, 0);
        } else {
          return selected_menu.setAttribute("data-transition", "fade-out");
        }
      });
    };

    CoreCollection.prototype.clearAllListener = function () {
      var _this;
      _this = this;
      return _this.clear_tags_button
        .add(_this.reset_button)
        .on("click keydown", function (event) {
          if (event.type === "keydown" && event.key !== "Enter") {
            return;
          }
          if (_this.sort_links.length) {
            _this.clearSortFilter();
          }
          // GC-164: both exist only once a price filter or an active tag was rendered; the store has no price filter.
          if (_this.reset_prices && _this.reset_prices.length) {
            _this.reset_prices.trigger("click");
          }
          if (_this.current_active_tags && _this.current_active_tags.length) {
            return _this.current_active_tags.each(function (tag) {
              return tag.click();
            });
          }
        });
    };

    CoreCollection.prototype.browseListener = function () {
      var _this;
      _this = this;
      return _this.browse_links.on("click keydown", function (event) {
        var location_pathname, was_active;
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        was_active = this.dataset.active === "true";
        _this.browse_links.attr("data-active", false);
        if (was_active) {
          location_pathname = theme.urls.all_products_collection;
        } else {
          location_pathname = this.dataset.value;
          this.dataset.active = true;
        }
        location.href = "" + location.origin + location_pathname;
        return setTimeout(function () {
          return theme.partials.OffCanvas.closeRight();
        }, 300);
      });
    };

    CoreCollection.prototype.sortListener = function () {
      var _this;
      _this = this;
      return _this.sort_links.on("click keydown", function (event) {
        var input, remove_value;
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        input = this.previousElementSibling;
        remove_value = false;
        if (input.checked) {
          remove_value = true;
        }
        return setTimeout(function () {
          if (remove_value) {
            input.checked = false;
            _this.current_sort_value = false;
          } else {
            input.checked = true;
            _this.current_sort_label = input.dataset.label;
            _this.current_sort_value = input.value;
          }
          _this.renderActiveSort();
          _this.showLoadingView();
          return _this.getAjaxUrl();
        }, 0);
      });
    };

    CoreCollection.prototype.priceListeners = function () {
      var _this;
      _this = this;
      _this.price_inputs.on("keydown", function (event) {
        var key;
        key = event.which;
        if (
          (key < 48 || key > 57) &&
          (key < 37 || key > 40) &&
          key !== 8 &&
          key !== 9 &&
          key !== 13 &&
          key !== 65 &&
          key !== 67 &&
          key !== 86 &&
          key !== 88 &&
          key !== 91 &&
          key !== 188 &&
          key !== 190
        ) {
          return event.preventDefault();
        }
      });
      return _this.price_inputs.on("change", function () {
        var float_value;
        if (this.value === "") {
          this.dataset.empty = true;
          float_value = 0;
        } else {
          this.dataset.empty = false;
          float_value = parseFloat(this.value);
        }
        if (this.dataset.hasOwnProperty("minPrice")) {
          if (this.value === "") {
            _this.current_min = 0;
          } else if (float_value > _this.current_max) {
            this.value = _this.current_max;
            _this.current_min = _this.current_max;
            return;
          } else {
            _this.current_min = this.value;
          }
        } else if (this.dataset.hasOwnProperty("maxPrice")) {
          if (this.value === "") {
            _this.current_max = _this.max_price;
          } else if (float_value > _this.max_price) {
            this.value = _this.max_price;
            _this.current_max = _this.max_price;
            return;
          } else if (float_value < _this.current_min) {
            this.value = _this.current_min;
            _this.current_max = _this.current_min;
          } else {
            _this.current_max = this.value;
          }
        }
        _this.renderActivePrice();
        _this.showLoadingView();
        return _this.getAjaxUrl();
      });
    };

    CoreCollection.prototype.tagListener = function () {
      var _this;
      _this = this;
      return _this.tag_links.on("click keydown", function (event) {
        var input;
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        if (event.key === "Enter") {
          input = this.parentNode.querySelector("input");
          input.checked = !input.checked;
        }
        return setTimeout(function () {
          _this.active_tags_wrapper
            .find(".collection--navigation--active-tag")
            .remove();
          _this.showLoadingView();
          _this.renderActiveTags();
          return _this.getAjaxUrl();
        }, 0);
      });
    };

    CoreCollection.prototype.showLoadingView = function () {
      var _this;
      _this = this;
      _this.grid_container.empty();
      _this.grid_container.hide();
      _this.pagination.hide();
      return _this.spinner.css("display", "flex");
    };

    CoreCollection.prototype.getAjaxUrl = function () {
      var _this, form_data, search_params;
      _this = this;
      form_data = new FormData(_this.filter_form);
      search_params = new URLSearchParams(form_data);
      _this.ajax_url = _this.url + "?" + search_params.toString();
      history.replaceState({}, "", _this.ajax_url);
      _this.getGridHtml();
      return _this.toggleActiveTags();
    };

    CoreCollection.prototype.getGridHtml = function () {
      var _this;
      _this = this;
      if (_this.request) {
        _this.request.abort();
      }
      _this.request = new XMLHttpRequest();
      _this.request.onload = function () {
        var collection_body_ajax;
        if (_this.request.status >= 200 && _this.request.status < 300) {
          collection_body_ajax = theme.utils.parseHtml(
            _this.request.response,
            ".collection--body--root",
          );
          _this.renderGridHtml(collection_body_ajax);
          _this.spinner.hide();
          _this.grid_container.removeAttr("style");
          theme.classes.Product.clearQuickAddForms("collection");
          if (collection_body_ajax.find(".product--root").length > 0) {
            return _this.formatProducts();
          }
        } else {
          // GC-164: the grid is already emptied, so a 429/5xx would leave a spinner; load the page instead.
          location.assign(_this.ajax_url);
        }
      };
      _this.request.onerror = function () {
        console.log(
          _this.request.statusText + ": collection filter request failed!",
        );
        location.assign(_this.ajax_url);
      };
      _this.request.open("GET", _this.ajax_url);
      return _this.request.send();
    };

    CoreCollection.prototype.renderGridHtml = function (collection_body_ajax) {
      var _this, collection_grid_html, pagination_root;
      _this = this;
      collection_grid_html = collection_body_ajax
        .find(".collection--body--grid")
        .html();
      _this.grid_container.html(collection_grid_html);
      pagination_root = collection_body_ajax.find(
        ".collection--body--pagination",
      );
      if (pagination_root.html()) {
        _this.pagination.html(pagination_root.html());
        _this.pagination.removeAttr("style");
        return _this.pagination_link.show();
      } else {
        return _this.pagination_link.hide();
      }
    };

    CoreCollection.prototype.formatProducts = function () {
      var _this;
      _this = this;
      _this.matchImageHeights();
      theme.utils.loadJsClasses(_this.grid_container);
      if (theme.settings.hover_image_enabled) {
        _this.hoverImagesLoaded();
      }
      if (theme.settings.quick_add) {
        theme.partials.OffCanvas.unload();
        return theme.partials.OffCanvas.load();
      }
    };

    CoreCollection.prototype.renderActiveSort = function () {
      var _this;
      _this = this;
      if (_this.current_sort_value) {
        _this.render_active_sort = true;
        _this.active_sort_container.find("span").text(_this.current_sort_label);
        _this.active_sort_container.attr(
          "data-value",
          _this.current_sort_value,
        );
        return _this.active_sort_container.removeAttr("style");
      } else {
        _this.render_active_sort = false;
        return _this.active_sort_container.hide();
      }
    };

    CoreCollection.prototype.renderActivePrice = function () {
      var _this;
      _this = this;
      if (isNaN(_this.current_min)) {
        _this.current_min = 0;
      }
      if (isNaN(_this.current_max)) {
        _this.current_max = _this.max_price;
      }
      if (_this.current_min === 0 && _this.current_max === _this.max_price) {
        _this.active_price_container.hide();
        return (_this.render_active_price = false);
      } else {
        _this.render_active_price = true;
        _this.active_min.text("" + _this.current_min);
        _this.active_max.text("" + _this.current_max);
        return _this.active_price_container.removeAttr("style");
      }
    };

    CoreCollection.prototype.renderActiveTags = function () {
      var _this, active_tag_labels, data, index, j, ref, tag_el, tag_html;
      _this = this;
      _this.active_tag_values = [];
      _this.active_tag_names = [];
      active_tag_labels = [];
      _this.render_active_tags = false;
      _this.tag_links
        .parent()
        .find(":checked")
        .each(function (input) {
          _this.active_tag_values.push(input.value);
          _this.active_tag_names.push(input.name);
          return active_tag_labels.push(input.getAttribute("data-label"));
        });
      if (_this.active_tag_values.length > 0) {
        for (
          index = j = 0, ref = _this.active_tag_values.length - 1;
          0 <= ref ? j <= ref : j >= ref;
          index = 0 <= ref ? ++j : --j
        ) {
          data =
            "data-value='" +
            _this.active_tag_values[index] +
            "' data-name='" +
            _this.active_tag_names[index] +
            "'";
          tag_html = _this.tag_template_html
            .replace("<span></span>", active_tag_labels[index])
            .replace("data-placeholder", data);
          tag_el = theme.utils.parseHtml(
            tag_html,
            ".collection--navigation--active-tag",
          );
          _this.active_tags_wrapper.prepend(tag_el.removeAttr("style"));
        }
        _this.render_active_tags = true;
        return _this.activeTagListeners();
      }
    };

    CoreCollection.prototype.toggleActiveTags = function () {
      var _this, render_tags;
      _this = this;
      render_tags =
        _this.render_active_tags ||
        _this.render_active_sort ||
        _this.render_active_price;
      if (render_tags) {
        return _this.active_options_container.show();
      } else {
        return _this.active_options_container.hide();
      }
    };

    CoreCollection.prototype.activeSortListener = function () {
      var _this;
      _this = this;
      return _this.active_sort_container.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        return _this.clearSortFilter();
      });
    };

    CoreCollection.prototype.activePriceListener = function () {
      var _this;
      _this = this;
      return _this.active_price_container.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        return _this.reset_prices.trigger("click");
      });
    };

    CoreCollection.prototype.activeTagListeners = function () {
      var _this;
      _this = this;
      _this.current_active_tags = _this.active_tags_wrapper.find(
        ".collection--navigation--active-tag",
      );
      return _this.current_active_tags.on("click keydown", function (event) {
        var click_event, input, j, len, ref, tag_link;
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        ref = _this.tag_links.el;
        for (j = 0, len = ref.length; j < len; j++) {
          tag_link = ref[j];
          input = tag_link.previousElementSibling;
          if (
            input.value === this.dataset.value &&
            input.name === this.dataset.name
          ) {
            click_event = new Event("click");
            tag_link.dispatchEvent(click_event);
            input.checked = false;
            return;
          }
        }
      });
    };

    CoreCollection.prototype.clearSortFilter = function () {
      var _this, active_sort_input;
      _this = this;
      active_sort_input = _this.sort_inputs
        .filter(":checked")
        .siblings("label");
      if (active_sort_input) {
        return active_sort_input.trigger("click");
      }
    };

    CoreCollection.prototype.clearPriceFilter = function () {
      var _this;
      _this = this;
      return _this.reset_prices.on("click keydown", function (event) {
        var change_event;
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        change_event = new Event("change");
        return _this.price_inputs.each(function (input) {
          if (input.value === "") {
            return;
          }
          input.value = "";
          return input.dispatchEvent(change_event);
        });
      });
    };

    CoreCollection.toggleFilterMenu = function (filter_button) {
      var _this;
      _this = CoreCollection;
      return document
        .querySelectorAll(".collection--filter--toggle")
        .forEach(function (toggle) {
          var menu_name;
          toggle.setAttribute("aria-expanded", false);
          menu_name = toggle.getAttribute("aria-controls");
          if (menu_name.includes(filter_button.dataset.toggleMenu)) {
            return toggle.click();
          }
        });
    };

    return CoreCollection;
  })();

  theme.classes.CoreDisclosure = (function () {
    function CoreDisclosure(root) {
      var _this;
      this.root = root;
      this.optionChangeCallback = bind(this.optionChangeCallback, this);
      this.updateFormPosition = bind(this.updateFormPosition, this);
      this.toggleFormDisplay = bind(this.toggleFormDisplay, this);
      this.setOptionOnClick = bind(this.setOptionOnClick, this);
      this.hideFormWhenFocusOut = bind(this.hideFormWhenFocusOut, this);
      this.showFormWhenClick = bind(this.showFormWhenClick, this);
      this.updateFormListeners = bind(this.updateFormListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_option = _this.root.find(".disclosure--current-option");
      _this.form = _this.root.find(".disclosure--form");
      _this.input = _this.root.find('[data-item="disclosure"]');
      _this.links = _this.root.find(".disclosure--option-link");
      _this.toggle = _this.root.find(".disclosure--toggle");
      _this.type = _this.root.attr("data-type");
      _this.toggle_and_form_gap = 8;
      _this.window_and_form_gap = 32;
      _this.form_space_needed =
        theme.utils.getHiddenElHeight(_this.form, false) +
        _this.toggle_and_form_gap +
        _this.window_and_form_gap;
      _this.load();
    }

    CoreDisclosure.prototype.load = function () {
      var _this;
      _this = this;
      _this.updateFormListeners();
      _this.showFormWhenClick();
      _this.hideFormWhenFocusOut();
      _this.setOptionOnClick();
      _this.updateFormPosition();
      if (_this.type === "url-redirect" || _this.type === "localization") {
        return _this.optionChangeCallback();
      }
    };

    CoreDisclosure.prototype.updateFormListeners = function () {
      var _this;
      _this = this;
      theme.window.on(
        "resize.Disclosure",
        theme.utils.debounce(100, function () {
          return _this.updateFormPosition();
        }),
      );
      return _this.root.on("update_form_position", function () {
        return _this.updateFormPosition();
      });
    };

    CoreDisclosure.prototype.showFormWhenClick = function () {
      var _this;
      _this = this;
      return _this.toggle.on("click keydown", function (event) {
        var aria_expanded;
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        aria_expanded = this.getAttribute("aria-expanded") === "true";
        return _this.toggleFormDisplay(!aria_expanded);
      });
    };

    CoreDisclosure.prototype.hideFormWhenFocusOut = function () {
      var _this;
      _this = this;
      _this.toggle.on("focusout", function (event) {
        var form_has_focus;
        form_has_focus = _this.root.has(event.relatedTarget);
        if (!form_has_focus) {
          return _this.toggleFormDisplay(false);
        }
      });
      _this.form.on("focusout", function (event) {
        var child_in_focus, is_visible;
        child_in_focus = this.contains(event.relatedTarget);
        is_visible = _this.toggle.attr("aria-expanded") === "true";
        if (is_visible && !child_in_focus) {
          return _this.toggleFormDisplay(false);
        }
      });
      return _this.root.on("keydown", function (event) {
        if (event.key !== "Escape") {
          return;
        }
        _this.toggleFormDisplay(false);
        return _this.toggle.focus();
      });
    };

    CoreDisclosure.prototype.setOptionOnClick = function () {
      var _this;
      _this = this;
      return _this.links.on("click keydown", function (event) {
        var option_selected_name, option_selected_value;
        if (event.key === "Enter") {
          _this.toggle.focus();
        } else if (event.type === "keydown") {
          return;
        }
        option_selected_value = this.dataset.value;
        option_selected_name = this.textContent;
        _this.toggleFormDisplay(false);
        _this.current_option.text(option_selected_name);
        _this.links.attr("aria-current", false);
        this.setAttribute("aria-current", true);
        _this.input.val(option_selected_value);
        return _this.input.trigger("change");
      });
    };

    CoreDisclosure.prototype.toggleFormDisplay = function (open_form) {
      var _this;
      _this = this;
      return _this.toggle.attr("aria-expanded", open_form);
    };

    CoreDisclosure.prototype.updateFormPosition = function () {
      var _this,
        clearance_height,
        close_to_bottom,
        close_to_top,
        distance_from_bottom,
        distance_from_top,
        form_height,
        height_of_canvas,
        height_of_toggle,
        max_form_height;
      _this = this;
      height_of_toggle = _this.toggle.outerHeight();
      clearance_height = height_of_toggle + _this.toggle_and_form_gap;
      height_of_canvas = _this.root.closest("[class^=off-canvas]").height();
      distance_from_top = _this.root.offset().top;
      distance_from_bottom =
        height_of_canvas - distance_from_top - height_of_toggle;
      close_to_bottom =
        _this.form_space_needed > distance_from_bottom &&
        distance_from_bottom < distance_from_top;
      close_to_top =
        _this.form_space_needed > distance_from_top &&
        distance_from_bottom > distance_from_top;
      max_form_height =
        window.innerHeight - clearance_height - _this.window_and_form_gap;
      if (close_to_bottom) {
        max_form_height -= distance_from_bottom;
      } else if (close_to_top) {
        max_form_height -= distance_from_top;
      }
      _this.form.css("max-height", max_form_height + "px");
      if (close_to_bottom) {
        form_height =
          theme.utils.getHiddenElHeight(_this.form, false) +
          _this.toggle_and_form_gap;
        return _this.form.css("top", "-" + form_height + "px");
      } else {
        return _this.form.css("top", clearance_height + "px");
      }
    };

    CoreDisclosure.prototype.optionChangeCallback = function () {
      var _this;
      _this = this;
      return _this.input.on("change", function () {
        if (_this.type === "url-redirect") {
          return (window.location.href = this.value);
        } else if (_this.type === "localization") {
          return this.closest("form").submit();
        }
      });
    };

    return CoreDisclosure;
  })();

  theme.classes.CoreDomObject = (function () {
    function CoreDomObject(selector1, container1) {
      var event_function_map;
      this.selector = selector1;
      this.container = container1 != null ? container1 : document;
      this.wrapInner = bind(this.wrapInner, this);
      this.wrapAll = bind(this.wrapAll, this);
      this.width = bind(this.width, this);
      this.val = bind(this.val, this);
      this.trigger = bind(this.trigger, this);
      this.text = bind(this.text, this);
      this.submit = bind(this.submit, this);
      this.siblings = bind(this.siblings, this);
      this.show = bind(this.show, this);
      this.setAttribute = bind(this.setAttribute, this);
      this.scrollTop = bind(this.scrollTop, this);
      this.replaceWith = bind(this.replaceWith, this);
      this.removeClass = bind(this.removeClass, this);
      this.removeAttr = bind(this.removeAttr, this);
      this.remove = bind(this.remove, this);
      this.prev = bind(this.prev, this);
      this.prepend = bind(this.prepend, this);
      this.parent = bind(this.parent, this);
      this.outerWidth = bind(this.outerWidth, this);
      this.outerHtml = bind(this.outerHtml, this);
      this.outerHeight = bind(this.outerHeight, this);
      this.on = bind(this.on, this);
      this.offset = bind(this.offset, this);
      this.off = bind(this.off, this);
      this.not = bind(this.not, this);
      this.next = bind(this.next, this);
      this.last = bind(this.last, this);
      this.isEmpty = bind(this.isEmpty, this);
      this.isVisible = bind(this.isVisible, this);
      this.is = bind(this.is, this);
      this.insertBefore = bind(this.insertBefore, this);
      this.index = bind(this.index, this);
      this.html = bind(this.html, this);
      this.hide = bind(this.hide, this);
      this.height = bind(this.height, this);
      this.hasClass = bind(this.hasClass, this);
      this.has = bind(this.has, this);
      this.getAttribute = bind(this.getAttribute, this);
      this.focus = bind(this.focus, this);
      this.first = bind(this.first, this);
      this.find = bind(this.find, this);
      this.filter = bind(this.filter, this);
      this.eq = bind(this.eq, this);
      this.empty = bind(this.empty, this);
      this.each = bind(this.each, this);
      this.data = bind(this.data, this);
      this.css = bind(this.css, this);
      this.closest = bind(this.closest, this);
      this.clone = bind(this.clone, this);
      this.children = bind(this.children, this);
      this.attr = bind(this.attr, this);
      this.append = bind(this.append, this);
      this.addClass = bind(this.addClass, this);
      this.add = bind(this.add, this);
      if (typeof this.selector === "string") {
        this.el = this.container.querySelectorAll(this.selector);
      } else if (Array.isArray(this.selector)) {
        this.el = this.selector;
      } else if (typeof this.selector === "object") {
        this.el = new Array(this.selector);
      } else {
        this.el = [];
      }
      this.isDOMobject = true;
      if (this.el[0] !== null) {
        this.length = this.el.length;
      } else {
        this.length = 0;
      }
      event_function_map = [];
      this.el.forEach(function (el) {
        return event_function_map.push({});
      });
      this.event_function_map = event_function_map;
    }

    CoreDomObject.prototype.add = function (element) {
      var elements_to_add;
      if (typeof element === "string") {
        elements_to_add = Array.from(
          document.querySelectorAll(element.selector),
        );
      } else {
        elements_to_add = Array.from(element.el);
      }
      this.el.forEach(function (el) {
        return elements_to_add.push(el);
      });
      return el(elements_to_add);
    };

    CoreDomObject.prototype.addClass = function (class_name) {
      if (!class_name) {
        return false;
      }
      this.el.forEach(function (el) {
        return el.classList.add(class_name);
      });
      return this;
    };

    CoreDomObject.prototype.append = function (element) {
      if (typeof element === "object" && this.length && element.length) {
        this.el.forEach(function (parent_el) {
          return element.el.forEach(function (child_el) {
            return parent_el.appendChild(child_el);
          });
        });
      }
      return this;
    };

    CoreDomObject.prototype.attr = function (attr, val) {
      if (val == null) {
        val = null;
      }
      if (!attr) {
        return;
      }
      if (val !== null && this.length) {
        this.el.forEach(function (el) {
          return el.setAttribute(attr, val);
        });
        return this;
      } else if (this.length) {
        return this.el[0].getAttribute(attr);
      }
    };

    CoreDomObject.prototype.children = function (selector) {
      if (!selector) {
        selector = "*";
      }
      return el(":scope > " + selector, this.el[0]);
    };

    CoreDomObject.prototype.clone = function () {
      if (this.length === 0) {
        return;
      }
      return el(this.el[0].cloneNode(true));
    };

    CoreDomObject.prototype.closest = function (selector) {
      if (!(selector && this.length)) {
        return false;
      }
      return el(this.el[0].closest(selector));
    };

    CoreDomObject.prototype.css = function (property_name, value) {
      if (!(property_name || value)) {
        return false;
      } else if (value === void 0 && this.length) {
        return window.getComputedStyle(this.el[0])[property_name];
      } else {
        this.el.forEach(function (el) {
          return (el.style[property_name] = value);
        });
      }
      return this;
    };

    CoreDomObject.prototype.data = function (data_attr) {
      var attr;
      if (!(data_attr && this.length)) {
        return false;
      }
      if (!(data_attr.indexOf("-") > -1)) {
        data_attr = (data_attr.match(/[A-Za-z][a-z]*/g) || {}).join("-");
      }
      attr = this.el[0].getAttribute("data-" + data_attr);
      if (attr === "true") {
        return true;
      } else if (attr === "false") {
        return false;
      } else if (isNaN(parseFloat(attr))) {
        return attr;
      } else {
        return parseFloat(attr);
      }
    };

    CoreDomObject.prototype.each = function (callback) {
      return this.el.forEach(function (el, index) {
        return callback(el, index);
      });
    };

    CoreDomObject.prototype.empty = function () {
      if (this.length) {
        this.el.forEach(function (el) {
          return (el.innerHTML = "");
        });
      }
      return this;
    };

    CoreDomObject.prototype.eq = function (index) {
      if (index === void 0) {
        return -1;
      }
      return el(this.el[index]);
    };

    CoreDomObject.prototype.filter = function (selector) {
      var elements_to_filter, new_element_list;
      if (!selector) {
        return false;
      }
      elements_to_filter = Array.from(
        this.container.querySelectorAll(selector),
      );
      new_element_list = [];
      this.el.forEach(function (el) {
        if (elements_to_filter.includes(el)) {
          return new_element_list.push(el);
        }
      });
      return el(new_element_list);
    };

    CoreDomObject.prototype.find = function (selector) {
      var new_elements;
      if (!selector) {
        return false;
      } else if (selector.charAt(0) === ">") {
        selector = ":scope " + selector;
      }
      if (this.length === 1) {
        return el(selector, this.el[0]);
      } else {
        new_elements = [];
        this.el.forEach(function (el) {
          var found_element, found_elements, j, len, results1;
          found_elements = el.querySelectorAll(selector);
          results1 = [];
          for (j = 0, len = found_elements.length; j < len; j++) {
            found_element = found_elements[j];
            results1.push(new_elements.push(found_element));
          }
          return results1;
        });
        return el(new_elements);
      }
    };

    CoreDomObject.prototype.first = function () {
      return el(this.el[0]);
    };

    CoreDomObject.prototype.focus = function (index) {
      if (!index) {
        index = 0;
      }
      if (this.length) {
        this.el[index].focus();
      }
      return this;
    };

    CoreDomObject.prototype.getAttribute = function (attr) {
      if (!(attr && this.length)) {
        return;
      }
      return this.el[0].getAttribute(attr);
    };

    CoreDomObject.prototype.has = function (element) {
      if (typeof element === "object") {
        return this.el[0].contains(element);
      } else {
      }
    };

    CoreDomObject.prototype.hasClass = function (class_name) {
      if (!(class_name && this.length)) {
        return;
      }
      return this.el[0].classList.contains(class_name);
    };

    CoreDomObject.prototype.height = function (height) {
      if (this.length === 0) {
        return this;
      }
      if (!height) {
        return this.el[0].offsetHeight;
      } else {
        this.el.forEach(function (el) {
          return (el.style.height = height + "px");
        });
        return this;
      }
    };

    CoreDomObject.prototype.hide = function () {
      if (this.length === 0) {
        return;
      }
      this.el.forEach(function (el) {
        return (el.style.display = "none");
      });
      return this;
    };

    CoreDomObject.prototype.html = function (html) {
      if (!html) {
        return this.el[0].innerHTML;
      } else if (this.length) {
        this.el[0].innerHTML = html;
      }
      return this;
    };

    CoreDomObject.prototype.index = function (element) {
      var found_index;
      if (!element) {
        return Array.from(this.el[0].parentNode.children).indexOf(this.el[0]);
      } else {
        found_index = -1;
        this.el.forEach(function (el, index) {
          if (el === element.el[0]) {
            return (found_index = index);
          }
        });
        return found_index;
      }
    };

    CoreDomObject.prototype.insertBefore = function (new_el) {
      if (this.length === 0) {
        return;
      }
      this.el.forEach(function (el) {
        return el.parentNode.insertBefore(new_el.el[0], el);
      });
      return this;
    };

    CoreDomObject.prototype.is = function (element) {
      var elements_to_compare;
      if (!element) {
        return false;
      } else if (typeof element === "string") {
        elements_to_compare = Array.from(document.querySelectorAll(element));
      } else {
        elements_to_compare = Array.from(element.el);
      }
      return elements_to_compare.includes(this.el[0]);
    };

    CoreDomObject.prototype.isVisible = function () {
      var is_visible;
      if (this.length === 0) {
        return;
      }
      is_visible = false;
      this.el.forEach(function (el) {
        var style;
        style = window.getComputedStyle(el);
        if (style.display !== "none") {
          return (is_visible = true);
        }
      });
      return is_visible;
    };

    CoreDomObject.prototype.isEmpty = function () {
      var is_empty;
      if (this.length === 0) {
        return;
      }
      is_empty = true;
      this.el.forEach(function (el) {
        if (el.hasChildNodes()) {
          is_empty = false;
        }
      });
      return is_empty;
    };

    CoreDomObject.prototype.last = function () {
      if (this.length === 0) {
        return;
      }
      return el(this.el[this.el.length - 1], this.container);
    };

    CoreDomObject.prototype.next = function () {
      if (this.length === 0) {
        return;
      }
      return el(this.el[0].nextElementSibling);
    };

    CoreDomObject.prototype.not = function (element) {
      var elements_to_remove, new_object_arr;
      if (typeof element === "string") {
        elements_to_remove = Array.from(document.querySelectorAll(element));
      } else {
        elements_to_remove = Array.from(element.el);
      }
      new_object_arr = [];
      this.el.forEach(function (el) {
        if (!(elements_to_remove.includes(el) || new_object_arr.includes(el))) {
          return new_object_arr.push(el);
        }
      });
      return el(new_object_arr);
    };

    CoreDomObject.prototype.off = function (types) {
      var event_function_map;
      if (this.length === 0) {
        return;
      }
      event_function_map = this.event_function_map;
      this.el.forEach(function (el, el_index) {
        return types.split(" ").forEach(function (type) {
          if (event_function_map[el_index][type]) {
            el.removeEventListener(
              type.split(".")[0],
              event_function_map[el_index][type],
            );
            return delete event_function_map[el_index][type];
          }
        });
      });
      this.event_function_map = event_function_map;
      return true;
    };

    CoreDomObject.prototype.offset = function () {
      var offset, rect;
      if (this.length === 0) {
        return;
      }
      rect = this.el[0].getBoundingClientRect();
      return (offset = {
        top: rect.top + window.pageYOffset,
        left: rect.left + window.pageXOffset,
      });
    };

    CoreDomObject.prototype.on = function (types, event_function, passive) {
      var event_function_map;
      if (passive == null) {
        passive = false;
      }
      if (this.length === 0) {
        return;
      }
      event_function_map = this.event_function_map;
      this.el.forEach(function (el, el_index) {
        return types.split(" ").forEach(function (type) {
          event_function_map[el_index][type] = event_function;
          return el.addEventListener(type.split(".")[0], event_function, {
            passive: passive,
          });
        });
      });
      this.event_function_map = event_function_map;
      return true;
    };

    CoreDomObject.prototype.outerHeight = function () {
      if (this.length) {
        return this.el[0].offsetHeight;
      }
    };

    CoreDomObject.prototype.outerHtml = function () {
      if (this.length) {
        return this.el[0].outerHTML;
      }
    };

    CoreDomObject.prototype.outerWidth = function () {
      if (this.length) {
        return this.el[0].offsetWidth;
      }
    };

    CoreDomObject.prototype.parent = function () {
      var parent_el;
      if (this.length) {
        parent_el = [];
        this.el.forEach(function (child) {
          return parent_el.push(child.parentNode);
        });
        return el(parent_el);
      } else {
        return this;
      }
    };

    CoreDomObject.prototype.prepend = function (element) {
      if (typeof element === "object" && this.length && element.length) {
        this.el.forEach(function (parent_el) {
          return element.el.forEach(function (child_el) {
            return parent_el.prepend(child_el);
          });
        });
      }
      return this;
    };

    CoreDomObject.prototype.prev = function () {
      if (this.length === 0) {
        return;
      }
      return el(this.el[0].previousElementSibling);
    };

    CoreDomObject.prototype.remove = function () {
      this.el.forEach(function (el) {
        return el.parentNode.removeChild(el);
      });
      return delete this;
    };

    CoreDomObject.prototype.removeAttr = function (attr) {
      if (!attr) {
        return;
      }
      if (this.length) {
        this.el.forEach(function (el) {
          return el.removeAttribute(attr);
        });
      }
      return this;
    };

    CoreDomObject.prototype.removeClass = function (class_names) {
      if (!(class_names && this.length)) {
        return;
      }
      this.el.forEach(function (el) {
        return class_names.split(" ").forEach(function (class_name) {
          return el.classList.remove(class_name);
        });
      });
      return this;
    };

    CoreDomObject.prototype.replaceWith = function (element) {
      if (this.length) {
        this.el[0].replaceWith(element.el[0]);
      }
      return this;
    };

    CoreDomObject.prototype.scrollTop = function (position) {
      if (this.length === 0) {
        return;
      }
      if (position) {
        return (this.el[0].scrollTop = position);
      } else {
        return this.el[0].scrollTop;
      }
    };

    CoreDomObject.prototype.setAttribute = function (attribute, value) {
      if (!(attribute || value)) {
        return;
      }
      if (this.length) {
        this.el.forEach(function (el) {
          return el.setAttribute(attribute, value);
        });
        return this;
      }
    };

    CoreDomObject.prototype.show = function () {
      if (this.length === 0) {
        return;
      }
      this.el.forEach(function (el) {
        return (el.style.display = "block");
      });
      return this;
    };

    CoreDomObject.prototype.siblings = function (selector) {
      if (this.length === 0) {
        return;
      }
      return el(selector, this.el[0].parentNode);
    };

    CoreDomObject.prototype.submit = function () {
      if (this.length === 0) {
        return;
      }
      return this.el[0].submit();
    };

    CoreDomObject.prototype.text = function (text) {
      if (this.length === 0) {
        return this;
      }
      if (!text) {
        return this.el[0].textContent;
      } else {
        this.el.forEach(function (el) {
          return (el.textContent = text);
        });
      }
      return this;
    };

    CoreDomObject.prototype.trigger = function (types) {
      var elements;
      if (!types) {
        return;
      }
      elements = this.el;
      types.split(" ").forEach(function (type) {
        var event;
        event = new Event(type.split(".")[0], {
          bubbles: true,
        });
        return elements.forEach(function (el) {
          return el.dispatchEvent(event);
        });
      });
      return this;
    };

    CoreDomObject.prototype.val = function (new_value) {
      if (this.length === 0) {
        return;
      }
      if (!new_value) {
        return this.el[0].value;
      } else {
        this.el[0].value = new_value;
      }
      return this;
    };

    CoreDomObject.prototype.width = function (width) {
      if (this.length === 0) {
        return;
      }
      if (!width) {
        return this.el[0].offsetWidth;
      } else {
        return this.el.forEach(function (el) {
          return (el.style.width = width + "px");
        });
      }
    };

    CoreDomObject.prototype.wrapAll = function (prepended_html, appended_html) {
      if (this.length === 0) {
        return;
      }
      this.el.forEach(function (el) {
        var new_html, org_html;
        org_html = el.outerHTML;
        new_html = prepended_html + org_html + appended_html;
        return (el.outerHTML = new_html);
      });
      return this;
    };

    CoreDomObject.prototype.wrapInner = function (
      prepended_html,
      appended_html,
    ) {
      if (this.length === 0) {
        return;
      }
      this.el.forEach(function (el) {
        var new_html, org_html;
        org_html = el.innerHTML;
        new_html = prepended_html + org_html + appended_html;
        return (el.innerHTML = new_html);
      });
      return this;
    };

    return CoreDomObject;
  })();

  theme.classes.CoreFeaturedBlog = (function () {
    function CoreFeaturedBlog(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      _this = this;
      _this.current_width = window.innerWidth;
      _this.item_container = _this.root.find(".featured-blog--grid");
      _this.items = _this.root.find(".featured-blog--item");
      _this.matchImageHeights();
      _this.resizeListeners();
    }

    CoreFeaturedBlog.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(
        _this.item_container,
        _this.items,
        ".featured-blog--item--image",
      );
    };

    CoreFeaturedBlog.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.FeaturedBlog",
        theme.utils.debounce(100, function () {
          if (_this.current_width !== window.innerWidth) {
            _this.matchImageHeights();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    return CoreFeaturedBlog;
  })();

  theme.classes.CoreFeaturedCollection = (function () {
    function CoreFeaturedCollection(root) {
      var _this;
      this.root = root;
      this.hoverImagesLoaded = bind(this.hoverImagesLoaded, this);
      this.setGreatestHeight = bind(this.setGreatestHeight, this);
      this.sectionListeners = bind(this.sectionListeners, this);
      this.resizeListener = bind(this.resizeListener, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_width = window.innerWidth;
      _this.display_type = _this.root.data("display-type");
      _this.section_id = _this.root.data("section-id");
      _this.items = _this.root.find(".product--root");
      _this.load();
    }

    CoreFeaturedCollection.prototype.load = function () {
      var _this;
      _this = this;
      _this.resizeListener();
      _this.sectionListeners();
      _this.setGreatestHeight();
      if (theme.settings.hover_image_enabled) {
        return _this.hoverImagesLoaded();
      }
    };

    CoreFeaturedCollection.prototype.resizeListener = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize." + _this.section_id,
        theme.utils.debounce(100, function () {
          if (_this.current_width !== window.innerWidth) {
            _this.setGreatestHeight();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    CoreFeaturedCollection.prototype.sectionListeners = function () {
      var _this;
      _this = this;
      return _this.root.on("theme:section:unload", function () {
        return theme.window.off("resize." + _this.section_id);
      });
    };

    CoreFeaturedCollection.prototype.setGreatestHeight = function () {
      var _this, greatest_image_height;
      _this = this;
      if (_this.display_type === "grid") {
        return theme.utils.matchImageHeights(
          _this.root.find(".featured-collection--grid"),
          _this.root.find(".product--root"),
          ".product--image-wrapper:not(.stack_wrapper) ",
        );
      } else {
        greatest_image_height = 0;
        _this.items.each(function (item) {
          var item_el, this_height;
          item_el = el(item);
          if (item_el.find(".image--root").length > 0) {
            this_height = item_el
              .find(".product--image-wrapper:not(.stack_wrapper) .image--root")
              .outerHeight();
          } else {
            this_height = item_el.find(".placeholder--root").outerHeight();
          }
          if (this_height > greatest_image_height) {
            return (greatest_image_height = this_height);
          }
        });
        return _this.items
          .find(
            ".product--image-wrapper:not(.stack_wrapper) , .placeholder--root",
          )
          .height(greatest_image_height);
      }
    };

    CoreFeaturedCollection.prototype.hoverImagesLoaded = function () {
      var _this;
      _this = this;
      return _this.root.find(".product--hover-image").each(function (image) {
        var hover_image;
        hover_image = el(image);
        return theme.utils.imagesLoaded(hover_image, function () {
          var product;
          product = hover_image.closest('[data-hover-image="true"]');
          return product.attr("data-hover-image", "loaded");
        });
      });
    };

    return CoreFeaturedCollection;
  })();

  theme.classes.CoreFeaturedCollections = (function () {
    function CoreFeaturedCollections(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_width = window.innerWidth;
      _this.item_container = _this.root.find(".featured-collections--body");
      _this.items = _this.root.find(".featured-collections--item");
      _this.load();
    }

    CoreFeaturedCollections.prototype.load = function () {
      var _this;
      _this = this;
      _this.matchImageHeights();
      return _this.resizeListeners();
    };

    CoreFeaturedCollections.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(
        _this.item_container,
        _this.items,
        ".featured-collections--image",
      );
    };

    CoreFeaturedCollections.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.FeaturedCollections",
        theme.utils.debounce(100, function () {
          if (_this.current_width !== window.innerWidth) {
            _this.matchImageHeights();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    return CoreFeaturedCollections;
  })();

  theme.classes.CoreFeaturedGrid = (function () {
    function CoreFeaturedGrid(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_width = window.innerWidth;
      _this.item_container = _this.root.find(".featured-grid--body--container");
      _this.items = _this.root.find(".featured-grid--item");
      _this.text_position = _this.root.attr("data-text-position");
      _this.mobile_overlay = _this.root.data("mobile-overlay");
      _this.load();
    }

    CoreFeaturedGrid.prototype.load = function () {
      var _this;
      _this = this;
      _this.matchImageHeights();
      return _this.resizeListeners();
    };

    CoreFeaturedGrid.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      if (
        _this.text_position === "bottom" ||
        (theme.utils.mqs.current_window === "small" && !_this.mobile_overlay)
      ) {
        return theme.utils.matchImageHeights(
          _this.item_container,
          _this.items,
          ".featured-grid--item--image",
        );
      }
    };

    CoreFeaturedGrid.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.FeaturedGrid",
        theme.utils.debounce(100, function () {
          _this.items
            .find(".featured-grid--item--image, .placeholder--root")
            .css("height", "100%");
          if (_this.current_width !== window.innerWidth) {
            _this.matchImageHeights();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    return CoreFeaturedGrid;
  })();

  theme.classes.CoreFeaturedVideo = (function () {
    function CoreFeaturedVideo(root) {
      var _this;
      this.root = root;
      this.hideThumbnail = bind(this.hideThumbnail, this);
      this.playButtonListener = bind(this.playButtonListener, this);
      this.disablePlayerFocus = bind(this.disablePlayerFocus, this);
      this.vimeoEvents = bind(this.vimeoEvents, this);
      this.insertVimeoPlayer = bind(this.insertVimeoPlayer, this);
      this.youtubeEvents = bind(this.youtubeEvents, this);
      this.youtubeReady = bind(this.youtubeReady, this);
      this.insertYoutubePlayer = bind(this.insertYoutubePlayer, this);
      this.insertAPIScript = bind(this.insertAPIScript, this);
      this.playerInit = bind(this.playerInit, this);
      this.checkAPIScriptExists = bind(this.checkAPIScriptExists, this);
      _this = this;
      _this.play_buttons = _this.root.find(
        ".feature-video--play svg, .feature-video--play-mobile svg",
      );
      _this.section_id = _this.root.attr("data-section-id");
      _this.thumbnail = _this.root.data("thumbnail");
      _this.video_type = _this.root.data("video-type");
      _this.video_id = _this.root.data("video-id");
      _this.vimeoVars = {
        id: _this.video_id,
        autopause: 0,
        playsinline: 0,
        title: 0,
      };
      _this.youtubeVars = {};
      if (_this.thumbnail) {
        _this.playButtonListener();
      } else {
        _this.checkAPIScriptExists();
      }
    }

    CoreFeaturedVideo.prototype.checkAPIScriptExists = function () {
      var _this;
      _this = this;
      if (_this.video_type === "vimeo") {
        if (theme.utils.vimeo_script_added) {
          return _this.playerInit();
        } else {
          return _this.insertAPIScript();
        }
      } else {
        if (theme.utils.youtube_script_added) {
          return _this.playerInit();
        } else {
          return _this.insertAPIScript();
        }
      }
    };

    CoreFeaturedVideo.prototype.playerInit = function () {
      var _this;
      _this = this;
      if (_this.video_type === "vimeo") {
        if (_this.thumbnail) {
          return _this.insertVimeoPlayer();
        } else {
          window.addEventListener("load", function () {
            return _this.insertVimeoPlayer();
          });
          return _this.root.on("theme:section:load", function () {
            return _this.insertVimeoPlayer();
          });
        }
      } else {
        if (_this.thumbnail) {
          return _this.insertYoutubePlayer();
        } else {
          window.addEventListener("load", function () {
            return _this.insertYoutubePlayer();
          });
          return _this.root.on("theme:section:load", function () {
            return _this.insertYoutubePlayer();
          });
        }
      }
    };

    CoreFeaturedVideo.prototype.insertAPIScript = function () {
      var _this;
      _this = this;
      if (_this.video_type === "vimeo") {
        theme.utils.vimeo_script_added = true;
        return theme.utils.insertScript(
          "https://player.vimeo.com/api/player.js",
          function () {
            return _this.insertVimeoPlayer();
          },
        );
      } else {
        theme.utils.youtube_script_added = true;
        theme.utils.insertScript("https://www.youtube.com/iframe_api");
        return window.addEventListener(
          "theme:utils:youtubeAPIReady",
          function () {
            return _this.insertYoutubePlayer();
          },
        );
      }
    };

    CoreFeaturedVideo.prototype.insertYoutubePlayer = function () {
      var _this;
      _this = this;
      if (!_this.thumbnail) {
        _this.youtubeVars.enablejsapi = 1;
        _this.youtubeVars.origin = window.location.href;
        _this.youtubeVars.playsinline = 1;
        _this.youtubeVars.fs = 0;
        _this.youtubeVars.loop = 1;
        _this.youtubeVars.playlist = _this.video_id;
      }
      if (typeof YT !== "undefined") {
        return (_this.player = new YT.Player("player-" + _this.section_id, {
          videoId: _this.video_id,
          playerVars: _this.youtubeVars,
          events: {
            onReady: _this.youtubeReady,
            onStateChange: _this.youtubeEvents,
          },
        }));
      }
    };

    CoreFeaturedVideo.prototype.youtubeReady = function () {
      var _this;
      _this = this;
      if (!_this.thumbnail) {
        _this.player.mute();
        _this.disablePlayerFocus();
      }
      return _this.player.playVideo();
    };

    CoreFeaturedVideo.prototype.youtubeEvents = function (event) {
      var YTP, _this, remains;
      _this = this;
      YTP = event.target;
      if (_this.thumbnail) {
        if (event.data === 0) {
          YTP.seekTo(0);
          return YTP.pauseVideo();
        }
      } else {
        if (event.data === 1) {
          remains = YTP.getDuration() - YTP.getCurrentTime();
          if (_this.rewindTO) {
            clearTimeout(_this.rewindTO);
          }
          return (_this.rewindTO = setTimeout(
            function () {
              YTP.seekTo(0);
            },
            (remains - 0.1) * 1000,
          ));
        }
      }
    };

    CoreFeaturedVideo.prototype.insertVimeoPlayer = function () {
      var _this;
      _this = this;
      if (!_this.thumbnail) {
        _this.vimeoVars.playsinline = 1;
        _this.vimeoVars.muted = 1;
        _this.vimeoVars.background = 1;
        _this.vimeoVars.loop = 1;
      }
      _this.player = new Vimeo.Player(
        "player-" + _this.section_id,
        _this.vimeoVars,
      );
      if (_this.thumbnail) {
        _this.vimeoEvents();
      } else {
        _this.player.ready().then(function () {
          return _this.disablePlayerFocus();
        });
      }
      return _this.player.play();
    };

    CoreFeaturedVideo.prototype.vimeoEvents = function () {
      var _this;
      _this = this;
      _this.player.getDuration().then(function (duration) {
        return _this.player.addCuePoint(duration - 0.3, {});
      });
      return _this.player.on("cuepoint", function () {
        _this.player.setCurrentTime(0);
        return _this.player.pause();
      });
    };

    CoreFeaturedVideo.prototype.disablePlayerFocus = function () {
      var _this;
      _this = this;
      return _this.root.find("iframe").attr("tabindex", "-1");
    };

    CoreFeaturedVideo.prototype.playButtonListener = function () {
      var _this;
      _this = this;
      _this.play_buttons.attr("tabindex", "0");
      return _this.play_buttons.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        _this.checkAPIScriptExists();
        return _this.hideThumbnail();
      });
    };

    CoreFeaturedVideo.prototype.hideThumbnail = function () {
      var _this;
      _this = this;
      return setTimeout(function () {
        return _this.root
          .find(
            ".feature-video--header, .feature-video--thumbnail, .feature-video--play-mobile",
          )
          .hide();
      }, 350);
    };

    return CoreFeaturedVideo;
  })();

  theme.classes.CoreFeedbackBar = (function () {
    function CoreFeedbackBar(root) {
      var _this;
      this.root = root;
      this.asyncListener = bind(this.asyncListener, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.messages = _this.root.find(".feedback-bar--message > *");
      _this.load();
      _this.asyncListener();
    }

    CoreFeedbackBar.prototype.load = function () {
      var _this, anchor_tag, message, message_elem;
      _this = this;
      _this.messages.hide();
      anchor_tag = window.location.hash.substr(1);
      message = anchor_tag.replace("feedback-bar--", "");
      message_elem = _this.messages.filter("[data-message='" + message + "']");
      if (message_elem.length) {
        message_elem.show();
        setTimeout(function () {
          return _this.root.attr("data-open", "true");
        }, 200);
        return setTimeout(function () {
          return _this.root.attr("data-open", "false");
        }, 5000);
      }
    };

    CoreFeedbackBar.prototype.asyncListener = function () {
      var _this;
      _this = this;
      return window.addEventListener("theme:feedback-bar:trigger", function () {
        return _this.load();
      });
    };

    return CoreFeedbackBar;
  })();

  theme.classes.CoreFooter = (function () {
    function CoreFooter(root) {
      var _this;
      this.root = root;
      this.stickyFooter = bind(this.stickyFooter, this);
      this.addListeners = bind(this.addListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.header = el(".header--root");
      _this.main_content = el(".layout--main-content");
      _this.load();
    }

    CoreFooter.prototype.load = function () {
      var _this;
      _this = this;
      _this.addListeners();
      return _this.stickyFooter();
    };

    CoreFooter.prototype.addListeners = function () {
      var _this;
      _this = this;
      theme.window.on("resize theme:cart:updated", function () {
        return _this.stickyFooter();
      });
      return document.addEventListener("shopify:section:load", function () {
        return _this.stickyFooter();
      });
    };

    CoreFooter.prototype.stickyFooter = function () {
      var _this, announcement_el, reduce_window_by, total_content_height;
      _this = this;
      _this.main_content.css("min-height", "unset");
      total_content_height =
        _this.header.outerHeight() +
        _this.main_content.outerHeight() +
        _this.root.outerHeight();
      if (theme.body.data("border")) {
        if (theme.utils.mqs.current_window === "small") {
          total_content_height += 8 * 2;
        } else {
          total_content_height += 12 * 2;
        }
      }
      announcement_el = el(".announcement--root");
      if (announcement_el.length > 0) {
        total_content_height += announcement_el.outerHeight();
      }
      if (window.innerHeight > total_content_height) {
        reduce_window_by =
          total_content_height - _this.main_content.outerHeight();
        return _this.main_content.css(
          "min-height",
          window.innerHeight - reduce_window_by + "px",
        );
      }
    };

    return CoreFooter;
  })();

  theme.classes.CoreMap = (function () {
    function CoreMap(root) {
      var _this;
      this.root = root;
      this.buildStyles = bind(this.buildStyles, this);
      this.buildMap = bind(this.buildMap, this);
      this.geolocate = bind(this.geolocate, this);
      this.loadMapsApi = bind(this.loadMapsApi, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.api_status = null;
      _this.map_instance = null;
      _this.key = _this.root.data("api-key");
      _this.address = _this.root.attr("data-address");
      _this.theme = _this.root.data("theme");
      _this.styles = null;
      _this.container = _this.root.find(".map--google-maps");
      _this.center = null;
      _this.load();
    }

    CoreMap.prototype.load = function () {
      var _this;
      _this = this;
      if (_this.container.length > 0) {
        return _this.loadMapsApi();
      }
    };

    CoreMap.prototype.loadMapsApi = function () {
      var _this, other_map_loading_checker;
      _this = this;
      if (theme.utils.google_maps_script_status === "loading") {
        return (other_map_loading_checker = setInterval(function () {
          if (theme.utils.google_maps_script_status === "loaded") {
            _this.geolocate();
            return clearInterval(other_map_loading_checker);
          }
        }, 100));
      } else if (typeof window.google === "undefined") {
        theme.utils.google_maps_script_status = "loading";
        return theme.utils.insertScript(
          "https://maps.googleapis.com/maps/api/js?key=" + _this.key,
          function () {
            _this.geolocate();
            return (theme.utils.google_maps_script_status = "loaded");
          },
        );
      } else {
        return _this.geolocate();
      }
    };

    CoreMap.prototype.geolocate = function () {
      var _this, geocoder;
      _this = this;
      geocoder = new google.maps.Geocoder();
      return geocoder.geocode(
        {
          address: _this.address,
        },
        function (results, status) {
          if (status === "OK") {
            _this.center = results[0].geometry.location;
            _this.buildStyles();
            return _this.buildMap();
          } else {
            return console.log("couldn't convert address with geocoder");
          }
        },
      );
    };

    CoreMap.prototype.buildMap = function () {
      var _this, center, map, mapOptions, marker;
      _this = this;
      mapOptions = {
        zoom: 15,
        center: _this.center,
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: false,
        styles: _this.styles,
      };
      map = new google.maps.Map(_this.container.el[0], mapOptions);
      center = map.getCenter();
      marker = new google.maps.Marker({
        map: map,
        position: map.getCenter(),
      });
      return (_this.map_instance = google.maps.event.addDomListener(
        window,
        "resize",
        theme.utils.debounce(500, function () {
          google.maps.event.trigger(map, "resize");
          map.setCenter(center);
        }),
      ));
    };

    CoreMap.prototype.buildStyles = function () {
      var _this;
      _this = this;
      if (_this.theme === "grayscale") {
        return (_this.styles = [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#c9c9c9",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
        ]);
      } else if (_this.theme === "dark") {
        return (_this.styles = [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#212121",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#212121",
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#181818",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#1b1b1b",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#2c2c2c",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#8a8a8a",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#373737",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#3c3c3c",
              },
            ],
          },
          {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
              {
                color: "#4e4e4e",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#000000",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#3d3d3d",
              },
            ],
          },
        ]);
      }
    };

    return CoreMap;
  })();

  theme.classes.CoreMediaQueries = (function () {
    function CoreMediaQueries() {
      this.screenSizeListener = bind(this.screenSizeListener, this);
      this.getScreenSize = bind(this.getScreenSize, this);
      this.medium_screen = 768;
      this.large_screen = 1024;
      this.current_window = null;
      this.getScreenSize();
      this.screenSizeListener();
    }

    CoreMediaQueries.prototype.getScreenSize = function () {
      var _this, mq_updated_event, previous_window;
      _this = this;
      previous_window = _this.current_window;
      if (
        window.matchMedia(
          "only screen and (min-width: " + _this.large_screen + "px)",
        ).matches
      ) {
        if (_this.current_window !== "large") {
          _this.current_window = "large";
        }
      } else if (
        window.matchMedia(
          "only screen and (min-width: " + _this.medium_screen + "px)",
        ).matches
      ) {
        if (_this.current_window !== "medium") {
          _this.current_window = "medium";
        }
      } else {
        if (_this.current_window !== "small") {
          _this.current_window = "small";
        }
      }
      if (_this.current_window !== previous_window) {
        mq_updated_event = new Event("theme:utils:mqs:updated");
        return window.dispatchEvent(mq_updated_event);
      }
    };

    CoreMediaQueries.prototype.screenSizeListener = function () {
      var _this;
      _this = this;
      return window.addEventListener("resize", function () {
        return _this.getScreenSize();
      });
    };

    return CoreMediaQueries;
  })();

  theme.classes.CoreModal = (function () {
    function CoreModal(root) {
      var _this;
      this.root = root;
      this.transitionListeners = bind(this.transitionListeners, this);
      _this = this;
      _this.fullscreen = _this.root.data("modal-fullscreen") ? true : false;
      if (_this.root.data("modal-custom-close")) {
        _this.custom_close_button = _this.root.data("modal-custom-close");
      } else {
        _this.custom_close_button = "";
      }
      _this.document_el = el(document);
      _this.force_view = _this.root.data("force-view");
      _this.view = _this.root.data("modal-view");
      _this.viewport = el(".offcanvas--viewport");
      _this.nested_links = _this.root.find(":scope .modal--root .modal--link");
      _this.nested_content = _this.root.find(
        ":scope .modal--root .modal--content",
      );
      _this.links = _this.root.find(".modal--link").not(_this.nested_links);
      _this.content = _this.root
        .find(".modal--content")
        .not(_this.nested_content);
      _this.window = el(".modal--window");
      _this.window_container = _this.window.find(".modal--container");
      _this.mask = _this.window.find(".modal--mask");
      _this.close_button = _this.window.find(".modal--close");
      _this.next_button = _this.window.find(".modal--next");
      _this.prev_button = _this.window.find(".modal--prev");
      _this.slider = null;
      _this.slides = null;
      _this.main_content_window = el(".off-canvas--main-content");
      _this.openListeners();
      _this.transitionListeners();
      _this.modal_state = "closed";
      _this.nav_lock = false;
    }

    CoreModal.prototype.openListeners = function () {
      var _this;
      _this = this;
      return _this.links.on(
        "keypress.CoreModal, click.CoreModal, quick-open",
        function (event) {
          var clicked_item;
          if (
            event.type === "keypress" &&
            theme.utils.a11yClick(event) === false
          ) {
            return false;
          }
          clicked_item = el(this);
          _this.links.each(function (link, index) {
            if (el(link).is(clicked_item)) {
              if (event.type === "quick-open") {
                return _this.open(index, true);
              } else {
                return _this.open(index);
              }
            }
          });
          event.preventDefault();
          return event.stopPropagation();
        },
      );
    };

    CoreModal.prototype.open = function (index, quick_open) {
      var _this, scrolled_position;
      if (quick_open == null) {
        quick_open = false;
      }
      _this = this;
      if (_this.modal_state === "closed") {
        _this.modal_state = "opened";
        theme.body.attr("data-modal-open", true);
        theme.window.trigger("theme:modal:opened");
        _this.window.attr("data-modal-fullscreen", _this.fullscreen);
        _this.window.attr("data-modal-custom-close", _this.custom_close_button);
        _this.window.attr("data-modal-view", _this.view);
        _this.viewport.css("overflow", "hidden");
        _this.closeListeners();
        _this.positionListeners();
        scrolled_position = window.pageYOffset;
        _this.main_content_window.css("position", "fixed");
        _this.main_content_window.css("top", "-" + scrolled_position + "px");
        _this.moveContentToWindow();
        if (_this.slides.length > 1) {
          _this.next_button.show();
          _this.prev_button.show();
          _this.prevListeners();
          _this.nextListeners();
        }
        _this.window.css("visibility", "visible");
        _this.window_container.show();
        if (quick_open) {
          _this.slides.eq(index).addClass("active");
          return _this.position();
        } else {
          _this.mask.attr("data-transition", "forwards");
          return _this.loadModal(_this.slides.eq(index), function () {
            return setTimeout(function () {
              return _this.window_container.find('input[type="text"]').focus();
            }, 0);
          });
        }
      }
    };

    CoreModal.prototype.moveContentToWindow = function () {
      var _this, content;
      _this = this;
      content = _this.root.find(".modal--content").not(_this.nested_content);
      _this.window_container.append(content);
      return (_this.slides = _this.window_container.find(".modal--content"));
    };

    CoreModal.prototype.extractVideoType = function (src_url) {
      var _this, matches, re;
      _this = this;
      re =
        /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
      matches = re.exec(src_url);
      if (matches) {
        return "youtube";
      }
      re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
      matches = re.exec(src_url);
      if (matches) {
        return "vimeo";
      }
      re = /^.*(kickstarter)\.com/g;
      matches = re.exec(src_url);
      if (matches) {
        return "kickstarter";
      }
      return false;
    };

    CoreModal.prototype.extractVideoId = function (src_url, type) {
      var _this, match, regExp;
      _this = this;
      if (type === "youtube") {
        regExp =
          /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        match = src_url.match(regExp);
        if (match && match[2].length === 11) {
          return match[2];
        }
      } else if (type === "vimeo") {
        regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
        match = src_url.match(regExp);
        if (match) {
          return match[2];
        }
      } else if (type === "kickstarter") {
        regExp = /(?:kickstarter\.com\/projects\/)(.*)(|\?)/;
        match = src_url.match(regExp);
        if (match) {
          return match[1];
        }
      }
    };

    CoreModal.prototype.createIframe = function (type, id) {
      var _this;
      _this = this;
      if (type === "youtube") {
        return (
          "<iframe src='//www.youtube.com/embed/" +
          id +
          "?autoplay=1' frameborder='0' allowfullwidth></iframe>"
        );
      } else if (type === "vimeo") {
        return (
          "<iframe src='//player.vimeo.com/video/" +
          id +
          "?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?' frameborder='0' webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
        );
      } else if (type === "kickstarter") {
        return (
          "<iframe src='//www.kickstarter.com/projects/" +
          id +
          "/widget/video.html' frameborder='0' webkitallowfullwidth mozallowfullwidth allowfullwidth></iframe>"
        );
      }
    };

    CoreModal.prototype.loadModal = function (modal, callback) {
      var _this;
      _this = this;
      modal.addClass("active");
      _this.position();
      if (callback) {
        callback();
      }
      return (_this.nav_lock = false);
    };

    CoreModal.prototype.position = function () {
      var _this, active_modal, entire_modal_height, modal_height, modal_width;
      _this = this;
      if (_this.window_container != null) {
        active_modal = _this.content.filter(".active");
        _this.window_container.removeAttr("style");
        _this.window.removeClass("fixed");
        modal_height = active_modal.outerHeight();
        modal_width = active_modal.outerWidth();
        entire_modal_height =
          modal_height +
          parseInt(_this.window.css("padding-top")) +
          parseInt(_this.window.css("padding-bottom"));
        if (_this.fullscreen) {
          return;
        }
        if (active_modal.hasClass("type--image")) {
          entire_modal_height = modal_height;
        }
        if (
          window.innerHeight >= entire_modal_height &&
          _this.force_view !== "absolute"
        ) {
          return _this.window.addClass("fixed");
        } else {
          document.querySelectorAll("html, body").forEach(function (el) {
            return el.scrollTo(0, 0);
          });
          return _this.window.removeClass("fixed");
        }
      }
    };

    CoreModal.prototype.positionListeners = function () {
      var _this;
      _this = this;
      return theme.window.on("resize.CoreModal", function () {
        return _this.position();
      });
    };

    CoreModal.prototype.nextListeners = function () {
      var _this;
      _this = this;
      _this.document_el.on("keydown.CoreModal", function (event) {
        if (event.keyCode === 39) {
          return _this.next();
        }
      });
      return _this.next_button.on("click.CoreModal", function () {
        return _this.next();
      });
    };

    CoreModal.prototype.next = function () {
      var _this, active_slide, index;
      _this = this;
      if (!_this.nav_lock) {
        _this.nav_lock = true;
        index = _this.slides.filter(".active").index();
        _this.slides.removeClass("active");
        if (index + 1 === _this.slides.length) {
          active_slide = _this.slides.eq(0);
        } else {
          active_slide = _this.slides.eq(index + 1);
        }
        return _this.loadModal(active_slide);
      }
    };

    CoreModal.prototype.prevListeners = function () {
      var _this;
      _this = this;
      _this.document_el.on("keydown.CoreModal", function (event) {
        if (event.keyCode === 37) {
          return _this.prev();
        }
      });
      return _this.prev_button.on("click.CoreModal", function () {
        return _this.prev();
      });
    };

    CoreModal.prototype.prev = function () {
      var _this, active_slide, index;
      _this = this;
      if (!_this.nav_lock) {
        _this.nav_lock = true;
        index = _this.slides.filter(".active").index();
        _this.slides.removeClass("active");
        if (index === 0) {
          active_slide = _this.slides.eq(_this.slides.length - 1);
        } else {
          active_slide = _this.slides.eq(index - 1);
        }
        return _this.loadModal(active_slide);
      }
    };

    CoreModal.prototype.closeListeners = function () {
      var _this;
      _this = this;
      _this.root.on("quick-close", function () {
        return _this.close(true);
      });
      _this.document_el.on("keydown.CoreModal", function (event) {
        if (event.keyCode === 27) {
          return _this.close();
        }
      });
      _this.mask.on("click.CoreModal", function () {
        return _this.close();
      });
      _this.window_container.on("click.CoreModal", function () {
        return _this.close();
      });
      _this.content.on("click.CoreModal", function (event) {
        return event.stopPropagation();
      });
      return _this.close_button.on(
        "click.CoreModal keydown.CoreModal",
        function () {
          if (event.type === "keydown" && event.key !== "Enter") {
            return;
          }
          return _this.close();
        },
      );
    };

    CoreModal.prototype.close = function (quick_close) {
      var _this, scrolled_position;
      if (quick_close == null) {
        quick_close = false;
      }
      _this = this;
      scrolled_position = parseInt(_this.main_content_window.css("top")) * -1;
      theme.body.attr("data-modal-open", false);
      theme.window.trigger("theme:modal:closed");
      _this.main_content_window.css("top", "0");
      _this.main_content_window.css("position", "relative");
      _this.viewport.css("overflow", "unset");
      window.scrollTo(0, scrolled_position);
      _this.putBackContent();
      _this.next_button.hide();
      _this.prev_button.hide();
      _this.window.css("visibility", "hidden");
      if (quick_close) {
        _this.mask.hide();
        _this.window_container.empty();
        _this.modal_state = "closed";
      } else {
        _this.mask.attr("data-transition", "backwards");
      }
      return _this.removeListeners();
    };

    CoreModal.prototype.putBackContent = function () {
      var _this;
      _this = this;
      return _this.root.append(_this.slides.removeClass("active"));
    };

    CoreModal.prototype.removeListeners = function () {
      var _this;
      _this = this;
      _this.document_el.off("keydown.CoreModal");
      theme.window.off("resize.CoreModal");
      el("body,html").off(
        "DOMMouseScroll.CoreModal mousewheel.CoreModal touchmove.CoreModal",
      );
      _this.next_button.off("click.CoreModal");
      _this.prev_button.off("click.CoreModal");
      _this.close_button.off("click.CoreModal");
      _this.close_button.off("keydown.CoreModal");
      _this.mask.off("click.CoreModal");
      return _this.window_container.off("click.CoreModal");
    };

    CoreModal.prototype.transitionListeners = function () {
      var _this;
      _this = this;
      return _this.mask.on("transition:at_start", function () {
        _this.window_container.empty();
        return (_this.modal_state = "closed");
      });
    };

    return CoreModal;
  })();

  theme.classes.CoreOffCanvas = (function () {
    function CoreOffCanvas(root) {
      var _this;
      this.root = root;
      this.transitionListeners = bind(this.transitionListeners, this);
      this.touchListener = bind(this.touchListener, this);
      this.setFocus = bind(this.setFocus, this);
      this.closeRightComplete = bind(this.closeRightComplete, this);
      this.closeRight = bind(this.closeRight, this);
      this.closeLeftComplete = bind(this.closeLeftComplete, this);
      this.closeLeft = bind(this.closeLeft, this);
      this.openRightComplete = bind(this.openRightComplete, this);
      this.openRight = bind(this.openRight, this);
      this.openLeftComplete = bind(this.openLeftComplete, this);
      this.openLeft = bind(this.openLeft, this);
      this.toggle = bind(this.toggle, this);
      this.closeWithEscKey = bind(this.closeWithEscKey, this);
      this.closeWhenFocusOut = bind(this.closeWhenFocusOut, this);
      this.toggleListeners = bind(this.toggleListeners, this);
      this.viewPortHeightListener = bind(this.viewPortHeightListener, this);
      this.setViewPortHeight = bind(this.setViewPortHeight, this);
      this.setState = bind(this.setState, this);
      this.unload = bind(this.unload, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.left_sidebar = _this.root.find(".off-canvas--left-sidebar");
      _this.right_sidebar = _this.root.find(".off-canvas--right-sidebar");
      _this.focus_triggers = _this.root.find(".off-canvas--focus-trigger");
      _this.main_content = _this.root.find(".off-canvas--main-content");
      _this.overlay = _this.root.find(".off-canvas--overlay");
      _this.state = "closed";
      _this.load();
    }

    CoreOffCanvas.prototype.load = function () {
      var _this;
      _this = this;
      _this.close = el("[data-off-canvas--close]");
      _this.triggers = el("[data-off-canvas--open]");
      _this.setViewPortHeight();
      _this.viewPortHeightListener();
      _this.toggleListeners();
      _this.touchListener();
      _this.closeWhenFocusOut();
      _this.closeWithEscKey();
      return _this.transitionListeners();
    };

    CoreOffCanvas.prototype.unload = function () {
      var _this;
      _this = this;
      _this.triggers.off("click keydown");
      return _this.overlay.add(_this.close).off("click");
    };

    CoreOffCanvas.prototype.setState = function (state) {
      var _this;
      _this = this;
      _this.state = state;
      _this.root.attr("data-off-canvas--state", state);
      // GC-197: the menu button says whether the menu is open.
      _this.triggers.el.forEach(
        /**
         * @param {HTMLElement} trigger - an element that opens a drawer
         * @returns {void}
         */
        function (trigger) {
          if (trigger.dataset["offCanvas-Open"] === "left-sidebar") {
            trigger.setAttribute("aria-expanded", state.indexOf("left--open") === 0);
          }
        },
      );
      if (_this.state === "left--opening") {
        _this.left_sidebar.attr("data-transition", "forwards");
        _this.overlay.attr("data-transition", "forwards");
      }
      if (_this.state === "left--closing") {
        _this.left_sidebar.attr("data-transition", "backwards");
        _this.overlay.attr("data-transition", "backwards");
      }
      if (_this.state === "right--opening") {
        _this.right_sidebar.attr("data-transition", "forwards");
        _this.overlay.attr("data-transition", "forwards");
      }
      if (_this.state === "right--closing") {
        _this.right_sidebar.attr("data-transition", "backwards");
        return _this.overlay.attr("data-transition", "backwards");
      }
    };

    CoreOffCanvas.prototype.setViewPortHeight = function () {
      var _this;
      _this = this;
      return _this.root.css("min-height", window.innerHeight + "px");
    };

    CoreOffCanvas.prototype.viewPortHeightListener = function () {
      var _this;
      _this = this;
      return window.addEventListener("resize", function () {
        return _this.setViewPortHeight();
      });
    };

    CoreOffCanvas.prototype.toggleListeners = function () {
      var _this;
      _this = this;
      _this.triggers.on("click keydown", function (event) {
        var drawer;
        if (event.type === "keydown" && !_this.isActivationKey(event, this)) {
          return;
        }
        drawer = this.dataset["offCanvas-Open"];
        _this.last_trigger = this;
        if (drawer === "left-sidebar") {
          _this.toggle("left-sidebar");
        } else if (drawer === "right-sidebar") {
          _this.right_sidebar_view = this.dataset["offCanvas-View"];
          _this.right_sidebar.attr("data-active", _this.right_sidebar_view);
          if (_this.right_sidebar_view === "product-form") {
            theme.classes.Product.initQuickAddForm(this);
          } else if (_this.right_sidebar_view === "collection-filter") {
            theme.classes.Collection.toggleFilterMenu(this);
          } else if (
            _this.right_sidebar_view === "cart" &&
            this.dataset.productId
          ) {
            event.preventDefault();
            event.stopPropagation();
            theme.classes.Product.quickAddToCart(this);
            return false;
          }
          _this.toggle("right-sidebar");
        }
        event.preventDefault();
        return event.stopPropagation();
      });
      return _this.overlay.add(_this.close).on("click keydown", function (event) {
        if (event.type === "keydown") {
          if (!_this.isActivationKey(event, this)) {
            return;
          }
          event.preventDefault();
        }
        if (_this.state === "left--opened") {
          return _this.toggle("left-sidebar");
        } else if (_this.state === "right--opened") {
          return _this.toggle("right-sidebar");
        }
      });
    };

    /**
     * Enter on any trigger, or Space on a role="button" element, as a native button does (GC-197).
     * Links keep Space for scrolling.
     * @param {KeyboardEvent} event - the keydown
     * @param {HTMLElement} element - the trigger or close control
     * @returns {boolean} true when the key should activate the element
     */
    CoreOffCanvas.prototype.isActivationKey = function (event, element) {
      return (
        event.key === "Enter" ||
        (event.key === " " && element.getAttribute("role") === "button")
      );
    };

    CoreOffCanvas.prototype.closeWhenFocusOut = function () {
      var _this, close_x;
      _this = this;
      // GC-197: the shared close X sits outside both drawers. Tab or Shift+Tab out of an open drawer
      // lands on it first; the next Tab or Shift+Tab from it closes the drawer, as leaving it did before.
      close_x = document.querySelector(
        ".off-canvas--overlay + [data-off-canvas--close]",
      );
      // load() runs again on every cart re-render: bind once.
      if (close_x && !close_x.gcTabClose) {
        close_x.gcTabClose = true;
        close_x.addEventListener("keydown", function (event) {
          if (
            event.key === "Tab" &&
            (_this.state === "left--opened" || _this.state === "right--opened")
          ) {
            event.preventDefault();
            return _this.state === "left--opened"
              ? _this.closeLeft()
              : _this.closeRight();
          }
        });
      }
      return _this.focus_triggers.on("focus", function (event) {
        if (
          close_x &&
          event.relatedTarget !== close_x &&
          (_this.state === "left--opened" || _this.state === "right--opened")
        ) {
          return close_x.focus();
        }
        if (_this.state === "left--opened") {
          return _this.closeLeft();
        } else if (_this.state === "right--opened") {
          return _this.closeRight();
        }
      });
    };

    CoreOffCanvas.prototype.closeWithEscKey = function () {
      var _this;
      _this = this;
      return window.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") {
          return;
        }
        if (_this.state === "left--opened") {
          return _this.closeLeft();
        } else if (_this.state === "right--opened") {
          return _this.closeRight();
        }
      });
    };

    CoreOffCanvas.prototype.toggle = function (element) {
      var _this;
      _this = this;
      if (element === "left-sidebar" && _this.state === "closed") {
        return _this.openLeft();
      } else if (element === "left-sidebar" && _this.state === "left--opened") {
        return _this.closeLeft();
      } else if (element === "right-sidebar" && _this.state === "closed") {
        return _this.openRight();
      } else if (
        element === "right-sidebar" &&
        _this.state === "right--opened"
      ) {
        return _this.closeRight();
      }
    };

    CoreOffCanvas.prototype.openLeft = function () {
      var _this;
      _this = this;
      _this.root.css("overflow", "hidden");
      _this.left_sidebar.css("display", "block");
      _this.window_offset = window.pageYOffset;
      _this.main_content.css("top", "-" + _this.window_offset + "px");
      _this.main_content.css("position", "fixed");
      _this.setState("left--opening");
      return window.scrollTo(0, 0);
    };

    CoreOffCanvas.prototype.openLeftComplete = function () {
      var _this;
      _this = this;
      _this.setFocus("left-sidebar");
      return _this.left_sidebar
        .find(".disclosure--root")
        .trigger("update_form_position");
    };

    CoreOffCanvas.prototype.openRight = function () {
      var _this;
      _this = this;
      _this.root.css("overflow", "hidden");
      _this.right_sidebar.css("display", "block");
      // The panel goes from display none to its sliding state in one turn. Without a style flush between the two, WebKit
      // has no starting style and runs no transition: the panel never slides, and data-transition stays "forwards".
      // Chromium already gets one before the state changes here, so it slides either way.
      if (_this.right_sidebar.el[0]) {
        void _this.right_sidebar.el[0].offsetWidth;
      }
      _this.window_offset = window.pageYOffset;
      _this.main_content.css("top", "-" + _this.window_offset + "px");
      _this.main_content.css("position", "fixed");
      _this.setState("right--opening");
      return window.scrollTo(0, 0);
    };

    CoreOffCanvas.prototype.openRightComplete = function () {
      var _this;
      _this = this;
      _this.setFocus("right-sidebar");
      return _this.right_sidebar
        .find(".disclosure--root")
        .trigger("update_form_position");
    };

    CoreOffCanvas.prototype.closeLeft = function () {
      var _this;
      _this = this;
      _this.setState("left--closing");
      return _this.last_trigger.focus();
    };

    CoreOffCanvas.prototype.closeLeftComplete = function () {
      var _this;
      _this = this;
      _this.root.css("overflow", "unset");
      _this.left_sidebar.css("display", "none");
      _this.main_content.css("position", "relative");
      _this.main_content.css("top", "initial");
      return window.scrollTo(0, _this.window_offset);
    };

    CoreOffCanvas.prototype.closeRight = function () {
      var _this;
      _this = this;
      _this.setState("right--closing");
      return _this.last_trigger.focus();
    };

    CoreOffCanvas.prototype.closeRightComplete = function () {
      var _this;
      _this = this;
      _this.root.css("overflow", "unset");
      _this.right_sidebar.css("display", "none");
      _this.main_content.css("position", "relative");
      _this.main_content.css("top", "initial");
      return window.scrollTo(0, _this.window_offset);
    };

    CoreOffCanvas.prototype.setFocus = function (element) {
      var _this, current_view, focusable_elements;
      _this = this;
      if (element === "right-sidebar") {
        current_view = _this.right_sidebar.find(
          "[data-view='" + _this.right_sidebar_view + "']",
        );
      } else if ((element = "left-sidebar")) {
        current_view = _this.left_sidebar.find("[data-view='menu']");
      }
      focusable_elements = theme.utils.getFocusableEl(current_view);
      if (focusable_elements) {
        return focusable_elements.focus(0);
      }
    };

    CoreOffCanvas.prototype.touchListener = function () {
      var _this;
      _this = this;
      if (!theme.utils.isTouchDevice()) {
        return;
      }
      document.addEventListener("theme:swipe:left", function () {
        if (_this.state === "left--opened") {
          return _this.closeLeft();
        }
      });
      return document.addEventListener("theme:swipe:right", function () {
        if (_this.state === "right--opened") {
          return _this.closeRight();
        }
      });
    };

    CoreOffCanvas.prototype.transitionListeners = function () {
      var _this;
      _this = this;
      _this.overlay.on("transition:at_start", function () {
        if (_this.state === "left--closing") {
          _this.setState("closed");
          _this.closeLeftComplete();
        }
        if (_this.state === "right--closing") {
          _this.setState("closed");
          return _this.closeRightComplete();
        }
      });
      return _this.overlay.on("transition:at_end", function () {
        if (_this.state === "left--opening") {
          _this.setState("left--opened");
          _this.openLeftComplete();
        }
        if (_this.state === "right--opening") {
          _this.setState("right--opened");
          return _this.openRightComplete();
        }
      });
    };

    return CoreOffCanvas;
  })();

  theme.classes.CoreProductModel = (function () {
    function CoreProductModel(root) {
      var _this;
      this.root = root;
      this.loadModel = bind(this.loadModel, this);
      this.loadAssets = bind(this.loadAssets, this);
      this.eventListeners = bind(this.eventListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.all_models = el(".product-model--root");
      _this.view = _this.root.data("view");
      _this.key = _this.root.closest("[data-id]").data("id");
      _this.cdn =
        "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui";
      _this.xr_cdn =
        "https://cdn.shopify.com/shopifycloud/shopify-xr-js/assets/v1.0/shopify-xr.en.js";
      _this.load();
    }

    CoreProductModel.prototype.load = function () {
      var _this;
      _this = this;
      _this.eventListeners();
      if (theme.utils.modelAssetsAdded) {
        return;
      }
      theme.utils.modelAssetsAdded = true;
      return _this.loadAssets();
    };

    CoreProductModel.prototype.eventListeners = function () {
      var _this;
      _this = this;
      _this.root.on("model-ready", function () {
        return _this.loadModel();
      });
      _this.root.on("theme:section:load", function () {
        return _this.loadModel();
      });
      _this.root.on("pause-media", function () {
        if (_this.model) {
          return _this.model.pause();
        }
      });
      _this.root.on("play-media", function () {
        if (_this.model) {
          return _this.model.play();
        }
      });
      return theme.window.on(
        "resize.ProductModel",
        theme.utils.debounce(250, function () {
          _this.all_models.trigger("pause-media");
          return _this.all_models.trigger("model-ready");
        }),
      );
    };

    CoreProductModel.prototype.loadAssets = function () {
      var _this;
      _this = this;
      theme.utils.insertStylesheet(_this.cdn + ".css");
      theme.utils.insertScript(_this.xr_cdn);
      return theme.utils.insertScript(_this.cdn + ".en.js", function () {
        return _this.all_models.trigger("model-ready");
      });
    };

    CoreProductModel.prototype.loadModel = function () {
      var _this;
      _this = this;
      if (_this.model) {
        return;
      }
      if (
        theme.utils.mqs.current_window === "small" &&
        _this.view === "desktop"
      ) {
        return;
      } else if (
        theme.utils.mqs.current_window !== "small" &&
        _this.view === "mobile"
      ) {
        return;
      }
      if (typeof Shopify !== "undefined") {
        return (_this.model = new Shopify.ModelViewerUI(
          _this.root.find("model-viewer").el[0],
        ));
      }
    };

    return CoreProductModel;
  })();

  theme.classes.CoreProductRecommendations = (function () {
    function CoreProductRecommendations(root) {
      var _this, max_products, product_id;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.loadHoverImages = bind(this.loadHoverImages, this);
      this.initProductItems = bind(this.initProductItems, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_width = window.innerWidth;
      product_id = _this.root.attr("data-product-id");
      max_products = _this.root.attr("data-max-products");
      _this.request_url =
        theme.urls.product_recommendations +
        "?section_id=product-recommendations&limit=" +
        max_products +
        "&product_id=" +
        product_id;
      _this.load();
    }

    CoreProductRecommendations.prototype.load = function () {
      var _this, request;
      _this = this;
      request = new XMLHttpRequest();
      request.onload = function () {
        var html, number_of_products;
        if (request.status >= 200 && request.status < 300) {
          html = theme.utils.parseHtml(
            request.response,
            ".product-recommendations--wrapper",
          );
          _this.root.append(html);
          number_of_products = _this.root.find(".product--root").length;
          if (!number_of_products) {
            _this.root.hide();
            return;
          }
          _this.matchImageHeights();
          _this.initProductItems();
          _this.loadHoverImages();
          return _this.resizeListeners();
        }
      };
      request.onerror = function () {
        return console.log(
          request.statusText + ": recommendation HTML request failed!",
        );
      };
      request.open("GET", _this.request_url);
      return request.send();
    };

    CoreProductRecommendations.prototype.matchImageHeights = function () {
      var _this, item_container, items;
      _this = this;
      item_container = _this.root.find(".product-recommendations--body");
      items = _this.root.find(".product--root");
      return theme.utils.matchImageHeights(
        item_container,
        items,
        ".product--image-wrapper:not(.stack_wrapper) ",
      );
    };

    CoreProductRecommendations.prototype.initProductItems = function () {
      var _this;
      _this = this;
      if (theme.settings.quick_add) {
        theme.partials.OffCanvas.unload();
        theme.partials.OffCanvas.load();
      }
      return theme.utils.loadJsClasses(_this.root);
    };

    CoreProductRecommendations.prototype.loadHoverImages = function () {
      var _this;
      _this = this;
      return _this.root
        .find(".product--hover-image")
        .each(function (hover_image) {
          hover_image = el(hover_image);
          return theme.utils.imagesLoaded(hover_image, function () {
            var product;
            product = hover_image.closest('[data-hover-image="true"]');
            return product.attr("data-hover-image", "loaded");
          });
        });
    };

    CoreProductRecommendations.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.ProductRecommendations",
        theme.utils.debounce(100, function () {
          if (_this.current_width !== window.innerWidth) {
            _this.matchImageHeights();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    return CoreProductRecommendations;
  })();

  theme.classes.CoreProductVideo = (function () {
    function CoreProductVideo(root) {
      var _this;
      this.root = root;
      this.skipVideo = bind(this.skipVideo, this);
      this.loadYoutubeVideo = bind(this.loadYoutubeVideo, this);
      this.loadPlyrVideo = bind(this.loadPlyrVideo, this);
      this.loadYoutubeAsset = bind(this.loadYoutubeAsset, this);
      this.loadPlyrAssets = bind(this.loadPlyrAssets, this);
      this.resizeListener = bind(this.resizeListener, this);
      this.youtubeListeners = bind(this.youtubeListeners, this);
      this.plyrListeners = bind(this.plyrListeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.all_videos = el(".product-video--root");
      _this.view = _this.root.data("view");
      _this.type = _this.root.data("type");
      _this.loop_enabled = _this.root.data("loop-enabled");
      _this.load();
    }

    CoreProductVideo.prototype.load = function () {
      var _this;
      _this = this;
      _this.resizeListener();
      if (_this.type === "youtube") {
        _this.id = _this.root.find(".product-video").attr("id");
        _this.video_id = _this.root.data("video-id");
        _this.youtubeListeners();
        return _this.loadYoutubeAsset();
      } else {
        _this.plyr_cdn =
          "https://cdn.shopify.com/shopifycloud/plyr/v2.0/shopify-plyr";
        _this.plyrListeners();
        return _this.loadPlyrAssets();
      }
    };

    CoreProductVideo.prototype.plyrListeners = function () {
      var _this;
      _this = this;
      _this.root.on("plyr-video-ready", function () {
        return _this.loadPlyrVideo();
      });
      _this.root.on("theme:section:load", function () {
        return _this.loadPlyrVideo();
      });
      _this.root.on("pause-media", function () {
        if (_this.video) {
          return _this.video.pause();
        }
      });
      return _this.root.on("play-media", function () {
        if (_this.video) {
          return _this.video.play();
        }
      });
    };

    CoreProductVideo.prototype.youtubeListeners = function () {
      var _this;
      _this = this;
      window.addEventListener("theme:utils:youtubeAPIReady", function () {
        return _this.loadYoutubeVideo();
      });
      return _this.root.on("theme:section:load", function () {
        return _this.loadYoutubeVideo();
      });
    };

    CoreProductVideo.prototype.resizeListener = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.ProductVideo",
        theme.utils.debounce(250, function () {
          _this.all_videos.trigger("pause-media");
          _this.all_videos.trigger("plyr-video-ready");
          return _this.all_videos.trigger("theme:utils:youtubeAPIReady");
        }),
      );
    };

    CoreProductVideo.prototype.loadPlyrAssets = function () {
      var _this;
      _this = this;
      if (theme.utils.plyrScriptAdded) {
        return;
      }
      theme.utils.plyrScriptAdded = true;
      theme.utils.insertStylesheet(_this.plyr_cdn + ".css");
      return theme.utils.insertScript(_this.plyr_cdn + ".en.js", function () {
        return _this.all_videos.trigger("plyr-video-ready");
      });
    };

    CoreProductVideo.prototype.loadYoutubeAsset = function () {
      var _this;
      _this = this;
      if (theme.utils.youtube_script_added) {
        return;
      }
      theme.utils.youtube_script_added = true;
      return theme.utils.insertScript("https://www.youtube.com/iframe_api");
    };

    CoreProductVideo.prototype.loadPlyrVideo = function () {
      var _this;
      _this = this;
      if (_this.video) {
        return;
      }
      if (_this.skipVideo()) {
        return;
      }
      if (typeof Shopify !== "undefined") {
        return (_this.video = new Shopify.Video(
          _this.root.find("video").el[0],
          {
            iconUrl: _this.plyr_cdn + ".svg",
            loop: {
              active: _this.loop_enabled,
            },
          },
        ));
      }
    };

    CoreProductVideo.prototype.loadYoutubeVideo = function () {
      var _this;
      _this = this;
      if (_this.video) {
        return;
      }
      if (_this.skipVideo()) {
        return;
      }
      if (typeof YT !== "undefined") {
        return (_this.video = new YT.Player(_this.id, {
          videoId: _this.video_id,
          events: {
            onReady: function (event) {
              _this.root.on("pause-media", function () {
                return event.target.pauseVideo();
              });
              return _this.root.on("play-media", function () {
                return event.target.playVideo();
              });
            },
            onStateChange: function (event) {
              if (event.data === 0 && _this.loop_enabled) {
                event.target.seekTo(0);
              }
              if (event.data === 1) {
                return el(".product-media--featured > *")
                  .not(_this.root)
                  .trigger("pause-media");
              }
            },
          },
        }));
      }
    };

    CoreProductVideo.prototype.skipVideo = function () {
      var _this;
      _this = this;
      if (
        theme.utils.mqs.current_window === "small" &&
        _this.view === "desktop"
      ) {
        return true;
      } else if (
        theme.utils.mqs.current_window !== "small" &&
        _this.view === "mobile"
      ) {
        return true;
      } else {
        return false;
      }
    };

    return CoreProductVideo;
  })();

  theme.classes.CoreProduct = (function () {
    function CoreProduct(root) {
      var _this;
      this.root = root;
      this.updateRecentList = bind(this.updateRecentList, this);
      this.thumbNavigation = bind(this.thumbNavigation, this);
      this.initZoomListener = bind(this.initZoomListener, this);
      this.getActiveImageId = bind(this.getActiveImageId, this);
      this.imageZoom = bind(this.imageZoom, this);
      this.updateVariantMedia = bind(this.updateVariantMedia, this);
      this.addToCartListener = bind(this.addToCartListener, this);
      this.updatePrices = bind(this.updatePrices, this);
      this.backInStockListener = bind(this.backInStockListener, this);
      this.getBackInStockVariant = bind(this.getBackInStockVariant, this);
      this.updateBackInStock = bind(this.updateBackInStock, this);
      this.enableStockForm = bind(this.enableStockForm, this);
      this.enableCartButtons = bind(this.enableCartButtons, this);
      this.variantSelected = bind(this.variantSelected, this);
      this.updateHistoryState = bind(this.updateHistoryState, this);
      this.updateVariant = bind(this.updateVariant, this);
      this.optionChangeListener = bind(this.optionChangeListener, this);
      this.getOptionValue = bind(this.getOptionValue, this);
      this.updateDisabledOptions = bind(this.updateDisabledOptions, this);
      this.disableEmptyOptions = bind(this.disableEmptyOptions, this);
      this.getAvailableVariants = bind(this.getAvailableVariants, this);
      this.updateLowInStock = bind(this.updateLowInStock, this);
      this.inLowStockHypothesis = bind(this.inLowStockHypothesis, this);
      this.sizeChart = bind(this.sizeChart, this);
      this.updatePickup = bind(this.updatePickup, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.is_product_page = _this.root.hasClass("product-page--root");
      // _this.product_json = JSON.parse(_this.root.find('.product-form--json').val());
      // Null check
      // GC-192: a card's JSON (snippets/product-grid-add.liquid) has only options + variant id, available, options,
      // price, compare_at_price, inventory_management; read another field here and add it there too.
      var productFormJson = _this.root.find(".product-form--json");
      _this.product_json =
        productFormJson.length && productFormJson.val()
          ? JSON.parse(productFormJson.val())
          : null;

      _this.form_root = _this.root.find(".product-form--root");
      _this.thumbs_root = _this.root.find(
        '.product-media--root[data-view="thumb-container"]',
      );
      _this.featured_root = _this.root
        .find('.product-media--root[data-view="featured"]')
        .not('[data-media-size="mobile"]');
      if (_this.featured_root) {
        _this.magnify = _this.featured_root.data("magnify");
        _this.main_media = _this.featured_root.find(".product-media--featured");
        _this.media_container = _this.featured_root.closest(
          ".product-media--wrapper",
        );
        _this.thumbs = _this.thumbs_root.find(".product-media--thumb");
        _this.zoom_enabled = _this.featured_root.data("zoom-enabled");
        _this.zoom_images = _this.featured_root.find(
          ".product-media--zoom-image",
        );
      }
      if (_this.form_root) {
        _this.add_to_cart_button = _this.form_root.find(
          ".product-form--add-to-cart",
        );
        _this.back_in_stock_forms = _this.form_root.find(
          ".back-in-stock--form",
        );
        _this.back_in_stock_signed_up = {};
        _this.button_container = _this.form_root.find(
          ".product-form--button-container",
        );
        _this.button_text_container = _this.form_root.find(
          ".product-form--text",
        );
        _this.compare_price = _this.form_root.find(
          ".product-form--compare-price",
        );
        _this.form = _this.form_root.find(".product-form--container");
        _this.handle = _this.form_root.attr("data-handle");
        _this.is_only_variant = _this.form_root.data("is-only-variant");
        _this.low_stock_container = _this.form_root.find(
          ".product-form--low-stock",
        );
        _this.low_stock_threshold = _this.form_root.data("low-stock-amount");
        // attr, not data(): data() turns an id that starts with digits into a number
        _this.low_stock_hypothesis = _this.form_root.attr(
          "data-low-stock-hypothesis",
        );
        _this.options_container = _this.form_root.find(
          ".product-form--options",
        );
        _this.pickup_enabled = _this.form_root.data("pickup-enabled");
        _this.pickup_drawer_container = el(
          '.off-canvas--container[data-view="pickup"]',
        );
        _this.pickup_form_container = _this.root.find(".product-form--pickup");
        _this.price = _this.form_root.find(".product-form--price");
        _this.price_container = _this.form_root.find(
          ".product-form--price-container",
        );
        _this.product_title = _this.form_root.attr("data-title");
        _this.reference_unit = _this.form_root.find(
          ".product-form--reference-unit",
        );
        _this.reference_value = _this.form_root.find(
          ".product-form--reference-value",
        );
        _this.show_low_in_stock =
          _this.low_stock_threshold === void 0 ? false : true;
        _this.size_chart_enabled = _this.form_root.data("size-chart-enabled");

        // _this.size_chart_option = _this.form_root.attr('data-size-chart-option').toLowerCase();
        // Null check
        var sizeChartOption = _this.form_root.attr("data-size-chart-option");
        _this.size_chart_option = sizeChartOption
          ? sizeChartOption.toLowerCase()
          : "";

        _this.smart_payment_buttons = _this.form_root.find(
          ".product-form--smart-payment-buttons",
        );
        _this.sold_out = _this.form_root.data("sold-out");
        _this.unavailable_container = _this.form_root.find(
          ".product-form--unavailable",
        );
        _this.unavailable_button = _this.unavailable_container.find("button");
        _this.unit_price_container = _this.form_root.find(
          ".product-form--unit-price-container",
        );
        _this.unit_price = _this.form_root.find(".product-form--unit-price");
        _this.variant_listbox = _this.form_root.find(
          ".product-form--variant-select",
        );
        _this.first_variant = _this.variant_listbox.find("[selected]");
        _this.first_variant_available = _this.first_variant.data("available");
        _this.first_variant_id = parseInt(_this.first_variant.val());
        _this.first_variant_has_pickup = _this.first_variant.data("pickup");
        _this.option_inputs = _this.options_container.find(
          '[data-item="disclosure"], [data-item="radio"]',
        );
      }
      if (_this.product_json) {
        _this.load();
      }
    }

    CoreProduct.prototype.load = function () {
      var _this;
      _this = this;

      if (
        !_this.product_json ||
        !_this.product_json.variants ||
        _this.product_json.error
      ) {
        return;
      }

      // GC-195: a one-size product's sold-out size is crossed out (and read out) too.
      _this.getAvailableVariants();
      _this.disableEmptyOptions();
      if (_this.product_json.variants.length > 1) {
        _this.optionChangeListener();
        _this.updateDisabledOptions(_this.first_variant_available);
      }
      if (_this.product_json.variants.length > 1 && _this.size_chart_enabled) {
        _this.sizeChart();
      }
      if (
        _this.pickup_enabled &&
        _this.first_variant_has_pickup &&
        _this.sold_out === false
      ) {
        _this.updatePickup(_this.first_variant_id);
      }
      if (_this.show_low_in_stock && _this.sold_out === false) {
        _this.updateLowInStock(_this.first_variant_id);
      }
      if (_this.form.length > 0 && _this.sold_out === false) {
        _this.addToCartListener();
      }
      _this.backInStockListener();
      if (_this.zoom_enabled) {
        _this.initZoomListener();
      }
      if (_this.thumbs) {
        _this.thumbNavigation();
      }
      if (_this.handle) {
        return _this.updateRecentList();
      }
    };

    CoreProduct.prototype.updatePickup = function (variant_id) {
      var _this, request;
      _this = this;
      _this.pickup_form_container.attr("data-loading", true);
      request = new XMLHttpRequest();
      request.onload = function () {
        var drawer_el, form_el;
        if (request.status >= 200 && request.status < 300) {
          form_el = theme.utils.parseHtml(
            request.response,
            ".pickup--form--container",
          );
          _this.pickup_form_container.empty().append(form_el);
          _this.pickup_form_container.attr("data-loading", false);
          drawer_el = theme.utils.parseHtml(
            request.response,
            ".pickup--drawer--container",
          );
          if (drawer_el.length) {
            drawer_el
              .find(".pickup--drawer--product-title")
              .text(_this.product_title);
            if (_this.is_only_variant) {
              drawer_el.find(".pickup--drawer--variant-title").hide();
            }
            _this.pickup_drawer_container.empty().append(drawer_el);
          }
          theme.partials.OffCanvas.unload();
          return theme.partials.OffCanvas.load();
        }
      };
      request.onerror = function () {
        return console.log(
          request.statusText + ": product pickup request failed!",
        );
      };
      request.open(
        "GET",
        theme.urls.root + "/variants/" + variant_id + "/?section_id=pickup",
      );
      return request.send();
    };

    CoreProduct.prototype.sizeChart = function () {
      var _this;
      _this = this;
      _this.form_root
        .find(".disclosure--root, .radios--header")
        .each(function (input, index) {
          var option_name, size_chart_el;
          option_name = _this.product_json.options[index].name.toLowerCase();
          if (option_name === _this.size_chart_option) {
            size_chart_el = theme.utils.parseHtml(
              "<div class='product-form--modal-link' data-item='block-link'> <a class='modal--link' href='#'> " +
                theme.translations.size_chart_label +
                " </a> </div>",
              ".product-form--modal-link",
            );
            el(input).append(size_chart_el);
            return false;
          }
        });
      return new theme.classes.CoreModal(
        _this.form_root.find('[data-js-class="CoreModal"]'),
      );
    };

    /**
     * Shows "Only N items left" when the selected size has at or under the
     * section's threshold in stock, else hides it. With a Shoplift hypothesis
     * set, only a visitor Shoplift puts in that hypothesis sees it, and
     * Shoplift is asked only once a low size is selected.
     * @param {number|string} variant_id - The selected variant's id.
     * @returns {Object|Promise|undefined} The notice element, or a promise
     *   that settles after Shoplift answers.
     */
    CoreProduct.prototype.updateLowInStock = function (variant_id) {
      var _this, message, quantity;
      _this = this;
      quantity = _this.variant_listbox
        .find("[value='" + variant_id + "']")
        .data("inventory-quantity");
      if (!quantity || quantity < 1 || quantity > _this.low_stock_threshold) {
        _this.low_stock_container.hide();
        return;
      } else if (quantity === 1) {
        message = theme.translations.low_in_stock.one;
      } else if (quantity > 1) {
        message = theme.translations.low_in_stock.other.replace(/\d+/, quantity);
      }
      if (!_this.low_stock_hypothesis) {
        return _this.low_stock_container.text(message).show();
      }
      return _this.inLowStockHypothesis().then(function (in_hypothesis) {
        // The shopper may have picked another size while Shoplift answered
        if (
          in_hypothesis &&
          _this.variant_listbox.find("option[selected]").val() ===
            String(variant_id)
        ) {
          return _this.low_stock_container.text(message).show();
        }
      });
    };

    /**
     * Asks Shoplift's JavaScript API, once per page, whether this visitor is
     * in the section's low-stock test hypothesis. Waits up to about 5 s for
     * Shoplift to load, then gives up.
     * @returns {Promise<boolean>} true only when Shoplift says yes; false when
     *   it says no, never loads, throws or rejects. Never rejects.
     */
    CoreProduct.prototype.inLowStockHypothesis = function () {
      var _this, attempts, waitForShoplift;
      _this = this;
      if (_this.low_stock_in_hypothesis) {
        return _this.low_stock_in_hypothesis;
      }
      attempts = 0;
      _this.low_stock_in_hypothesis = new Promise(function (resolve) {
        // Shoplift's script can initialise after this deferred file: poll as its docs show
        waitForShoplift = function () {
          if (window.shoplift || attempts >= 50) {
            return resolve();
          }
          attempts++;
          return setTimeout(waitForShoplift, 100);
        };
        return waitForShoplift();
      })
        .then(function () {
          return window.shoplift.isHypothesisActive(_this.low_stock_hypothesis);
        })
        .then(function (is_active) {
          return is_active === true;
        })
        .catch(function () {
          // No Shoplift, or its assignment failed: stay on control.
          return false;
        });
      return _this.low_stock_in_hypothesis;
    };

    CoreProduct.prototype.getAvailableVariants = function () {
      var _this;
      _this = this;
      if (!_this.product_json) {
        return;
      }
      _this.available_variants = [];
      return _this.product_json.variants.forEach(function (variant) {
        if (variant.available) {
          return _this.available_variants.push(variant.options);
        }
      });
    };

    CoreProduct.prototype.disableEmptyOptions = function () {
      var _this, available_options, options;
      _this = this;
      available_options = [].concat.apply([], _this.available_variants);
      options = _this.options_container.find(
        ".radios--input, .disclosure--option-link",
      );
      if (!options.length) {
        return;
      }
      return options.each(function (option) {
        var current_value;
        current_value = _this.getOptionValue(el(option));
        if (!available_options.includes(current_value)) {
          return option.setAttribute("data-empty", true);
        }
      });
    };

    CoreProduct.prototype.updateDisabledOptions = function (
      variant_available,
      selected_option,
    ) {
      var _this,
        disclosure_toggles,
        option_containers,
        options,
        options_available_with_current_selection,
        options_in_same_container,
        selected_options,
        selected_value;
      if (selected_option == null) {
        selected_option = false;
      }
      _this = this;
      options = _this.options_container.find(
        ".radios--input, .disclosure--option-link",
      );
      if (!options.length) {
        return;
      }
      options.removeAttr("data-unavailable");
      selected_options = options.filter(':checked, [aria-current="true"]');
      disclosure_toggles = _this.options_container.find(
        ".disclosure--current-option",
      );
      if (selected_option === false) {
        selected_option = selected_options.eq(0);
        selected_value = _this.getOptionValue(selected_option);
      } else if (selected_option.hasClass("disclosure--input")) {
        selected_value = selected_option.val();
        selected_option = selected_options.filter(
          "[data-value='" + selected_value + "']",
        );
      } else {
        selected_value = selected_option.val();
      }
      options_in_same_container = [];
      option_containers = selected_option.closest(
        ".radios--container, .disclosure--form",
      );
      option_containers
        .find(".radios--input, .disclosure--option-link")
        .each(function (option) {
          var current_value;
          current_value = _this.getOptionValue(el(option));
          if (current_value !== selected_value) {
            return options_in_same_container.push(current_value);
          }
        });
      options_available_with_current_selection = options_in_same_container;
      _this.available_variants.forEach(function (available_variant) {
        if (available_variant.includes(selected_value)) {
          return available_variant.forEach(function (option) {
            return options_available_with_current_selection.push(option);
          });
        }
      });
      options.each(function (option) {
        var current_value;
        current_value = _this.getOptionValue(el(option));
        if (!options_available_with_current_selection.includes(current_value)) {
          return option.setAttribute("data-unavailable", true);
        }
      });
      if (!variant_available) {
        selected_options.each(function (option) {
          return option.setAttribute("data-unavailable", true);
        });
        if (disclosure_toggles.length) {
          return disclosure_toggles.attr("data-unavailable", true);
        }
      } else if (disclosure_toggles.length) {
        return disclosure_toggles.attr("data-unavailable", false);
      }
    };

    CoreProduct.prototype.getOptionValue = function (option_el) {
      var _this;
      _this = this;
      if (option_el.attr("data-value")) {
        return option_el.attr("data-value");
      } else {
        return option_el.val();
      }
    };

    CoreProduct.prototype.optionChangeListener = function () {
      var _this;
      _this = this;
      return _this.option_inputs.on("change", function () {
        var current_options,
          j,
          k,
          len,
          len1,
          option,
          options,
          options_match,
          ref,
          selected_options,
          variant,
          variant_found;
        selected_options = [];
        var active_form = el(this).closest(".product-form--root");
        if (active_form.length) {
          current_options = active_form
            .find(".product-form--options")
            .find('[data-item="disclosure"], [data-item="radio"]:checked');
        } else {
          current_options = _this.options_container.find(
            '[data-item="disclosure"], [data-item="radio"]:checked',
          );
        }
        current_options.each(function (current_option) {
          var index;
          index = current_option.closest(".product-form--option").dataset.index;
          return selected_options.push({
            index: index,
            value: current_option.value,
          });
        });
        ref = _this.product_json.variants;
        for (j = 0, len = ref.length; j < len; j++) {
          variant = ref[j];
          options = variant.options;
          options_match = true;
          for (k = 0, len1 = selected_options.length; k < len1; k++) {
            option = selected_options[k];
            if (options_match) {
              options_match = options[option.index] === option.value;
            }
          }
          variant_found = false;
          if (options_match) {
            variant_found = variant;
            break;
          }
        }
        return _this.updateVariant(variant_found, el(this));
      });
    };

    CoreProduct.prototype.updateVariant = function (variant, selected_option) {
      var _this;
      _this = this;
      if (variant.available) {
        _this.updateDisabledOptions(true, selected_option);
      } else {
        _this.updateDisabledOptions(false, selected_option);
      }
      _this.syncOtherFormRadios(selected_option);
      if (_this.is_product_page) {
        _this.updateHistoryState(variant.id);
        return selectCallback(variant);
      } else {
        return _this.variantSelected(variant);
      }
    };

    /**
     * Syncs radio selections across duplicate product forms (mobile/desktop).
     * When a variant option is changed in one form, this ensures the other
     * form's radios reflect the same selection to prevent mismatches on
     * viewport changes. Matches by option index and value since each form
     * has unique radio name attributes.
     * @param {Object} selected_option - The radio input element that was changed.
     */
    CoreProduct.prototype.syncOtherFormRadios = function (selected_option) {
      var _this, selected_value, selected_form, option_index;
      _this = this;
      if (!selected_option || !selected_option.length) {
        return;
      }
      selected_value = selected_option.val();
      selected_form = selected_option.closest(".product-form--root");
      option_index = selected_option.closest(".product-form--option").el[0]
        .dataset.index;
      if (!selected_value || !selected_form.length) {
        return;
      }
      _this.option_inputs.each(function (input) {
        var input_el = el(input);
        var input_form = input_el.closest(".product-form--root");
        var input_option_index = input_el.closest(".product-form--option").el[0]
          .dataset.index;
        if (
          input_form.el[0] !== selected_form.el[0] &&
          input_option_index === option_index &&
          input_el.val() === selected_value
        ) {
          input.checked = true;
        }
      });
    };

    CoreProduct.prototype.updateHistoryState = function (variant_id) {
      var _this, new_variant_url;
      _this = this;
      new_variant_url = "" + location.origin + location.pathname;
      if (variant_id) {
        new_variant_url += "?variant=" + variant_id;
      }
      return history.replaceState(
        {
          path: new_variant_url,
        },
        "",
        new_variant_url,
      );
    };

    CoreProduct.prototype.variantSelected = function (variant) {
      var _this, label_before, variant_media_id;
      _this = this;
      label_before = _this.button_text_container.text();
      _this.low_stock_container.hide();
      _this.variant_listbox.find("option[selected]").removeAttr("selected");
      _this.updatePrices(variant);
      if (variant && variant.available) {
        _this.variant_listbox
          .find("option[value='" + variant.id + "']")
          .attr("selected", "");
        _this.enableCartButtons(true, true);
        _this.enableStockForm(false);
        if (_this.show_low_in_stock) {
          _this.updateLowInStock(variant.id);
        }
        if (
          _this.pickup_enabled &&
          variant.inventory_management === "shopify"
        ) {
          _this.updatePickup(variant.id);
        }
      } else if (variant && !variant.available) {
        _this.variant_listbox
          .find("option[value='" + variant.id + "']")
          .attr("selected", "");
        _this.enableCartButtons(false, true);
        _this.enableStockForm(true);
      } else {
        _this.enableCartButtons(false, false);
        _this.enableStockForm(false);
      }
      // GC-195: a size tap that changes the button's label ("Add to Cart", "Out of stock") says the new one.
      if (_this.button_text_container.text() !== label_before) {
        theme.announce(_this.button_text_container.text());
      }
      if (
        _this.pickup_enabled &&
        (variant.inventory_management !== "shopify" || !variant.available)
      ) {
        _this.pickup_form_container.empty();
      }
      variant_media_id = 0;
      if (variant.featured_media) {
        variant_media_id = variant.featured_media.id;
      }
      return _this.updateVariantMedia(variant_media_id);
    };

    CoreProduct.prototype.enableCartButtons = function (enable, available) {
      var _this;
      _this = this;

      // GC-203: a form can word its button its own way (snippets/product--form.liquid,
      // add_to_cart_label and sold_out_label); the theme's words otherwise.
      var button = _this.add_to_cart_button.el[0];
      var own = function (attribute, fallback) {
        return (button && button.getAttribute(attribute)) || fallback;
      };

      if (enable) {
        _this.add_to_cart_button.removeAttr("disabled");
        _this.button_text_container.text(own("data-add-to-cart-text", theme.translations.add_to_cart));
        return _this.smart_payment_buttons.removeAttr("style");
      } else {
        _this.add_to_cart_button.attr("disabled", true);
        _this.smart_payment_buttons.hide();

        if (available) {
          return _this.button_text_container.text(
            own("data-out-of-stock-text", theme.translations.out_of_stock),
          );
        } else {
          return _this.button_text_container.text(
            theme.translations.unavailable,
          );
        }
      }
    };

    /**
     * Shows the sold-out sign-up box for a sold-out size and hides it
     * otherwise; a hidden box's button is disabled. GC-27: each "Notify me"
     * box also switches to the state of the size its form now shows. GC-202:
     * a form root that carries data-variant-sold-out (product--form.liquid,
     * the gold page) gets it set to match, so its CSS shows the box in the
     * sold-out size's button place.
     * @param {boolean} enable - True when the selected variant exists but is
     *   sold out.
     * @returns {Object|undefined} The unavailable container, if any.
     */
    CoreProduct.prototype.enableStockForm = function (enable) {
      var _this;
      _this = this;
      _this.updateBackInStock();
      if (_this.form_root.attr("data-variant-sold-out") !== null) {
        _this.form_root.attr("data-variant-sold-out", enable ? "true" : "false");
      }
      if (enable) {
        _this.unavailable_button.each(function (button) {
          // A "Notify me" box still sending stays busy until Klaviyo answers
          if (!button.closest('.back-in-stock--form[data-loading="true"]')) {
            button.removeAttribute("disabled");
          }
        });
        return _this.unavailable_container.show();
      } else {
        _this.unavailable_button.attr("disabled", true);
        return _this.unavailable_container.hide();
      }
    };

    /**
     * GC-27: puts every "Notify me" box in the state of the size its own form
     * has selected: the thank-you text for a size signed up on this page (a
     * second sign-up for it would be refused by Klaviyo), else the empty form.
     * @returns {void}
     */
    CoreProduct.prototype.updateBackInStock = function () {
      var _this;
      _this = this;
      _this.back_in_stock_forms.each(function (form) {
        var signed_up;
        signed_up =
          _this.back_in_stock_signed_up[_this.getBackInStockVariant(form)];
        form.querySelector(".back-in-stock--fields").style.display = signed_up
          ? "none"
          : "";
        form.querySelector(".back-in-stock--status").textContent = signed_up
          ? form.parentNode.dataset.successText
          : "";
      });
    };

    /**
     * GC-27: the variant selected in the product form a "Notify me" box
     * belongs to (the gold product page renders a mobile and a desktop form).
     * @param {HTMLFormElement} form - The box's form.
     * @returns {string|null} The variant id, or null when no variant matches.
     */
    CoreProduct.prototype.getBackInStockVariant = function (form) {
      var option;
      option = form
        .closest(".product-form--root")
        .querySelector(".product-form--variant-select option[selected]");
      return option ? option.value : null;
    };

    // GC-27: Klaviyo's client API, at the revision the body was checked against
    CoreProduct.klaviyo_back_in_stock = {
      revision: "2026-10-15",
      url: "https://a.klaviyo.com/client/back-in-stock-subscriptions",
      variant_prefix: "$shopify:::$default:::",
    };

    /**
     * GC-27: sends a "Notify me" box (snippets/back-in-stock.liquid) to
     * Klaviyo's client back-in-stock API for the size selected in the product
     * form that box belongs to, never the first form on the page. Klaviyo
     * answers 202 with no body; any other status, a network error or a timeout
     * shows the error text and leaves the box usable. The answer only changes
     * the box if its form still shows the size that was sent.
     * @returns {void}
     */
    CoreProduct.prototype.backInStockListener = function () {
      var _this, api;
      _this = this;
      api = CoreProduct.klaviyo_back_in_stock;
      _this.back_in_stock_forms.on("submit", function (event) {
        var button, form, request, status, variant_id;
        event.preventDefault();
        form = this;
        // requestSubmit() still fires while the button is disabled
        if (form.dataset.loading === "true") {
          return;
        }
        button = form.querySelector("button");
        status = form.querySelector(".back-in-stock--status");
        variant_id = _this.getBackInStockVariant(form);
        if (!variant_id) {
          status.textContent = form.parentNode.dataset.errorText;
          return;
        }
        form.dataset.loading = "true";
        form.setAttribute("aria-busy", "true");
        button.setAttribute("disabled", true);
        status.textContent = "";
        request = new XMLHttpRequest();
        request.onloadend = function () {
          var current, focused;
          current = _this.getBackInStockVariant(form) === variant_id;
          focused = document.activeElement;
          form.dataset.loading = "false";
          form.removeAttribute("aria-busy");
          // Like enableStockForm: a box hidden for an in-stock size stays off
          button.disabled = form.parentNode.style.display === "none";
          if (request.status === 202) {
            _this.back_in_stock_signed_up[variant_id] = true;
            _this.updateBackInStock();
            // The button just hid: keep keyboard users on the result
            if (
              current &&
              (focused === document.body || form.contains(focused))
            ) {
              status.focus();
            }
          } else if (current && !_this.back_in_stock_signed_up[variant_id]) {
            // Signed up already: Klaviyo refusing the other render's repeat
            status.textContent = form.parentNode.dataset.errorText;
          }
        };
        request.open(
          "POST",
          api.url +
            "?company_id=" +
            encodeURIComponent(theme.settings.klaviyo_public_key),
        );
        request.timeout = 15000;
        request.setRequestHeader("Content-Type", "application/vnd.api+json");
        request.setRequestHeader("revision", api.revision);
        request.send(
          JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email: form.elements.email.value },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: api.variant_prefix + variant_id,
                  },
                },
              },
            },
          }),
        );
      });
    };

    /**
     * Sets innerHTML on all elements in a CoreDomObject collection.
     * Unlike the built-in .html() which only updates the first element,
     * this helper updates every matched element — needed when duplicate
     * mobile/desktop forms exist in the DOM.
     * @param {Object} dom_obj - CoreDomObject collection to update.
     * @param {string} html_content - The HTML string to set.
     */
    CoreProduct.prototype.setHtmlAll = function (dom_obj, html_content) {
      if (dom_obj && dom_obj.length) {
        dom_obj.each(function (element) {
          element.innerHTML = html_content;
        });
      }
    };

    CoreProduct.prototype.updatePrices = function (variant) {
      var _this, compare_price, unit_price, variant_price;
      _this = this;
      if (!variant) {
        _this.price_container.hide();
        return;
      } else {
        _this.price_container.removeAttr("style");
      }
      variant_price = theme.utils.formatMoney(variant.price);
      _this.setHtmlAll(_this.price, variant_price);
      if (variant.compare_at_price > variant.price) {
        compare_price = theme.utils.formatMoney(variant.compare_at_price);
        _this.setHtmlAll(_this.compare_price, compare_price);
        _this.compare_price.attr("style", "display:inline-block;");
      } else {
        _this.compare_price.hide();
      }
      if (variant.unit_price_measurement) {
        unit_price = theme.utils.formatMoney(variant.unit_price);
        _this.setHtmlAll(_this.unit_price, unit_price);
        _this.setHtmlAll(
          _this.reference_unit,
          variant.unit_price_measurement.reference_unit,
        );
        if (variant.unit_price_measurement.reference_value === 1) {
          _this.reference_value.hide();
        } else {
          _this.setHtmlAll(
            _this.reference_value,
            variant.unit_price_measurement.reference_value,
          );
          _this.reference_value.show();
        }
        return _this.unit_price_container.attr("style", "display:flex;");
      } else {
        return _this.unit_price_container.hide();
      }
    };

    CoreProduct.prototype.addToCartListener = function () {
      var _this;
      _this = this;

      return _this.form.on("submit", function (event) {
        var button, quantity_available;
        // This form's own button: the PDP renders the form twice (phone and
        // desktop), so add_to_cart_button holds both. Multi-variant grid cards
        // render it as one class, product-form--add-to-cart-variant-overlay.
        button = this.querySelector(
          ".product-form--add-to-cart, .product-form--add-to-cart-variant-overlay",
        );
        // GC-278: a tap while this button's add is still on its way is ignored.
        if (button && button.dataset.gcBusy === "1") {
          event.preventDefault();
          return event.stopPropagation();
        }
        _this.button_container.attr("data-loading", "true");
        quantity_available = theme.classes.Product.getAvailableQuantity(this);

        // shortcut: with cart_type "page" the form still posts natively, in the
        // single-item format Shopify adds sold-out variants in. The store uses
        // the drawer; route that branch through addItem if it ever changes.
        if (theme.settings.cart_type === "drawer" && quantity_available) {
          if (button && theme.isCardAdd(button)) {
            theme.cardBusy(button);
          }
          theme.partials.Cart.addItem(this, function (added, problem, message) {
            if (button) {
              delete button.dataset.gcBusy;
            }
            _this.button_container.attr("data-loading", false);
            if (problem === "sold_out") {
              _this.smart_payment_buttons.hide();
            }
            if (added) {
              theme.openCartDrawer(button);
            }
            return theme.cartAddNotice(
              button,
              button && button.querySelector(".product-form--text"),
              problem,
              message,
            );
          });
          event.preventDefault();

          return event.stopPropagation();
        } else if (quantity_available === false) {
          _this.button_container.attr("data-loading", false);
          event.preventDefault();

          return event.stopPropagation();
        }
      });
    };

    CoreProduct.prototype.updateVariantMedia = function (variant_media_id) {
      var _this, variant_image, variant_thumb;
      _this = this;
      if (variant_media_id === 0) {
        return;
      }
      _this.main_media.attr("data-active", "false");
      _this.main_media.parent().hide();
      variant_image = _this.main_media.filter(
        "[data-id='" + variant_media_id + "']",
      );
      variant_image.attr("data-active", "true");
      variant_image.parent().show();
      _this.thumbs.attr("data-active", "false");
      variant_thumb = _this.thumbs.filter(
        "[data-id='" + variant_media_id + "']",
      );
      variant_thumb.attr("data-active", "true");
      if (_this.zoom_enabled) {
        return _this.imageZoom();
      }
    };

    CoreProduct.prototype.imageZoom = function () {
      var _this,
        active_zoom_image,
        left_position,
        magnified_height,
        magnified_width,
        top_position,
        wrapper_height,
        wrapper_width,
        x_ratio,
        y_ratio;
      _this = this;
      active_zoom_image = _this.zoom_images.filter(
        "[data-id='" + _this.getActiveImageId() + "']",
      );
      active_zoom_image.css("display", "none");
      _this.media_container.off(
        "mouseenter.Product.ImageZoom mouseleave.Product.ImageZoom",
      );

      if (
        _this.main_media.length < 1 ||
        theme.utils.mqs.current_window === "small"
      ) {
      } else if (active_zoom_image.length > 0) {
        _this.media_container.attr("data-media-type", "image");
        wrapper_width = _this.media_container.width();
        wrapper_height = _this.media_container.height();
        magnified_width = wrapper_width * _this.magnify;
        magnified_height = wrapper_height * _this.magnify;
        left_position = _this.media_container.offset().left;
        top_position = _this.media_container.offset().top;
        active_zoom_image.css("width", magnified_width + "px");
        active_zoom_image
          .find(".image--root")
          .css("width", magnified_width + "px");
        active_zoom_image.find("img").addClass("lazypreload");
        x_ratio = (magnified_width - wrapper_width) / wrapper_width;
        y_ratio = (magnified_height - wrapper_height) / wrapper_height;

        _this.media_container.on("mouseenter.Product.ImageZoom", function () {
          return active_zoom_image.css("display", "block");
        });

        _this.media_container.on("mouseleave.Product.ImageZoom", function () {
          return active_zoom_image.css("display", "none");
        });

        return _this.media_container.on("mousemove", function (event) {
          var relative_left, relative_top;
          relative_left = event.pageX - left_position;
          relative_top = event.pageY - top_position;
          active_zoom_image.css("left", relative_left * -x_ratio + "px");

          return active_zoom_image.css("top", relative_top * -y_ratio + "px");
        });
      } else {
        return _this.media_container.attr("data-media-type", "");
      }
    };

    CoreProduct.prototype.getActiveImageId = function () {
      var _this, active_image, active_image_id;
      _this = this;
      active_image = _this.main_media.filter('[data-active="true"]');
      return (active_image_id = active_image.attr("data-id"));
    };

    CoreProduct.prototype.initZoomListener = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.Product",
        theme.utils.debounce(100, function () {
          return _this.imageZoom();
        }),
      );
    };

    CoreProduct.prototype.thumbNavigation = function () {
      var _this;
      _this = this;

      return _this.thumbs.on("keypress click", function (event) {
        var clicked_id, clicked_media, current_media;

        if (theme.utils.a11yClick(event)) {
          current_media = _this.root.find(
            '.product-media--featured[data-active="true"] > *',
          );
          current_media.trigger("pause-media");
          clicked_id = this.dataset.id;
          clicked_media = _this.root.find(
            ".product-media--featured[data-id='" + clicked_id + "'] > *",
          );
          _this.updateVariantMedia(clicked_id);

          if (theme.utils.mqs.current_window !== "small") {
            clicked_media.trigger("play-media");
          }

          if (clicked_media.parent().attr("data-media-type") !== "image") {
            return clicked_media.focus();
          }
        }
      });
    };

    CoreProduct.prototype.updateRecentList = function () {
      var _this,
        current_product_arr,
        current_product_str,
        max_num_recents_stored,
        newly_visited_product,
        previous_product_arr,
        previous_product_str;
      _this = this;
      current_product_arr = [_this.handle];
      previous_product_str = localStorage.getItem(
        theme.local_storage.recent_products,
      );
      max_num_recents_stored = 4;

      if (previous_product_str) {
        previous_product_arr = JSON.parse(previous_product_str);

        if (previous_product_arr.indexOf(_this.handle) === -1) {
          newly_visited_product = true;
        }
      } else {
        current_product_str = JSON.stringify(current_product_arr);
        localStorage.setItem(
          theme.local_storage.recent_products,
          current_product_str,
        );
      }

      if (newly_visited_product) {
        if (previous_product_arr.length === max_num_recents_stored) {
          previous_product_arr = previous_product_arr.slice(1);
        }

        current_product_str = JSON.stringify(
          previous_product_arr.concat(current_product_arr),
        );

        return localStorage.setItem(
          theme.local_storage.recent_products,
          current_product_str,
        );
      }
    };

    CoreProduct.clearQuickAddForms = function (product_id) {
      var right_sidebar;

      if (product_id == null) {
        product_id = "";
      }

      right_sidebar = theme.partials.OffCanvas.right_sidebar;

      return right_sidebar
        .find(".product--form[data-product-id*='" + product_id + "']")
        .remove();
    };

    CoreProduct.initQuickAddForm = function (quick_add_button) {
      var existing_product_form, new_product_form, product_id, right_sidebar;
      right_sidebar = theme.partials.OffCanvas.right_sidebar;
      right_sidebar.find(".product--form").hide();
      product_id = quick_add_button.getAttribute("data-product-id");
      existing_product_form = right_sidebar.find(
        "[data-product-id='" + product_id + "']",
      );

      if (existing_product_form.length > 0) {
        existing_product_form.show();

        return theme.partials["Product-" + product_id].updateRecentList();
      } else {
        new_product_form = quick_add_button
          .closest(".product--root")
          .querySelector(".product--form");
        theme.partials["Product-" + product_id] = new theme.classes.Product(
          el(new_product_form),
        );

        return document
          .querySelector('[data-view="product-form"]')
          .appendChild(new_product_form);
      }
    };

    CoreProduct.getAvailableQuantity = function (form) {
      var cart_quantity,
        inventory_quantity,
        quantity_input,
        quantity_remaining,
        requested_quantity,
        variant,
        variant_id;
      variant = form.querySelector("option[selected]");
      if (variant.dataset.inventoryManagement !== "shopify") {
        return true;
      }
      variant_id = variant.value;
      // Not cart_items[variant_id]: the map is missing on a first visit until
      // /cart.js answers, and the throw let the form post natively.
      cart_quantity = theme.classes.Cart.storedQuantity(variant_id);
      quantity_input = form.querySelector(".product-form--quantity");
      inventory_quantity = parseInt(variant.dataset.inventoryQuantity);
      requested_quantity = parseInt(quantity_input.value);
      quantity_remaining = inventory_quantity - cart_quantity;
      if (quantity_remaining <= 0) {
        quantity_remaining = 0;
        quantity_input.value = 1;
      } else if (requested_quantity > quantity_remaining) {
        quantity_input.value = quantity_remaining;
      } else {
        return true;
      }
      theme.classes.Product.triggerQuantityFeedback(quantity_remaining);
      return false;
    };

    CoreProduct.triggerQuantityFeedback = function (quantity_remaining) {
      var message, trigger_feedback;
      if (quantity_remaining === 0) {
        window.location.hash = "#feedback-bar--product--no-items";
      } else if (quantity_remaining === 1) {
        window.location.hash = "#feedback-bar--product--one-item";
      } else if (quantity_remaining > 1) {
        window.location.hash = "#feedback-bar--product--n-items";
        message = document.querySelector('[data-message="product--n-items"]');
        message.textContent = message.textContent.replace(
          "[num_items]",
          quantity_remaining,
        );
      }
      trigger_feedback = new Event("theme:feedback-bar:trigger");
      return window.dispatchEvent(trigger_feedback);
    };

    CoreProduct.quickAddToCart = function (quick_add_button) {
      var product_form, product_root, quantity_available;
      // "Just sold out" (theme.cartAddNotice): a re-tap would only 422 again.
      if (quick_add_button.getAttribute("aria-disabled") === "true") {
        return;
      }
      // GC-278: a tap while this button's add is still on its way is ignored.
      if (quick_add_button.dataset.gcBusy === "1") {
        return;
      }
      quick_add_button.dataset.loading = true;
      product_root = quick_add_button.closest(".product--root");
      product_form = product_root.querySelector(".product-form--container");
      quantity_available =
        theme.classes.Product.getAvailableQuantity(product_form);

      if (quantity_available) {
        theme.cardBusy(quick_add_button);
        theme.partials.Cart.addItem(
          product_form,
          function (added, problem, message) {
            delete quick_add_button.dataset.gcBusy;
            quick_add_button.dataset.loading = false;
            if (added) {
              theme.openCartDrawer(quick_add_button);
            }
            return theme.cartAddNotice(
              quick_add_button,
              quick_add_button.querySelector(".add_cart_btn"),
              problem,
              message,
            );
          },
        );
      } else {
        quick_add_button.dataset.loading = false;
      }
      return theme.window.trigger("resize");
    };

    return CoreProduct;
  })();

  theme.classes.CoreRadios = (function () {
    function CoreRadios(root) {
      var _this;
      this.root = root;
      this.setSwatchAppearance = bind(this.setSwatchAppearance, this);
      this.updateLabelOnChange = bind(this.updateLabelOnChange, this);
      this.preventFormSubmitOnEnter = bind(this.preventFormSubmitOnEnter, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_value = _this.root.find(".radios--option-current");
      _this.inputs = _this.root.find('[data-item="radio"]');
      _this.is_swatches = _this.root.data("is-swatches");
      _this.load();
    }

    CoreRadios.prototype.load = function () {
      var _this;
      _this = this;
      _this.preventFormSubmitOnEnter();
      _this.updateLabelOnChange();
      if (_this.is_swatches) {
        return _this.setSwatchAppearance();
      }
    };

    CoreRadios.prototype.preventFormSubmitOnEnter = function () {
      var _this;
      _this = this;
      return _this.inputs.on("keydown", function (event) {
        if (event.key === "Enter") {
          return event.preventDefault();
        }
      });
    };

    CoreRadios.prototype.updateLabelOnChange = function () {
      var _this;
      _this = this;
      return _this.inputs.on("change", function () {
        return _this.current_value.text(this.value);
      });
    };

    CoreRadios.prototype.setSwatchAppearance = function () {
      var _this;
      _this = this;
      return _this.inputs.each(function (input) {
        var input_el, swatch, swatch_color;
        input_el = el(input);
        swatch = input_el.siblings(".radios--swatch-button");
        swatch_color = input_el.val().toLowerCase().replace(/\s+/g, "");
        if (theme.swatches[swatch_color] === void 0) {
          return swatch.css("background-color", swatch_color);
        } else if (
          theme.swatches[swatch_color].indexOf("cdn.shopify.com") > -1
        ) {
          return swatch.css(
            "background-image",
            "url(" + theme.swatches[swatch_color] + ")",
          );
        } else {
          return swatch.css("background-color", theme.swatches[swatch_color]);
        }
      });
    };

    return CoreRadios;
  })();

  theme.classes.CoreRecentProducts = (function () {
    function CoreRecentProducts(root) {
      var _this;
      this.root = root;
      this.hoverImagesLoaded = bind(this.hoverImagesLoaded, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.resizeListeners = bind(this.resizeListeners, this);
      this.formatProducts = bind(this.formatProducts, this);
      this.checkIfAllProductsLoaded = bind(this.checkIfAllProductsLoaded, this);
      this.renderProductItem = bind(this.renderProductItem, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_width = window.innerWidth;
      _this.main_grid = _this.root.find(".recent-products--grid");
      _this.num_errors = 0;
      _this.num_loaded = 0;
      _this.spinner = _this.root.find(".recent-products--spinner");
      _this.storage = JSON.parse(
        localStorage.getItem(theme.local_storage.recent_products),
      );
      if (_this.storage) {
        _this.load();
      } else {
        _this.root.hide();
      }
    }

    CoreRecentProducts.prototype.load = function () {
      var _this;
      _this = this;
      return _this.storage.forEach(function (handle) {
        return _this.renderProductItem(handle);
      });
    };

    CoreRecentProducts.prototype.renderProductItem = function (handle) {
      var _this, request;
      _this = this;
      request = new XMLHttpRequest();
      request.onload = function () {
        var product_html;
        if (request.status >= 200 && request.status < 300) {
          // product_html = theme.utils.parseHtml(request.response, '.product--root');
          product_html = theme.utils.parseHtml(request.response, ".bs-card");
          // GC-187: on /cart (the only page that marks this section a suggestion spot), a product the
          // shared rule leaves out is handled like a card that failed to load: skipped, and the section
          // hides when none are left.
          if (
            product_html &&
            _this.root.attr("data-suggestion-spot") &&
            product_html.attr("data-suggestion-allowed") !== "yes"
          ) {
            return request.onerror();
          }
          _this.main_grid.prepend(product_html);
          return _this.checkIfAllProductsLoaded();
        }
      };
      request.onerror = function () {
        _this.num_errors++;
        if (_this.num_errors === _this.storage.length) {
          return _this.root.hide();
        } else {
          return _this.checkIfAllProductsLoaded();
        }
      };
      // request.open("GET", theme.urls.root + "/products/" + handle + "?view=ajax-item");
      // GC-187: on /cart (the section is a suggestion spot there), the -cart view also runs the shared
      // suggestion rule for the card.
      request.open(
        "GET",
        theme.urls.root +
          "/products/" +
          handle +
          "?view=ajax-item-gold" +
          (_this.root.attr("data-suggestion-spot") ? "-cart" : ""),
      );
      return request.send();
    };

    CoreRecentProducts.prototype.checkIfAllProductsLoaded = function () {
      var _this;
      _this = this;
      _this.num_loaded++;
      if (_this.num_loaded === _this.storage.length) {
        _this.main_grid.removeAttr("style");
        _this.spinner.hide();
        return _this.formatProducts();
      }
    };

    CoreRecentProducts.prototype.formatProducts = function () {
      var _this;
      _this = this;
      _this.resizeListeners();
      _this.matchImageHeights();
      theme.utils.loadJsClasses(_this.main_grid);
      if (theme.settings.hover_image_enabled) {
        _this.hoverImagesLoaded();
      }
      if (theme.settings.quick_add) {
        theme.partials.OffCanvas.unload();
        return theme.partials.OffCanvas.load();
      }
    };

    CoreRecentProducts.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.RecentProducts",
        theme.utils.debounce(100, function () {
          if (_this.current_width !== window.innerWidth) {
            _this.matchImageHeights();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    CoreRecentProducts.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(
        _this.main_grid,
        _this.root.find(".product--root"),
        ".product--image-wrapper:not(.stack_wrapper) ",
      );
    };

    CoreRecentProducts.prototype.hoverImagesLoaded = function () {
      var _this;
      _this = this;
      return _this.main_grid
        .find(".product--hover-image")
        .each(function (hover_image) {
          hover_image = el(hover_image);
          return theme.utils.imagesLoaded(hover_image, function () {
            var product;
            product = hover_image.closest('[data-hover-image="true"]');
            return product.attr("data-hover-image", "loaded");
          });
        });
    };

    return CoreRecentProducts;
  })();

  theme.classes.CoreSearch = (function () {
    function CoreSearch(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.toggleView = bind(this.toggleView, this);
      this.getResults = bind(this.getResults, this);
      this.listenForKeyEntered = bind(this.listenForKeyEntered, this);
      this.searchLinks = bind(this.searchLinks, this);
      this.onOpen = bind(this.onOpen, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.articles = _this.root.find(".search--articles");
      _this.current_width = window.innerWidth;
      _this.form = _this.root.find("form");
      _this.icon = _this.root.find(".search--icon");
      _this.loading = _this.root.find(".search--loading");
      _this.products = _this.root.find(".search--products");
      _this.results = _this.root.find(".search--results");
      _this.text_box = _this.root.find(".search--textbox");
      _this.toggle_link = _this.root.find(".search--toggle");
      _this.show_articles = _this.root.data("show-articles");
      _this.show_pages = _this.root.data("show-pages");
      _this.view = _this.root.data("view");
      _this.article_page_combination = "";
      _this.num_loaded_views = 0;
      _this.num_pending_views = 0;
      _this.offCanvas = theme.partials.OffCanvas;
      _this.typing_timer = null;
      if (_this.show_articles && _this.show_pages) {
        _this.article_page_combination = "article,page";
      } else if (_this.show_articles) {
        _this.article_page_combination = "article";
      } else if (_this.show_pages) {
        _this.article_page_combination = "page";
      }
      _this.load();
    }

    CoreSearch.prototype.load = function () {
      var _this;
      _this = this;
      if (_this.view === "modal") {
        _this.searchLinks();
        _this.listenForKeyEntered();
      }
      _this.resizeListeners();
      return _this.matchImageHeights();
    };

    CoreSearch.prototype.onOpen = function () {
      var _this, temp_val;
      _this = this;
      window.scrollTo(0, 0);
      _this.text_box.focus();
      temp_val = _this.text_box.val();
      _this.text_box.val("");
      _this.text_box.val(temp_val);
      return _this.text_box.trigger("keyup");
    };

    CoreSearch.prototype.searchLinks = function () {
      var _this, left_search_links, main_search_links, right_search_links;
      _this = this;
      main_search_links = el(
        ".off-canvas--main-content a[href='" + theme.urls.search + "']",
      );
      main_search_links.off("click");
      main_search_links.on("click", function (event) {
        el('[data-trigger="search-modal"]').trigger("click");
        _this.onOpen();
        event.preventDefault();
        return event.stopPropagation();
      });
      right_search_links = el(
        ".off-canvas--right-sidebar a[href='" + theme.urls.search + "']",
      );
      right_search_links.off("click");
      right_search_links.on("click", function (event) {
        _this.offCanvas.closeRight();
        setTimeout(function () {
          el('[data-trigger="search-modal"]').trigger("click");
          return _this.onOpen();
        }, 450);
        event.preventDefault();
        return event.stopPropagation();
      });
      left_search_links = el(
        ".off-canvas--left-sidebar a[href='" + theme.urls.search + "']",
      );
      left_search_links.off("click");
      return left_search_links.on("click", function (event) {
        _this.offCanvas.closeLeft();
        setTimeout(function () {
          el('[data-trigger="search-modal"]').trigger("click");
          return _this.onOpen();
        }, 450);
        event.preventDefault();
        return event.stopPropagation();
      });
    };

    CoreSearch.prototype.listenForKeyEntered = function () {
      var _this;
      _this = this;
      return _this.text_box
        .attr("autocomplete", "off")
        .on("keyup paste", function (event) {
          var term;
          clearTimeout(_this.typing_timer);
          term = this.value;
          if (term.length < 2 && event.type !== "paste") {
            _this.toggleView(false, true);
            return false;
          }
          _this.toggleView(true, true);
          return (_this.typing_timer = setTimeout(function () {
            var url;
            clearTimeout(_this.typing_timer);
            if (_this.show_articles || _this.show_pages) {
              _this.num_pending_views = 2;
              url =
                theme.urls.search +
                "?view=ajax-article-page&type=" +
                _this.article_page_combination +
                "&q=" +
                term +
                "*";
              _this.getResults(url, "article");
            } else {
              _this.num_pending_views = 1;
            }
            url =
              theme.urls.search +
              "?view=ajax-product&type=product&q=" +
              term +
              "*";
            return _this.getResults(url, "product");
          }, 750));
        });
    };

    CoreSearch.prototype.getResults = function (url, type) {
      var _this, request;
      _this = this;
      _this.toggleView(true, false);
      request = new XMLHttpRequest();
      request.onload = function () {
        var results_html;
        if (request.status >= 200 && request.status < 300) {
          _this.num_loaded_views += 1;
          results_html = theme.utils.parseHtml(request.response);
          if (type === "product") {
            _this.products.empty().append(results_html);
            _this.matchImageHeights();
            theme.utils.loadJsClasses(el(".search--products-container"));
          } else if (type === "article") {
            _this.articles.empty().append(results_html);
          }
          if (_this.num_loaded_views === _this.num_pending_views) {
            _this.toggleView(false, true);
            return (_this.num_loaded_views = 0);
          }
        }
      };
      request.onerror = function () {
        return console.log(
          request.statusText + ": search.json request failed!",
        );
      };
      request.open("GET", url);
      return request.send();
    };

    CoreSearch.prototype.toggleView = function (toggle_load, toggle_display) {
      var _this;
      _this = this;
      if (toggle_load) {
        _this.loading.show();
        _this.icon.hide();
      } else {
        _this.loading.hide();
        _this.icon.show();
      }
      if (toggle_display) {
        _this.products.css("opacity", "1");
        return _this.articles.css("opacity", "1");
      } else {
        _this.products.css("opacity", "0");
        return _this.articles.css("opacity", "0");
      }
    };

    CoreSearch.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      return theme.utils.matchImageHeights(
        _this.products,
        _this.products.find(".product--root"),
        ".product--image-wrapper:not(.stack_wrapper) ",
      );
    };

    CoreSearch.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.Search",
        theme.utils.debounce(100, function () {
          if (_this.current_width !== window.innerWidth) {
            _this.matchImageHeights();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    return CoreSearch;
  })();

  theme.classes.CoreSections = (function () {
    function CoreSections() {
      this.deselectBlock = bind(this.deselectBlock, this);
      this.selectBlock = bind(this.selectBlock, this);
      this.deselectSection = bind(this.deselectSection, this);
      this.selectSection = bind(this.selectSection, this);
      this.unload = bind(this.unload, this);
      this.load = bind(this.load, this);
      this.getActiveBlock = bind(this.getActiveBlock, this);
      this.getActiveSection = bind(this.getActiveSection, this);
      this.listeners = bind(this.listeners, this);
      var _this;
      _this = this;
      _this.listeners();
    }

    CoreSections.prototype.listeners = function () {
      var _this;
      _this = this;
      _this.load();
      _this.unload();
      _this.selectSection();
      _this.deselectSection();
      _this.selectBlock();
      return _this.deselectBlock();
    };

    CoreSections.prototype.getActiveSection = function (event) {
      var _this, active_section;
      _this = this;
      active_section = el(event.target).find("[data-section-id]");
      return active_section;
    };

    CoreSections.prototype.getActiveBlock = function (event) {
      var _this, active_block;
      _this = this;
      active_block = el(event.target);
      return active_block;
    };

    CoreSections.prototype.load = function () {
      var _this;
      _this = this;
      return document.addEventListener(
        "shopify:section:load",
        function (event) {
          var active_section;
          theme.utils.loadJsClasses();
          active_section = _this.getActiveSection(event);
          active_section.trigger("theme:section:load");
          return active_section
            .find("[data-js-class]")
            .each(function (js_class) {
              return el(js_class).trigger("theme:section:load");
            });
        },
      );
    };

    CoreSections.prototype.unload = function () {
      var _this;
      _this = this;
      return document.addEventListener(
        "shopify:section:unload",
        function (event) {
          var active_section;
          active_section = _this.getActiveSection(event);
          active_section.trigger("theme:section:unload");
          return active_section
            .find('[data-js-loaded="true"]')
            .each(function (loaded_class) {
              return el(loaded_class).trigger("theme:section:unload");
            });
        },
      );
    };

    CoreSections.prototype.selectSection = function () {
      var _this;
      _this = this;
      return document.addEventListener(
        "shopify:section:select",
        function (event) {
          var active_section;
          active_section = _this.getActiveSection(event);
          return active_section.trigger("theme:section:select");
        },
      );
    };

    CoreSections.prototype.deselectSection = function () {
      var _this;
      _this = this;
      return document.addEventListener(
        "shopify:section:deselect",
        function (event) {
          var active_section;
          active_section = _this.getActiveSection(event);
          return active_section.trigger("theme:section:deselect");
        },
      );
    };

    CoreSections.prototype.selectBlock = function () {
      var _this;
      _this = this;
      return document.addEventListener(
        "shopify:block:select",
        function (event) {
          var active_block;
          active_block = _this.getActiveBlock(event);
          return active_block.trigger("theme:block:select");
        },
      );
    };

    CoreSections.prototype.deselectBlock = function () {
      var _this;
      _this = this;
      return document.addEventListener(
        "shopify:block:deselect",
        function (event) {
          var active_block;
          active_block = _this.getActiveBlock(event);
          return active_block.trigger("theme:block:deselect");
        },
      );
    };

    return CoreSections;
  })();

  theme.classes.CoreServiceList = (function () {
    function CoreServiceList(root) {
      var _this;
      this.root = root;
      this.balanceColumns = bind(this.balanceColumns, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.block_list = _this.root.find(".service-list--blocks");
      _this.blocks = _this.root.find("li");
      _this.blocks_container = _this.root.find(".service-list--container");
      _this.headers = _this.root.find(".service-list--block-header");
      _this.single_column = _this.root.find(".service-list--single-column");
      _this.left_column = _this.root.find(".service-list--left-column");
      _this.right_column = _this.root.find(".service-list--right-column");
      _this.load();
    }

    CoreServiceList.prototype.load = function () {
      var _this;
      _this = this;
      return _this.balanceColumns();
    };

    CoreServiceList.prototype.balanceColumns = function () {
      var _this,
        assignLoopList,
        isTypeHeader,
        loop_list,
        offset,
        thresholdBreached,
        with_multiple_headers;
      _this = this;
      offset =
        _this.root.data("service-list--show-descriptions") === true ? 75 : 0;
      with_multiple_headers = _this.block_list.length > 1 ? true : false;
      isTypeHeader = function (item) {
        return item.hasClass("service-list--block-header");
      };
      thresholdBreached = function () {
        var left_column_height, right_column_height, single_column_height;
        single_column_height = _this.single_column.outerHeight();
        left_column_height = _this.left_column.outerHeight();
        right_column_height = _this.right_column.outerHeight();
        return (
          left_column_height >=
          parseFloat(right_column_height + single_column_height - offset)
        );
      };
      assignLoopList = function () {
        var blocks;
        if (with_multiple_headers) {
          _this.root.attr("data-has-headers", true);
          return _this.block_list;
        } else {
          blocks = theme.utils.parseHtml(
            '<ul class="service-list--blocks"></ul>',
          );
          _this.left_column.append(blocks);
          return _this.blocks;
        }
      };
      loop_list = assignLoopList();
      return loop_list.each(function (list, index) {
        var list_el;
        list_el = el(list);
        if (thresholdBreached()) {
          _this.right_column.append(
            _this.single_column.find(".service-list--blocks"),
          );
          return;
        } else {
          if (with_multiple_headers) {
            _this.left_column.append(list_el);
          } else {
            if (isTypeHeader(list_el)) {
              _this.blocks_container.prepend(
                list_el.find(".service-list--block-header--text"),
              );
              list_el.remove();
            } else {
              _this.left_column.find(".service-list--blocks").append(list_el);
            }
          }
        }
        if (
          index === loop_list.length - 1 &&
          _this.right_column.isEmpty() &&
          _this.headers.length > 1
        ) {
          return _this.right_column.append(
            _this.left_column.find(".service-list--blocks").last(),
          );
        }
      });
    };

    return CoreServiceList;
  })();

  theme.classes.CoreStickyColumn = (function () {
    function CoreStickyColumn(container1, column_a, column_b) {
      this.container = container1;
      this.column_a = column_a;
      this.column_b = column_b;
      this.Listeners = bind(this.Listeners, this);
      this.setColumnPosition = bind(this.setColumnPosition, this);
      this.getAlignment = bind(this.getAlignment, this);
      this.getState = bind(this.getState, this);
      this.resetLargerColumn = bind(this.resetLargerColumn, this);
      this.getSmallerColumn = bind(this.getSmallerColumn, this);
      this.heightsHaveChanged = bind(this.heightsHaveChanged, this);
      this.setHeights = bind(this.setHeights, this);
      this.loadColumns = bind(this.loadColumns, this);
      if (theme.utils.isTouchDevice()) {
        return false;
      }
      _this.current_state = "auto";
      _this.column_a_height = 0;
      _this.column_b_height = 0;
      _this.loadColumns();
    }

    CoreStickyColumn.prototype.loadColumns = function () {
      var _this;
      _this = this;
      return theme.utils.imagesLoaded(_this.container, function () {
        _this.Listeners();
        return _this.setColumnPosition();
      });
    };

    CoreStickyColumn.prototype.setHeights = function () {
      _this.column_a_height = _this.column_a.outerHeight();
      return (_this.column_b_height = _this.column_b.outerHeight());
    };

    CoreStickyColumn.prototype.heightsHaveChanged = function () {
      if (_this.column_a.outerHeight() !== _this.column_a_height) {
        _this.setHeights();
        return true;
      }
      if (_this.column_b.outerHeight() !== _this.column_b_height) {
        _this.setHeights();
        return true;
      }
      return false;
    };

    CoreStickyColumn.prototype.getSmallerColumn = function () {
      if (_this.column_a_height < _this.column_b_height) {
        return _this.column_a;
      } else {
        return _this.column_b;
      }
    };

    CoreStickyColumn.prototype.resetLargerColumn = function () {
      if (_this.column_a_height > _this.column_b_height) {
        _this.column_a.css("position", "relative");
        _this.column_a.css("top", "auto");
        return _this.column_a.css("bottom", "auto");
      } else {
        _this.column_b.css("position", "relative");
        _this.column_b.css("top", "auto");
        return _this.column_b.css("bottom", "auto");
      }
    };

    CoreStickyColumn.prototype.getState = function (
      scroll_pos,
      window_height,
      column,
    ) {
      var column_height,
        container_top,
        height_for_bottom,
        overflowing_column,
        state;
      state = "auto";
      if (theme.utils.mqs.current_window === "small") {
        return "auto";
      }
      column_height = column.outerHeight();
      container_top = _this.container.offset().top;
      if (window_height > column_height) {
        overflowing_column = true;
      }
      if (scroll_pos < container_top) {
        state = "auto";
      }
      if (overflowing_column) {
        height_for_bottom = column_height;
      } else {
        height_for_bottom = window_height;
      }
      if (
        scroll_pos + height_for_bottom >
        container_top + _this.container.outerHeight()
      ) {
        state = "absolute-bottom";
      } else if (scroll_pos > container_top && overflowing_column) {
        state = "fixed-top";
      } else if (
        window_height < column_height &&
        scroll_pos + window_height > container_top + column.outerHeight()
      ) {
        state = "fixed-bottom";
      }
      return state;
    };

    CoreStickyColumn.prototype.getAlignment = function (column) {
      if (column.hasClass("column-a")) {
        return "left";
      } else if (column.hasClass("column-b")) {
        return "right";
      }
    };

    CoreStickyColumn.prototype.setColumnPosition = function () {
      var _this, align, column, state;
      _this = this;
      _this.setHeights();
      column = _this.getSmallerColumn();
      state = _this.getState(window.pageYOffset, window.innerHeight, column);
      align = _this.getAlignment(column);
      if (state === "auto" && _this.current_state !== "auto") {
        _this.current_state = "auto";
        column.css("position", "relative");
        column.css("top", "auto");
        column.css("bottom", "auto");
      } else if (
        state === "fixed-bottom" &&
        _this.current_state !== "fixed-bottom"
      ) {
        _this.current_state = "fixed-bottom";
        column.css("position", "fixed");
        column.css("top", "auto");
        column.css("bottom", 0);
      } else if (state === "fixed-top" && _this.current_state !== "fixed-top") {
        _this.current_state = "fixed-top";
        column.css("position", "fixed");
        column.css("top", 0);
        column.css("bottom", "auto");
      } else if (
        state === "absolute-bottom" &&
        _this.current_state !== "absolute-bottom"
      ) {
        _this.current_state = "absolute-bottom";
        column.css("position", "absolute");
        column.css("top", "auto");
        column.css("bottom", 0);
      }
      if (align === "right") {
        return column.css("right", 0);
      }
    };

    CoreStickyColumn.prototype.Listeners = function () {
      var _this;
      _this = this;
      window.addEventListener("scroll", function () {
        return _this.setColumnPosition();
      });
      setInterval(function () {
        if (_this.heightsHaveChanged()) {
          _this.resetLargerColumn();
          return _this.setColumnPosition();
        }
      }, 250);
      return window.addEventListener("resize", function () {
        _this.resetLargerColumn();
        return _this.setColumnPosition();
      });
    };

    return CoreStickyColumn;
  })();

  theme.classes.CoreTabOrder = (function () {
    function CoreTabOrder(mobile_order, desktop_order) {
      var _this;
      this.mobile_order = mobile_order;
      this.desktop_order = desktop_order;
      this.resizeListener = bind(this.resizeListener, this);
      this.disableFocus = bind(this.disableFocus, this);
      this.moveFocus = bind(this.moveFocus, this);
      this.focusOutCallback = bind(this.focusOutCallback, this);
      this.focusListener = bind(this.focusListener, this);
      this.updateOrderList = bind(this.updateOrderList, this);
      this.getElementList = bind(this.getElementList, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.mobile_order_elements = _this.getElementList(_this.mobile_order);
      _this.desktop_order_elements = _this.getElementList(_this.desktop_order);
      _this.load();
    }

    CoreTabOrder.prototype.load = function () {
      var _this;
      _this = this;
      _this.updateOrderList();
      _this.focusListener();
      return _this.resizeListener();
    };

    CoreTabOrder.prototype.getElementList = function (order_list) {
      var _this, order_list_elements;
      _this = this;
      if (order_list) {
        order_list_elements = [];
        order_list.forEach(function (container_class) {
          var container_elements;
          container_elements = document.querySelectorAll(container_class);
          if (container_elements.length) {
            return container_elements.forEach(function (el) {
              return order_list_elements.push(el);
            });
          }
        });
        return order_list_elements;
      } else {
        return false;
      }
    };

    CoreTabOrder.prototype.updateOrderList = function () {
      var _this;
      _this = this;
      if (theme.utils.mqs.current_window === "small") {
        _this.current_order_elements = _this.mobile_order_elements;
        _this.previous_order_elements = _this.desktop_order_elements;
        return (_this.mq = "small");
      } else {
        _this.current_order_elements = _this.desktop_order_elements;
        _this.previous_order_elements = _this.mobile_order_elements;
        return (_this.mq = "medium-large");
      }
    };

    CoreTabOrder.prototype.focusListener = function () {
      var _this;
      _this = this;
      if (!_this.current_order_elements) {
        return;
      }
      return _this.current_order_elements.forEach(function (element, index) {
        return element.addEventListener("focusout", function (event) {
          return _this.focusOutCallback(this, index, event);
        });
      });
    };

    CoreTabOrder.prototype.focusOutCallback = function (element, index, event) {
      var _this, lost_focus;
      _this = this;
      if (!theme.utils.tabbing) {
        return;
      }
      lost_focus =
        !element.contains(event.relatedTarget) &&
        theme.partials.OffCanvas.state === "closed";
      if (lost_focus && theme.utils.tab_forwards) {
        return _this.moveFocus(index + 1, "forwards");
      } else if (lost_focus) {
        return _this.moveFocus(index - 1, "backwards");
      }
    };

    CoreTabOrder.prototype.moveFocus = function (index, direction) {
      var _this, focusable_elements, move_to;
      _this = this;
      move_to = _this.current_order_elements[index];
      focusable_elements = theme.utils.getFocusableEl(move_to, _this.mq);
      if (
        index < _this.current_order_elements.length &&
        direction === "forwards"
      ) {
        if (focusable_elements) {
          focusable_elements[0].focus();
        } else if (index + 1 < _this.current_order_elements.length) {
          _this.moveFocus(index + 1, "forwards");
        }
      }
      if (index >= 0 && direction === "backwards") {
        if (focusable_elements) {
          return focusable_elements[focusable_elements.length - 1].focus();
        } else if (index - 1 >= 0) {
          return _this.moveFocus(index - 1, "backwards");
        }
      }
    };

    CoreTabOrder.prototype.disableFocus = function () {
      var _this;
      _this = this;
      if (!_this.previous_order_elements) {
        return;
      }
      return _this.previous_order_elements.forEach(function (element) {
        return element.removeEventListener("focusout", function (event) {
          return _this.focusOutCallback(this, index, event);
        });
      });
    };

    CoreTabOrder.prototype.resizeListener = function () {
      var _this;
      _this = this;
      return window.addEventListener("theme:utils:mqs:updated", function () {
        _this.updateOrderList();
        _this.focusListener();
        return _this.disableFocus();
      });
    };

    return CoreTabOrder;
  })();

  theme.classes.Transition = (function () {
    function Transition(root) {
      var _this;
      this.root = root;
      this.transitionListeners = bind(this.transitionListeners, this);
      this.updateState = bind(this.updateState, this);
      this.setState = bind(this.setState, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.state = "at_start";
      _this.load();
    }

    Transition.prototype.load = function () {
      var _this;
      _this = this;
      _this.setState(_this.state);
      return _this.transitionListeners();
    };

    Transition.prototype.setState = function (state) {
      var _this;
      _this = this;
      _this.root.setAttribute("data-transition", state);
      return (_this.state = state);
    };

    Transition.prototype.updateState = function () {
      var _this;
      _this = this;
      return (_this.state = _this.root.getAttribute("data-transition"));
    };

    Transition.prototype.transitionListeners = function () {
      var _this;
      _this = this;
      return _this.root.on("transitionend", function () {
        _this.updateState();
        if (_this.state === "forwards") {
          _this.setState("at_end");
          return _this.root.trigger("transition:at_end");
        } else if (_this.state === "backwards") {
          _this.setState("at_start");
          return _this.root.trigger("transition:at_start");
        }
      });
    };

    return Transition;
  })();

  theme.classes.CoreUtils = (function () {
    function CoreUtils() {
      this.isTouchDevice = bind(this.isTouchDevice, this);
      this.loadJsClasses = bind(this.loadJsClasses, this);
      this.getHiddenElHeight = bind(this.getHiddenElHeight, this);
      this.detectTabDirection = bind(this.detectTabDirection, this);
      this.detectTabbing = bind(this.detectTabbing, this);
      var _this;
      _this = this;
      _this.carousel_script_status = null;
      _this.disable_swipe_listener = false;
      _this.google_maps_script_status = null;
      _this.mqs = new theme.classes.CoreMediaQueries();
      _this.detectTabbing();
      _this.detectTabDirection();
    }

    CoreUtils.prototype.swipe = function () {
      var _this;
      _this = this;
      document.querySelectorAll("input, textarea").forEach(function (input) {
        input.addEventListener("focus", function () {
          return (_this.disable_swipe_listener = true);
        });
        return input.addEventListener("blur", function () {
          return (_this.disable_swipe_listener = false);
        });
      });
      SwipeListener(document, {
        preventScroll: function (event) {
          var x_swipe_distance, y_swipe_distance;
          if (_this.disable_swipe_listener) {
            return;
          }
          x_swipe_distance = Math.abs(event.detail.x[0] - event.detail.x[1]);
          y_swipe_distance =
            Math.abs(event.detail.y[0] - event.detail.y[1]) * 2;
          if (x_swipe_distance > y_swipe_distance) {
            return true;
          } else {
            return false;
          }
        },
      });
      return document.addEventListener("swipe", function (event) {
        var directions, swipe_event;
        directions = event.detail.directions;
        if (directions.left) {
          swipe_event = new Event("theme:swipe:left");
        }
        if (directions.right) {
          swipe_event = new Event("theme:swipe:right");
        }
        if (directions.top) {
          swipe_event = new Event("theme:swipe:up");
        }
        if (directions.bottom) {
          swipe_event = new Event("theme:swipe:down");
        }
        return document.dispatchEvent(swipe_event);
      });
    };

    CoreUtils.prototype.a11yClick = function (event) {
      var code;
      if (event.type === "click") {
        return true;
      } else if (event.type === "keypress") {
        code = event.charCode || event.keyCode;
        if (code === 32) {
          event.preventDefault();
        }
        if (code === 32 || code === 13) {
          return true;
        }
      }
      return false;
    };

    CoreUtils.prototype.detectTabbing = function () {
      var _this;
      _this = this;
      theme.window.on("click load", function () {
        _this.tabbing = false;
        return theme.body.attr("data-tabbing", _this.tabbing);
      });
      return window.addEventListener("keydown", function (event) {
        if (
          event.which === 9 ||
          event.which === 37 ||
          event.which === 38 ||
          event.which === 39 ||
          event.which === 40 ||
          event.which === 27
        ) {
          _this.tabbing = true;
          return theme.body.attr("data-tabbing", _this.tabbing);
        }
      });
    };

    CoreUtils.prototype.detectTabDirection = function () {
      var _this;
      _this = this;
      _this.tab_forwards = null;
      return document.addEventListener("keydown", function (event) {
        _this.tab_forwards = true;
        if (event.which === 9 && event.shiftKey) {
          _this.tab_forwards = false;
        }
        return true;
      });
    };

    CoreUtils.prototype.getFocusableEl = function (container, mq) {
      var focusable_elements, focusable_selectors, ignore_mq;
      if (!container) {
        return;
      }
      ignore_mq = "";
      if (mq === "small") {
        ignore_mq = ":not([data-mq='medium-large'])";
      } else if (mq === "medium-large") {
        ignore_mq = ":not([data-mq='small'])";
      }
      focusable_selectors =
        "button:not([disabled]):not([aria-hidden='true']), [href], input:not([type='hidden']):not([disabled]):not([aria-hidden='true']), select:not([disabled]):not([data-mq='none']):not([aria-hidden='true']), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])" +
        ignore_mq;
      if (container.isDOMobject && container.length) {
        return (focusable_elements = container.find(focusable_selectors));
      } else if (container.isDOMobject !== true) {
        return (focusable_elements =
          container.querySelectorAll(focusable_selectors));
      }
    };

    CoreUtils.prototype.stylesheetLoaded = function () {
      var stylesheetPromise;
      return (stylesheetPromise = new Promise(function (resolve) {
        var link;
        link = document.querySelector(
          "link[href='" + theme.assets.stylesheet + "']",
        );
        if (link.loaded) {
          resolve();
        }
        return link.addEventListener("load", function () {
          return setTimeout(resolve, 0);
        });
      }));
    };

    CoreUtils.prototype.parseHtml = function (html_string, selector) {
      var container, parsed_element;
      container = document.createElement("div");
      container.innerHTML = html_string;
      if (!selector) {
        selector = ":scope > *";
      }
      parsed_element = el(selector, container);
      if (parsed_element.length) {
        return parsed_element;
      } else {
        return false;
      }
    };

    CoreUtils.prototype.getHiddenElHeight = function (element, fixed_width) {
      var cloned_el, el_height, el_padding, el_width;
      if (fixed_width == null) {
        fixed_width = true;
      }
      el_padding = element.css("padding");
      cloned_el = element.clone();
      cloned_el.css("visibility", "hidden");
      cloned_el.css("display", "block");
      cloned_el.css("position", "absolute");
      cloned_el.css("padding", el_padding);
      if (fixed_width) {
        el_width = element.width();
        cloned_el.css("width", el_width + "px");
      }
      theme.body.append(cloned_el);
      el_height = cloned_el.height();
      cloned_el.remove();
      return el_height;
    };

    CoreUtils.prototype.debounce = function (delay, fn) {
      var timeoutId;
      timeoutId = void 0;
      return function () {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(fn.bind(this), delay, arguments);
      };
    };

    CoreUtils.prototype.imagesLoaded = function (selector, callback) {
      var count, images_length;
      count = 0;
      images_length = selector.find('img[data-sizes="auto"]').length;
      if (images_length < 1) {
        callback();
        return;
      }
      return selector.on("lazybeforeunveil", function (event) {
        return el(event.target).on("load", function () {
          count++;
          if (count === images_length) {
            return callback();
          }
        });
      });
    };

    CoreUtils.prototype.loadJsClasses = function (container) {
      var _this;
      if (container == null) {
        container = theme.body;
      }
      _this = this;
      return container.find("[data-js-class]").each(function (js_element) {
        var js_class, js_el, partial_class;
        js_el = el(js_element);
        js_class = js_el.attr("data-js-class");
        if (!js_el.data("js-loaded")) {
          partial_class = theme.classes[js_class];
          if (typeof partial_class !== "undefined") {
            theme.partials[js_class] = new partial_class(js_el);
            return js_el.attr("data-js-loaded", "true");
          }
        }
      });
    };

    CoreUtils.prototype.matchImageHeights = function (
      container,
      items,
      image_class,
      items_to_ignore,
    ) {
      var _this,
        current_row,
        extra_ignore_blocks,
        greatest_image_height,
        ignore_item_rows,
        ignore_item_widths,
        image_roots,
        images,
        items_per_row,
        row_items;
      if (items_to_ignore == null) {
        items_to_ignore = false;
      }
      _this = this;
      if (!items.length) {
        return;
      }
      images = items
        .find(image_class + ", .placeholder--root")
        .css("height", "auto");
      image_roots = items.find(
        image_class + " .image--root, .placeholder--root",
      );
      items_per_row = Math.floor(container.width() / image_roots.width());
      if (isNaN(items_per_row)) {
        return;
      }
      if (items_to_ignore) {
        ignore_item_rows = [];
        ignore_item_widths = [];
        extra_ignore_blocks = 0;
        items_to_ignore.each(function (item) {
          var row, width;
          row =
            Math.floor(
              (extra_ignore_blocks + el(item).index()) / items_per_row,
            ) + 1;
          width = Math.floor(el(item).width() / image_roots.width());
          extra_ignore_blocks += width - 1;
          if (ignore_item_rows.includes(row)) {
            return (ignore_item_widths[ignore_item_rows.indexOf(row)] += width);
          } else {
            ignore_item_rows.push(row);
            return ignore_item_widths.push(width);
          }
        });
      }
      row_items = el();
      current_row = 1;
      greatest_image_height = 0;
      return items.each(function (item, index) {
        var end_of_row, item_el, number_items_to_skip, this_height;
        item_el = el(item);
        if (item_el.find(".image--root").length > 0) {
          this_height = item_el
            .find(image_class + " .image--root")
            .outerHeight();
        } else {
          this_height = item_el.find(".placeholder--root").outerHeight();
        }
        if (this_height > greatest_image_height) {
          greatest_image_height = this_height;
        }
        end_of_row = false;
        row_items = row_items.add(item_el);
        if (index + 1 === items.length) {
          end_of_row = true;
        } else if (items_to_ignore && ignore_item_rows.includes(current_row)) {
          number_items_to_skip =
            ignore_item_widths[ignore_item_rows.indexOf(current_row)];
          if (number_items_to_skip === items_per_row) {
            current_row++;
          } else {
            end_of_row =
              row_items.length + number_items_to_skip === items_per_row;
          }
          if (number_items_to_skip === 1 && items_per_row === 1) {
            end_of_row = true;
          }
        } else if (row_items.length === items_per_row) {
          end_of_row = true;
        }
        if (end_of_row) {
          row_items
            .find(image_class + ", .placeholder--root")
            .height(greatest_image_height);
          row_items = el();
          current_row++;
          return (greatest_image_height = 0);
        }
      });
    };

    CoreUtils.prototype.insertStylesheet = function (src) {
      var _this, stylesheet;
      _this = this;
      stylesheet = document.createElement("link");
      stylesheet.rel = "stylesheet";
      stylesheet.href = src;
      return document.head.appendChild(stylesheet);
    };

    CoreUtils.prototype.insertScript = function (src, callback) {
      var _this, script;
      _this = this;
      script = document.createElement("script");
      script.src = src;
      if (callback) {
        script.onload = callback;
      }
      return document.body.appendChild(script);
    };

    // Cart item count EXCLUDING fee line items (Route shipping protection).
    // Fee lines are suppressed from the rendered item list in
    // snippets/cart.liquid; this is the JS-side equivalent so the header badge
    // and the has-items flag agree with what the customer actually sees.
    // Titles come from theme.settings.fee_product_titles (snippets/js-variables
    // .liquid). Falls back to the raw count if that list is unavailable.
    CoreUtils.prototype.visibleCartItemCount = function (cart_data) {
      var count, fee_titles;
      count = parseInt(cart_data.item_count) || 0;
      fee_titles = (theme.settings && theme.settings.fee_product_titles) || [];
      if (!fee_titles.length || !Array.isArray(cart_data.items)) {
        return count;
      }
      cart_data.items.forEach(function (item) {
        if (fee_titles.indexOf(item.product_title) !== -1) {
          count -= item.quantity;
        }
      });
      return count < 0 ? 0 : count;
    };

    CoreUtils.prototype.formatMoney = function (raw_amount) {
      var _this, formatWithSeperators, formatted_amount, money_format, regex;
      _this = this;
      regex = /\{\{\s*(\w+)\s*\}\}/;
      money_format = theme.shop.money_format.match(regex)[1];
      formatWithSeperators = function (
        amount_in_cents,
        decimal_places,
        swap_seperators,
      ) {
        var amount_components,
          cents,
          cents_seperator,
          dollars,
          thousand_seperator;
        thousand_seperator = swap_seperators ? "." : ",";
        cents_seperator = swap_seperators ? "," : ".";
        amount_components = (amount_in_cents / 100)
          .toFixed(decimal_places)
          .split(".");
        cents = amount_components[1]
          ? cents_seperator + amount_components[1]
          : "";
        dollars = amount_components[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousand_seperator,
        );
        return dollars + cents;
      };
      switch (money_format) {
        case "amount":
          formatted_amount = formatWithSeperators(raw_amount, 2, false);
          break;
        case "amount_no_decimals":
          formatted_amount = formatWithSeperators(raw_amount, 0, false);
          break;
        case "amount_with_comma_separator":
          formatted_amount = formatWithSeperators(raw_amount, 2, true);
          break;
        case "amount_no_decimals_with_comma_separator":
          formatted_amount = formatWithSeperators(raw_amount, 0, true);
      }
      return theme.shop.money_format.replace(regex, formatted_amount);
    };

    CoreUtils.prototype.isTouchDevice = function () {
      var _this;
      _this = this;
      if (window.matchMedia("(pointer: coarse)").matches) {
        return true;
      } else {
        return false;
      }
    };

    return CoreUtils;
  })();

  theme.classes.CoreXMenu = (function () {
    function CoreXMenu(root) {
      var _this;
      this.root = root;
      this.transitionListeners = bind(this.transitionListeners, this);
      this.slideUp = bind(this.slideUp, this);
      this.slideDown = bind(this.slideDown, this);
      this.arrangeMegaNav = bind(this.arrangeMegaNav, this);
      this.resizeListeners = bind(this.resizeListeners, this);
      this.checkOverlap = bind(this.checkOverlap, this);
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.debugging = false;
      _this.current_width = window.innerWidth;
      _this.state = "closed";
      _this.parent_links = _this.root.find(".x-menu--level-1--link > a");
      _this.sub_menu_links = _this.root.find(
        '.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a',
      );
      _this.sub_menu_items = _this.sub_menu_links.parent().find("ul a");
      _this.parents_with_sub_menu = _this.sub_menu_links.parent();
      _this.overlap_parent = _this.root.data("x-menu--overlap-parent");
      _this.header_root = el(".header--root");
      _this.load();
    }

    CoreXMenu.prototype.load = function () {
      var _this;
      _this = this;
      _this.arrangeMegaNav();
      _this.listeners();
      _this.checkOverlap();
      _this.resizeListeners();
      return _this.transitionListeners();
    };

    CoreXMenu.prototype.listeners = function () {
      var _this, sub_menu;
      _this = this;
      _this.parents_with_sub_menu
        .find("> a")
        .on("mouseenter.XMenu", function () {
          return _this.slideDown(el(this));
        });
      _this.parents_with_sub_menu.on("mouseleave.XMenu", function () {
        return _this.slideUp();
      });
      _this.parent_links.on("focus", function () {
        return _this.slideUp();
      });
      _this.sub_menu_links.on("focus", function () {
        return _this.slideDown(el(this));
      });
      _this.sub_menu_links.on("touchstart.XMenu", function (event) {
        var link_el;
        event.preventDefault();
        link_el = el(this);
        if (link_el.parent().data("x-menu--open")) {
          return _this.slideUp();
        } else {
          return _this.slideDown(link_el);
        }
      });
      return (sub_menu = el(".x-menu--level-2--container"));
    };

    CoreXMenu.prototype.checkOverlap = function () {
      var _this,
        center_index,
        center_item,
        center_item_left_edge,
        center_item_right_edge,
        center_item_width,
        container,
        container_width,
        first_center_child,
        last_center_child,
        left_break_point,
        left_item,
        right_item,
        right_item_edge;
      _this = this;
      if (
        theme.utils.isTouchDevice() &&
        theme.utils.mqs.current_window !== "large"
      ) {
        _this.root.attr("data-x-menu--overlap", "true");
        _this.header_root.attr("data-x-menu--overlap", "true");
        theme.window.trigger("theme:x-menu:loaded");
        return false;
      }
      _this.root.attr("data-x-menu--overlap", "false");
      _this.header_root.attr("data-x-menu--overlap", "false");
      center_item = _this.root;
      if (_this.overlap_parent === 1) {
        center_item = center_item.parent();
      } else if (_this.overlap_parent === 2) {
        center_item = center_item.parent().parent();
      }
      container = center_item.parent();
      center_index = center_item.index();
      left_item = false;
      if (center_index > 1) {
        left_item = container.children().eq(center_index - 1);
      }
      right_item = false;
      if (center_index + 1 < container.children().length) {
        right_item = container.children().eq(center_index + 1);
      }
      container_width = container.width();
      center_item_width = _this.root.outerWidth();
      if (left_item) {
        first_center_child = center_item.find("> :first-child");
        center_item_left_edge = first_center_child.offset().left - 1;
        left_break_point = (container_width - center_item_width) / 2;
        if (left_edge >= center_item_left_edge) {
          _this.root.attr("data-x-menu--overlap", "true");
          _this.header_root.attr("data-x-menu--overlap", "true");
        }
      }
      if (right_item) {
        last_center_child = center_item.find("> :last-child");
        center_item_right_edge =
          last_center_child.outerWidth() + last_center_child.offset().left + 1;
        right_item_edge = right_item.offset().left;
        if (center_item_right_edge >= right_item_edge) {
          _this.root.attr("data-x-menu--overlap", "true");
          _this.header_root.attr("data-x-menu--overlap", "true");
        }
      }
      return theme.window.trigger("theme:x-menu:loaded");
    };

    CoreXMenu.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "resize.XMenu",
        theme.utils.debounce(100, function () {
          if (_this.current_width !== window.innerWidth) {
            _this.checkOverlap();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    CoreXMenu.prototype.arrangeMegaNav = function () {
      var _this, mega_navs;
      _this = this;
      if (_this.parents_with_sub_menu.length === 0) {
        return false;
      }
      mega_navs = _this.root.find(
        '[data-x-menu--depth="3"] .x-menu--level-2--container',
      );
      return mega_navs.each(function (nav) {
        var container, empty_list, single_parents, single_parents_container;
        container = el(nav);
        single_parents = container.find('[data-x-menu--single-parent="true"]');
        if (single_parents.length > 0) {
          single_parents_container = theme.utils.parseHtml(
            '<div class="x-menu--single-parents"></div>',
          );
          container.prepend(single_parents_container);
          empty_list = theme.utils.parseHtml("<ul>");
          return single_parents_container
            .append(empty_list)
            .find("ul")
            .append(single_parents);
        }
      });
    };

    CoreXMenu.prototype.slideDown = function (link, delay) {
      var _this, closest_link_parent, link_wrapper, sub_menu;
      if (delay == null) {
        delay = false;
      }
      _this = this;
      clearTimeout(_this.timer);
      link_wrapper = link.parent();
      if (link_wrapper.data("x-menu--open") || _this.state === "closing") {
        return false;
      }
      _this.slideUp(false);
      if (delay && delay !== "complete") {
        _this.timer = setTimeout(function () {
          return _this.slideDown(link, "complete");
        }, delay);
      } else {
        closest_link_parent = link.closest(".x-menu--level-1--link");
        closest_link_parent.find(".icon--chevron-up").css("display", "inline");
        closest_link_parent.find(".icon--chevron-down").hide();
        closest_link_parent.find(".icon--minus").show();
        closest_link_parent.find(".icon--plus").hide();
        link_wrapper.attr("data-x-menu--open", "true");
        link.attr("aria-expanded", "true");
        sub_menu = closest_link_parent.find(".x-menu--level-2--container");
        sub_menu.attr("data-transition", "forwards");
        sub_menu.css("height", "auto");
        _this.state = "open";
      }
    };

    CoreXMenu.prototype.slideUp = function (delay) {
      var _this, closest_link_parent, link, link_wrapper, sub_menu;
      if (delay == null) {
        delay = 300;
      }
      _this = this;
      if (_this.debugging) {
        return false;
      }
      link_wrapper = _this.parents_with_sub_menu.filter(
        '[data-x-menu--open="true"]',
      );
      link = link_wrapper.find("> a");
      if (!link_wrapper.data("x-menu--open")) {
        return false;
      }
      if (delay) {
        return (_this.timer = setTimeout(function () {
          return _this.slideUp(false);
        }, delay));
      } else {
        closest_link_parent = link.closest(".x-menu--level-1--link");
        closest_link_parent.find(".icon--chevron-up").hide();
        closest_link_parent
          .find(".icon--chevron-down")
          .css("display", "inline");
        closest_link_parent.find(".icon--minus").hide();
        closest_link_parent.find(".icon--plus").show();
        sub_menu = closest_link_parent.find(".x-menu--level-2--container");
        link_wrapper.attr("data-x-menu--open", "false");
        link.attr("aria-expanded", "false");
        return sub_menu.attr("data-transition", "backwards");
      }
    };

    CoreXMenu.prototype.transitionListeners = function () {
      var _this;
      _this = this;
      return _this.sub_menu_links.each(function (sub_links) {
        var menu, sub_menu_containers;
        menu = el(sub_links).parent();
        if (menu !== void 0) {
          sub_menu_containers = menu.find(".x-menu--level-2--container");
          return sub_menu_containers.on("transition:at_start", function () {
            return (this.style.height = "0");
          });
        }
      });
    };

    return CoreXMenu;
  })();

  theme.classes.CoreYMenu = (function () {
    function CoreYMenu(root) {
      var _this;
      this.root = root;
      this.slideRight = bind(this.slideRight, this);
      this.slideLeft = bind(this.slideLeft, this);
      this.adjustHeight = bind(this.adjustHeight, this);
      this.listeners = bind(this.listeners, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.state = "closed";
      _this.sub_menu_links = _this.root
        .find(".icon--chevron-right--small")
        .parent();
      _this.back_links = _this.root.find(".y-menu--back-link a");
      _this.regular_links = _this.root.find(
        '.y-menu--level-1--link > a:not([data-submenu="true"]), .y-menu--level-2--link > a:not([data-submenu="true"]), .y-menu--level-3--link > a:not([data-submenu="true"])',
      );
      _this.timer = null;
      _this.load();
    }

    CoreYMenu.prototype.load = function () {
      var _this;
      _this = this;
      return _this.listeners();
    };

    CoreYMenu.prototype.listeners = function () {
      var _this;
      _this = this;
      _this.regular_links.on("click", function () {
        var href;
        href = el(this).attr("href");
        if (href.indexOf("#") !== -1) {
          if (theme.partials.OffCanvas.state === "left--opened") {
            theme.partials.OffCanvas.closeLeft();
          } else if (theme.partials.OffCanvas.state === "right--opened") {
            theme.partials.OffCanvas.closeRight();
          }
          setTimeout(function () {
            return (window.location.href = href);
          }, 450);
        }
      });
      _this.sub_menu_links.on("click", function (event) {
        _this.slideLeft(el(this));
        event.preventDefault();
        return event.stopPropagation();
      });
      return _this.back_links.on("click", function (event) {
        _this.slideRight(el(this));
        event.preventDefault();
        return event.stopPropagation();
      });
    };

    CoreYMenu.prototype.adjustHeight = function (open_list) {
      var _this, current_height, open_list_height;
      _this = this;
      open_list_height = open_list.outerHeight();
      current_height = _this.root.outerHeight();
      _this.root.height(current_height);
      if (open_list.css("position") === "absolute") {
        open_list.css("position", "relative");
        open_list_height = open_list.outerHeight();
        open_list.css("position", "absolute");
      }
      return _this.root.height(open_list_height);
    };

    CoreYMenu.prototype.slideLeft = function (link) {
      var _this, sub_menu;
      _this = this;
      sub_menu = link.closest("li").find("ul").first();
      sub_menu.css("display", "block");
      _this.adjustHeight(sub_menu);
      return sub_menu.css("transform", "translateX(-100%)");
    };

    CoreYMenu.prototype.slideRight = function (link, close) {
      var _this, container, parent_container;
      _this = this;
      container = link.closest("ul");
      parent_container = container.parent().closest("ul");
      _this.adjustHeight(parent_container);
      return container.css("transform", "translateX(0)");
    };

    return CoreYMenu;
  })();

  theme.classes.Blog = (function (superClass) {
    extend(Blog, superClass);

    function Blog() {
      return Blog.__super__.constructor.apply(this, arguments);
    }

    return Blog;
  })(theme.classes.CoreBlog);

  theme.classes.Cart = (function (superClass) {
    extend(Cart, superClass);

    function Cart() {
      this.updateTotalsComplete = bind(this.updateTotalsComplete, this);
      return Cart.__super__.constructor.apply(this, arguments);
    }

    // GC-242: off when it ends, or the badge bumps again each time it is shown after being hidden (a phone turned
    // sideways crosses the header's two copies).
    document.addEventListener("animationend", function (event) {
      if (event.animationName === "cart-count-bump") {
        event.target.classList.remove("cart-count-bump");
      }
    });

    Cart.prototype.updateTotalsComplete = function (count) {
      // Every header badge: the header has a desktop and a mobile one, and
      // [data-item-count='0'] hides a badge, so updating only the first left
      // the phone's badge hidden after a first add.
      document
        .querySelectorAll(".header--cart-number")
        .forEach(function (badge) {
          // GC-278: a rise bumps the badge, so an add that keeps the drawer shut (a card, Order again) still shows.
          var before = parseInt(badge.dataset.itemCount, 10) || 0;
          badge.dataset.itemCount = count;
          // GC-242: only the copy on show: a hidden one would keep the class, and bump once it shows.
          if (count > before && badge.getClientRects().length) {
            badge.classList.remove("cart-count-bump");
            void badge.offsetWidth; // restart the animation on a quick second add
            badge.classList.add("cart-count-bump");
          }
        });
      // GC-197: the header cart links' names ("Cart, 3 items") follow the count.
      var label =
        count === 1
          ? theme.translations.cart_link.one
          : theme.translations.cart_link.other.replace(/\d+/, count);
      document.querySelectorAll("[data-cart-link]").forEach(
        /**
         * @param {HTMLAnchorElement} link - a header cart link
         * @returns {void}
         */
        function (link) {
          link.setAttribute("aria-label", label);
        },
      );
    };

    return Cart;
  })(theme.classes.CoreCart);

  theme.classes.Collection = (function (superClass) {
    extend(Collection, superClass);

    function Collection() {
      return Collection.__super__.constructor.apply(this, arguments);
    }

    return Collection;
  })(theme.classes.CoreCollection);

  theme.classes.Disclosure = (function (superClass) {
    extend(Disclosure, superClass);

    function Disclosure() {
      return Disclosure.__super__.constructor.apply(this, arguments);
    }

    return Disclosure;
  })(theme.classes.CoreDisclosure);

  theme.classes.FeaturedBlog = (function (superClass) {
    extend(FeaturedBlog, superClass);

    function FeaturedBlog() {
      return FeaturedBlog.__super__.constructor.apply(this, arguments);
    }

    return FeaturedBlog;
  })(theme.classes.CoreFeaturedBlog);

  theme.classes.FeaturedCollection = (function (superClass) {
    extend(FeaturedCollection, superClass);

    function FeaturedCollection() {
      return FeaturedCollection.__super__.constructor.apply(this, arguments);
    }

    return FeaturedCollection;
  })(theme.classes.CoreFeaturedCollection);

  theme.classes.FeaturedVideo = (function (superClass) {
    extend(FeaturedVideo, superClass);

    function FeaturedVideo() {
      return FeaturedVideo.__super__.constructor.apply(this, arguments);
    }

    return FeaturedVideo;
  })(theme.classes.CoreFeaturedVideo);

  theme.classes.Footer = (function (superClass) {
    extend(Footer, superClass);

    function Footer() {
      return Footer.__super__.constructor.apply(this, arguments);
    }

    return Footer;
  })(theme.classes.CoreFooter);

  theme.classes.Header = (function () {
    function Header(root) {
      var _this;
      this.root = root;
      this.moveYMenu = bind(this.moveYMenu, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.mobile_nav_menu = el(".mobile-nav--menu");
      _this.y_menu = _this.root.find(".y-menu");
      _this.load();
    }

    Header.prototype.load = function () {
      var _this;
      _this = this;
      _this.moveYMenu();
      if (el(".modal.window").css("display") === "block") {
        el(".modal.window .close").trigger("click");
      }
      return _this.root.on("theme:section:load", function () {
        theme.partials.OffCanvas.unload();
        return theme.partials.OffCanvas.load();
      });
    };

    Header.prototype.moveYMenu = function () {
      var _this;
      _this = this;
      _this.mobile_nav_menu.empty();
      if (_this.mobile_nav_menu.length && _this.y_menu.length) {
        return _this.mobile_nav_menu.append(_this.y_menu);
      }
    };

    return Header;
  })();

  theme.classes.ListCollections = (function () {
    function ListCollections(root) {
      var _this;
      this.root = root;
      this.resizeListeners = bind(this.resizeListeners, this);
      this.matchImageHeights = bind(this.matchImageHeights, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.current_width = window.innerWidth;
      _this.item_container = _this.root.find(".collection-list--grid");
      _this.items = _this.root.find(".collection-list--item");
      _this.load();
    }

    ListCollections.prototype.load = function () {
      var _this;
      _this = this;
      _this.matchImageHeights();
      return _this.resizeListeners();
    };

    ListCollections.prototype.matchImageHeights = function () {
      var _this;
      _this = this;
      if (theme.utils.mqs.current_window !== "small") {
        return theme.utils.matchImageHeights(
          _this.item_container,
          _this.items,
          ".collection-list--image",
        );
      }
    };

    ListCollections.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return window.addEventListener(
        "resize",
        theme.utils.debounce(100, function () {
          _this.items
            .find(".collection-list--image, .placeholder--root")
            .css("height", "100%");
          if (_this.current_width !== window.innerWidth) {
            _this.matchImageHeights();
            return (_this.current_width = window.innerWidth);
          }
        }),
      );
    };

    return ListCollections;
  })();

  theme.classes.Map = (function (superClass) {
    extend(Map, superClass);

    function Map() {
      return Map.__super__.constructor.apply(this, arguments);
    }

    return Map;
  })(theme.classes.CoreMap);

  theme.classes.OffCanvas = (function (superClass) {
    extend(OffCanvas, superClass);

    function OffCanvas() {
      return OffCanvas.__super__.constructor.apply(this, arguments);
    }

    return OffCanvas;
  })(theme.classes.CoreOffCanvas);

  theme.classes.Popup = (function () {
    function Popup(root) {
      var _this;
      this.root = root;
      _this = this;
      _this.container = _this.root.find(".popup--container");
      _this.open_link = el(".popup--open");
      _this.close_link = _this.root.find(".popup--close");
      _this.show_again_after = _this.root.data("show-again-after");
      _this.mode = _this.root.data("mode");
      _this.newsletter_form = _this.root.find("#contact_form");
      _this.eventListeners();
      _this.autoPopup();
    }

    Popup.prototype.eventListeners = function () {
      var _this;
      _this = this;
      _this.open_link.on("keypress.Popup, click.Popup", function () {
        if (theme.body.data("popup-open")) {
          _this.close();
        } else {
          _this.open();
        }
        return false;
      });
      _this.close_link.on("keypress.Popup, click.Popup", function () {
        _this.close();
        return false;
      });
      return _this.newsletter_form.on("submit", function (event) {
        var form, list_blank_el, list_success_el;
        form = el(this);
        form.find(".error, .success").remove();
        event.preventDefault();
        if (form.find('input[type="email"]').val().length === 0) {
          list_blank_el = theme.utils.parseHtml(
            "<p class='error'>" +
              theme.translations.mailing_list_email_blank +
              "</p>",
          );
          form.prepend(list_blank_el);
          return false;
        } else {
          form.find('input[type="email"], input[type="submit"]').hide();
          list_success_el = theme.utils.parseUtil(
            "<p class='success'>" +
              theme.translations.mailing_list_success_message +
              "</p>",
          );
          form.prepend(list_success_el).show();
          setTimeout(function () {
            return form.submit();
          }, 500);
        }
        return false;
      });
    };

    Popup.prototype.open = function (source) {
      var _this;
      _this = this;
      _this.container.attr("aria-hidden", false);
      _this.container.attr("data-transition", "forwards");
      theme.body.attr("data-popup-open", true);
      return theme.body.css(
        "padding-bottom",
        _this.container.outerHeight() + "px",
      );
    };

    Popup.prototype.delayUntilValidScrollPosition = function () {
      var _this;
      _this = this;
      return theme.window.on(
        "DOMMouseScroll.Popup mousewheel.Popup touchmove.Popup scroll.Popup touchmove.Popup",
        function () {
          var header_offset, scroll_top;
          header_offset = el(".header").offset().top;
          scroll_top = window.pageYOffset;
          if (scroll_top > header_offset) {
            _this.open();
            return theme.window.off(
              "DOMMouseScroll.Popup mousewheel.Popup touchmove.Popup scroll.Popup touchmove.Popup",
            );
          }
        },
      );
    };

    Popup.prototype.close = function () {
      var _this;
      _this = this;
      theme.body.css("padding-bottom", 0);
      theme.body.attr("data-popup-open", false);
      _this.container.attr("data-transition", "backwards");
      return _this.container.attr("aria-hidden", true);
    };

    Popup.prototype.autoPopup = function () {
      var _this;
      _this = this;
      if (_this.mode === "manual") {
        return;
      }
      if (!localStorage || _this.mode === "test") {
        return setTimeout(function () {
          return _this.open("auto");
        }, 1000);
      } else if (localStorage[theme.local_storage.popup] === void 0) {
        _this.setResetTime();
        return setTimeout(function () {
          return _this.open("auto");
        }, 1000);
      } else if (_this.readyToReset()) {
        _this.setResetTime();
        return setTimeout(function () {
          return _this.open("auto");
        }, 1000);
      }
    };

    Popup.prototype.readyToReset = function () {
      var _this, expires, now;
      _this = this;
      expires = JSON.parse(
        localStorage[theme.local_storage.popup],
      ).popup_expires;
      now = new Date().getTime();
      if (parseFloat(expires - now) <= 0) {
        _this.setResetTime();
        return true;
      }
      return false;
    };

    Popup.prototype.setResetTime = function () {
      var _this, date, expires, object, seconds_from_now;
      _this = this;
      date = new Date();
      seconds_from_now = 1000 * 60 * 60 * 24 * _this.show_again_after;
      expires = date.setTime(date.getTime() + seconds_from_now);
      object = {
        popup_expires: expires,
      };
      localStorage[theme.local_storage.popup] = JSON.stringify(object);
      return _this;
    };

    return Popup;
  })();

  theme.classes.ProductModel = (function (superClass) {
    extend(ProductModel, superClass);

    function ProductModel() {
      return ProductModel.__super__.constructor.apply(this, arguments);
    }

    return ProductModel;
  })(theme.classes.CoreProductModel);

  theme.classes.ProductRecommendations = (function (superClass) {
    extend(ProductRecommendations, superClass);

    function ProductRecommendations() {
      return ProductRecommendations.__super__.constructor.apply(
        this,
        arguments,
      );
    }

    return ProductRecommendations;
  })(theme.classes.CoreProductRecommendations);

  theme.classes.ProductVideo = (function (superClass) {
    extend(ProductVideo, superClass);

    function ProductVideo() {
      return ProductVideo.__super__.constructor.apply(this, arguments);
    }

    return ProductVideo;
  })(theme.classes.CoreProductVideo);

  theme.classes.Product = (function (superClass) {
    extend(Product, superClass);

    function Product(root) {
      var _this;
      this.root = root;
      this.copyLink = bind(this.copyLink, this);
      this.pauseOtherMedia = bind(this.pauseOtherMedia, this);
      this.reorderModalImages = bind(this.reorderModalImages, this);
      this.updateVariantMedia = bind(this.updateVariantMedia, this);
      this.swapMedia = bind(this.swapMedia, this);
      this.resizeListeners = bind(this.resizeListeners, this);
      this.balanceColumns = bind(this.balanceColumns, this);
      this.indexContentBlocks = bind(this.indexContentBlocks, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.social_root = el(".product-page--social");
      _this.copy_link = _this.social_root.find(".social-share--item-copy");
      _this.copy_text_wrapper = _this.social_root.find(
        ".social-share--item-copy--wrapper",
      );
      if (_this.is_product_page && _this.copy_text_wrapper.length) {
        _this.copy_text = _this.copy_text_wrapper.text().trim();
      }
      Product.__super__.constructor.apply(this, arguments);
    }

    Product.prototype.load = function () {
      var _this;
      _this = this;

      if (!_this.product_json) {
        return;
      }

      Product.__super__.load.apply(this, arguments);
      if (_this.is_product_page) {
        _this.pauseOtherMedia();
        _this.indexContentBlocks();
        _this.balanceColumns();
        _this.resizeListeners();
        _this.reorderModalImages();
        return _this.copyLink();
      }
    };

    Product.prototype.indexContentBlocks = function () {
      var _this, content_blocks;
      _this = this;
      content_blocks = _this.root.find(
        ".product-page--description, .product-page--media-variant",
      );
      return content_blocks.each(function (block, index) {
        return block.setAttribute("data-block-index", index);
      });
    };

    Product.prototype.balanceColumns = function () {
      var _this,
        content_blocks,
        image_count,
        left_side,
        right_side,
        single_column;
      _this = this;
      single_column = _this.root.find(".product-page--single-column");
      content_blocks = _this.root.find(
        ".product-page--description, .product-page--media-variant",
      );
      left_side = _this.root.find(".product-page--column-left");
      right_side = _this.root.find(".product-page--column-right");
      image_count = _this.root.find(".product-page--media-variant").length;
      if (
        content_blocks.find("iframe").length &&
        theme.utils.mqs.current_window !== "small" &&
        left_side.children().length
      ) {
        return false;
      }
      content_blocks.el = Array.from(content_blocks.el);
      content_blocks.el.sort(function (first_el, second_el) {
        return (
          +first_el.getAttribute("data-block-index") -
          +second_el.getAttribute("data-block-index")
        );
      });
      single_column.append(content_blocks);
      single_column.show();
      left_side.hide();
      right_side.hide();
      if (image_count > 0 && theme.utils.mqs.current_window !== "small") {
        content_blocks.each(function (block, index) {
          var block_el, left_height, right_height;
          block_el = el(block);
          left_height = theme.utils.getHiddenElHeight(left_side, false);
          right_height = theme.utils.getHiddenElHeight(right_side, false);
          if (left_height <= right_height) {
            return left_side.append(block_el);
          } else {
            return right_side.append(block_el);
          }
        });
        single_column.hide();
        left_side.show();
        return right_side.show();
      }
    };

    Product.prototype.resizeListeners = function () {
      var _this;
      _this = this;
      return theme.window.on("resize.TemplateProduct", function () {
        return _this.balanceColumns();
      });
    };

    Product.prototype.swapMedia = function (media_1, media_2) {
      var _this, media_1_clone, media_2_clone;
      _this = this;
      media_1_clone = media_1.clone();
      media_2_clone = media_2.clone();
      media_1.replaceWith(media_2_clone);
      return media_2.replaceWith(media_1_clone);
    };

    Product.prototype.updateVariantMedia = function (variant_media_id) {
      var _this,
        featured_media,
        modal_images,
        new_featured_media,
        new_first_modal_image,
        other_media;
      _this = this;
      if (!_this.is_product_page) {
        Product.__super__.updateVariantMedia.apply(this, arguments);
        return;
      }
      featured_media = _this.root.find(
        ".product-page--featured-media .product-media--featured",
      );
      other_media = _this.root.find(".product-media--featured");
      modal_images = _this.root.find(".product-page--modal-image");
      if (variant_media_id && variant_media_id !== featured_media.data("id")) {
        new_featured_media = other_media.filter(
          "[data-id='" + variant_media_id + "']",
        );
        new_first_modal_image = modal_images.filter(
          "[data-id='" + variant_media_id + "']",
        );
        _this.swapMedia(featured_media, new_featured_media);
        _this.swapMedia(modal_images.first(), new_first_modal_image);
        _this.balanceColumns();
        _this.reorderModalImages();
      }
    };

    Product.prototype.reorderModalImages = function () {
      var _this, modal_images, modal_wrapper, product_images;
      _this = this;
      modal_images = _this.root.find(".product-page--modal-image");
      modal_wrapper = _this.root.find(".product-page--modal-wrapper");
      product_images = _this.root.find(
        '.product-media--featured[data-media-type="image"]',
      );
      return product_images.each(function (image) {
        var modal_content, product_id;
        product_id = el(image).attr("data-id");
        modal_content = modal_images
          .filter("[data-id='" + product_id + "']")
          .closest(".modal--content");
        return modal_wrapper.append(modal_content);
      });
    };

    Product.prototype.pauseOtherMedia = function () {
      var _this;
      _this = this;
      return _this.root
        .find(".product-media--featured > *")
        .on("click", function () {
          return _this.root
            .find(".product-media--featured > *")
            .not(el(this))
            .trigger("pause-media");
        });
    };

    Product.prototype.copyLink = function () {
      var _this;
      _this = this;
      _this.copy_link.on("click keydown", function (event) {
        if (event.type === "keydown" && event.key !== "Enter") {
          return;
        }
        navigator.clipboard.writeText(window.location.href);
        _this.copy_text_wrapper.css("opacity", 0);
        return _this.copy_text_wrapper.attr("data-transition", "forwards");
      });
      _this.copy_text_wrapper.on("transition:at_end", function () {
        _this.copy_text_wrapper.text(theme.translations.url_copied);
        _this.copy_text_wrapper.css("opacity", 1);
        return setTimeout(function () {
          _this.copy_text_wrapper.css("opacity", 0);
          return _this.copy_text_wrapper.attr("data-transition", "backwards");
        }, 3000);
      });
      return _this.copy_text_wrapper.on("transition:at_start", function () {
        _this.copy_text_wrapper.text(_this.copy_text);
        return _this.copy_text_wrapper.css("opacity", 1);
      });
    };

    return Product;
  })(theme.classes.CoreProduct);

  theme.classes.Radios = (function (superClass) {
    extend(Radios, superClass);

    function Radios() {
      return Radios.__super__.constructor.apply(this, arguments);
    }

    return Radios;
  })(theme.classes.CoreRadios);

  theme.classes.RecentProducts = (function (superClass) {
    extend(RecentProducts, superClass);

    function RecentProducts() {
      return RecentProducts.__super__.constructor.apply(this, arguments);
    }

    return RecentProducts;
  })(theme.classes.CoreRecentProducts);

  theme.classes.Sections = (function (superClass) {
    extend(Sections, superClass);

    function Sections() {
      return Sections.__super__.constructor.apply(this, arguments);
    }

    return Sections;
  })(theme.classes.CoreSections);

  theme.classes.ServiceList = (function (superClass) {
    extend(ServiceList, superClass);

    function ServiceList() {
      return ServiceList.__super__.constructor.apply(this, arguments);
    }

    return ServiceList;
  })(theme.classes.CoreServiceList);

  theme.classes.XMenu = (function (superClass) {
    extend(XMenu, superClass);

    function XMenu(root) {
      var _this;
      this.root = root;
      this.checkOverlap = bind(this.checkOverlap, this);
      this.alignSubmenus = bind(this.alignSubmenus, this);
      this.load = bind(this.load, this);
      _this = this;
      _this.cart_count = el(".header--cart-count");
      _this.hide_when_overlapping = document.querySelectorAll(
        ".header--root .popup--open, .header--root .cart-link, .header--root .header--search",
      );
      XMenu.__super__.constructor.apply(this, arguments);
    }

    XMenu.prototype.load = function () {
      var _this;
      _this = this;
      XMenu.__super__.load.apply(this, arguments);
      return _this.alignSubmenus();
    };

    XMenu.prototype.alignSubmenus = function () {
      var _this, logo_offset, sub_menus;
      _this = this;
      logo_offset = document.querySelector(
        ".header--root .logo--root",
      ).offsetWidth;
      sub_menus = _this.root.find(
        '[data-x-menu--depth="3"] .x-menu--level-2--container',
      );
      return sub_menus.each(function (sub_menu) {
        sub_menu.style.left = logo_offset + "px";
        return (sub_menu.style.width = "calc(100% - " + logo_offset + "px)");
      });
    };

    XMenu.prototype.checkOverlap = function () {
      var _this, header;
      _this = this;
      header = document.querySelector(".header--root");
      _this.cart_count.attr("data-menu-overlap", "false");
      header.setAttribute("data-menu-overlap", "false");
      _this.hide_when_overlapping.forEach(function (el) {
        return el.removeAttribute("style");
      });
      XMenu.__super__.checkOverlap.apply(this, arguments);
      if (_this.root.data("x-menu--overlap")) {
        header.setAttribute("data-menu-overlap", "true");
        _this.hide_when_overlapping.forEach(function (el) {
          return (el.style.display = "none");
        });
        if (
          parseInt(
            _this.cart_count.find(".cart--external--total-items").text(),
          ) > 0
        ) {
          return _this.cart_count.attr("data-menu-overlap", "true");
        }
      }
    };

    return XMenu;
  })(theme.classes.CoreXMenu);

  el = function (selector, container) {
    if (container == null) {
      container = document;
    }
    return new theme.classes.CoreDomObject(selector, container);
  };

  new (Main = (function () {
    function Main() {
      this.loadSwipeLibrary = bind(this.loadSwipeLibrary, this);
      this.configureLinks = bind(this.configureLinks, this);
      this.load = bind(this.load, this);
      var _this;
      _this = this;
      theme.body = el("body");
      theme.window = el(window);
      _this.load();
    }

    Main.prototype.load = function () {
      var _this;
      _this = this;
      theme.sections = new theme.classes.Sections();
      theme.utils = new theme.classes.CoreUtils();
      theme.utils.stylesheetLoaded().then(function () {
        theme.utils.loadJsClasses();
        return theme.body.attr("data-assets-loaded", "true");
      });
      _this.configureLinks();
      _this.loadSwipeLibrary();
      return theme.classes.Cart.getItems();
    };

    Main.prototype.configureLinks = function () {
      return document
        .querySelectorAll('[data-item="hidden-text"] a')
        .forEach(function (link) {
          return link.setAttribute("tabindex", "-1");
        });
    };

    Main.prototype.loadSwipeLibrary = function () {
      return theme.utils.insertScript(theme.assets.swipe, function () {
        return theme.utils.swipe();
      });
    };

    return Main;
  })())();
}).call(this);
